export const messages = {
  uz: {
    app: {
      name: "InterAgro ERP",
      descriptor: "Interagro Hatchery",
      search: "Qidirish...",
      openMenu: "Menyuni ochish",
      // A picture of the screen without the sidebar, to send on.
      screenshot: {
        idle: "Skrinshot",
        hint: "Ekran rasmi nusxalanadi — Telegramga qo'yib yuboring",
        busy: "Tayyorlanmoqda",
        copied: "Nusxalandi",
        downloaded: "Yuklab olindi",
        failed: "Rasm olinmadi",
      },
      collapseMenu: "Menyuni ixchamlash",
      expandMenu: "Menyuni kengaytirish",
      navigationLabel: "Asosiy navigatsiya",
      darkTheme: "Tungi mavzu",
      lightTheme: "Kunduzgi mavzu",
      logout: "Chiqish",
      logoutDescription: "Akkauntingizdan chiqasiz. Davom etasizmi?",
      logoutTitle: "Tizimdan chiqish",
      notifications: "Bildirishnomalar",
      help: "Yordam",
      roleInspector: "Inspektor",
      roleAdmin: "Administrator",
      roleSuperAdmin: "Super administrator",
      roleSalesManager: "Sotuv menejeri",
    },
    nav: {
      dashboard: "Dashboard",
      salesDashboard: "Dashboard",
      orders: "Buyurtmalar",
      hatchCalendar: "Chiqish kalendari",
      customers: "Mijozlar",
      payments: "Tushumlar",
      debtors: "Qarzdorlar",
      creditors: "Haqdorlar",
      reminders: "Eslatmalar",
      expenses: "Xarajatlar",
      eggBatches: "Partiyalar",
      plannedBatches: "Partiyalar",
      pricing: "Narxlar",
      competitors: "Raqobatchilar",
      receiving: "Qabul",
      sorting: "Saralash",
      incubations: "Inkubatsiya",
      settingFlow: "Inkubatsiya",
      hatchingFlow: "Chiqarish",
      branchOrders: "Buyurtmalar",
      settings: "Sozlamalar",
      branches: "Filiallar",
      suppliers: "Yetkazib beruvchilar",
      incubationMachines: "Inkubator mashinalari",
      eggStandards: "Tuxum standartlari",
      vaccines: "Vaksinalar",
      users: "Foydalanuvchilar",
      roles: "Rollar",
      sections: {
        sales: "Sotuv",
        incubation: "Inkubatsiya",
        finance: "Moliya",
        settings: "Sozlamalar",
        administration: "Boshqaruv",
      },
    },
    branchOrders: {
      searchPlaceholder: "Mijoz, telefon yoki partiya bo'yicha qidiring",
      scopeLabel: "Buyurtmalar",
      scope: { active: "Topshiriladi", history: "Tarix" },
      dueTitle: "Bugun topshiriladi",
      today: "Bugun",
      late: "{count} kun kechikdi",
      totalChicks: "Jami {count} ta jo'ja",
      columns: {
        customer: "Mijoz",
        chicks: "Jo'jalar",
        vaccines: "Vaksinalar",
        handover: "Topshirish",
        payment: "To'lov",
        status: "Holat",
      },
      handoverKind: { pickup: "Mijoz olib ketadi", delivery: "Yetkazib beriladi" },
      noVaccines: "Vaksinasiz",
      handOver: "Topshirildi",
      handOverTitle: "Buyurtmani topshirish",
      handOverMessage:
        "{customer} {count} ta jo'jani oldimi? Buyurtma yakunlanadi, mijozga Telegram orqali xabar boradi va buni ortga qaytarib bo'lmaydi.",
      emptyTitle: "Topshiriladigan buyurtma yo'q",
      emptyDescription: "Sotuv bo'limi bu filialning partiyalariga buyurtma olganda ular shu yerda chiqish kuni bo'yicha paydo bo'ladi.",
      emptyHistoryTitle: "Tarix bo'sh",
      emptyHistoryDescription: "Topshirilgan va bekor qilingan buyurtmalar shu yerda saqlanadi.",
      emptyFilteredTitle: "Buyurtma topilmadi",
      emptyFiltered: "Qidiruvni o'zgartirib ko'ring.",
    },
    sorting: {
      title: "Tuxum saralash",
      subtitle:
        "Qabul qilingan partiyalarni inkubatsiyaga joylashdan oldin saralang.",
      refresh: "Yangilash",
      acceptedBatches: "Qabul qilingan partiyalar",
      acceptedTitle: "Saralanadigan partiyalar",
      unsortedEggs: "Saralanmagan tuxum",
      sortedUnsetted: "Joylanmagan saralangan",
      sortedUnsettedTitle: "Inkubatsiyaga tayyor partiyalar",
      batch: "Partiya",
      category: "Kategoriya",
      selectBatch: "Partiyani tanlang",
      selectBatchFirst: "Avval partiyani tanlang",
      selectCategory: "Kategoriyani tanlang",
      noUnsortedCategories: "Bu partiyada saralanmagan kategoriya yo'q",
      noAcceptedBatches: "Saralanadigan partiya yo‘q",
      noSortedUnsetted: "Inkubatsiyaga tayyor partiya yo‘q",
      tableTitle: "Saralanganlar",
      noTableRows: "Hali saralash qo‘shilmadi",
      eggStandardId: "Standart #{id}",
      netEggs: "Qoldiq",
      add: "Qo'shish",
      edit: "Tahrirlash",
      update: "Yangilash",
      saveSorting: "Saralashni saqlash",
      lossCannotExceedEggs: "Yo‘qotish tuxum sonidan oshmasligi kerak",
    },
    regions: {
      ANDIJON: "Andijon",
      BUXORO: "Buxoro",
      FARGONA: "Farg'ona",
      JIZZAX: "Jizzax",
      QASHQADARYO: "Qashqadaryo",
      NAMANGAN: "Namangan",
      NAVOIY: "Navoiy",
      SAMARQAND: "Samarqand",
      SIRDARYO: "Sirdaryo",
      SURXONDARYO: "Surxondaryo",
      TOSHKENT_VILOYATI: "Toshkent viloyati",
      XORAZM: "Xorazm",
      TOSHKENT_SHAHRI: "Toshkent shahri",
      QORAQALPOGISTON: "Qoraqalpog'iston",
    },
    salesDashboard: {
      title: "Dashboard",
      emptyHint: "Boshqa davrni tanlab ko'ring.",
      kpi: {
        orders: "Buyurtmalar",
        chicks: "Sotilgan jo'jalar",
        chicksBonus: "+{count} bonus",
        received: "Tushum",
        outstanding: "Kutilayotgan to'lov",
        debt: "Qarz",
        compensation: "Zararni qoplab berish",
      },
      orders: {
        title: "Buyurtmalar holati",
        columns: {
          status: "Holat",
          orders: "Buyurtma",
          chicks: "Jo'ja",
          collected: "To'langan",
        },
        categoryTitle: "Vazn bo'yicha",
        empty: "Bu davrda buyurtma yo'q.",
      },
      payments: {
        title: "To'lov usullari",
        received: "Kassaga tushdi",
        fromWallet: "Hamyondan yopildi",
        refunded: "Qaytarilgan",
        transactions: "amaliyot",
        transactionsBadge: "{count} amaliyot",
        columns: {
          method: "Usul",
          amount: "Summa",
          share: "Ulush",
          transactions: "Amaliyot",
        },
        empty: "Bu davrda to'lov qabul qilinmagan.",
      },
      customers: {
        title: "Eng yaxshi mijozlar",
        columns: {
          customer: "Mijoz",
          type: "Tur",
          region: "Viloyat",
          orders: "Buyurtma",
          chicks: "Jo'ja",
          collected: "To'langan",
          balance: "Balans",
        },
        empty: "Bu davrda buyurtma bergan mijoz yo'q.",
      },
      regions: {
        title: "Viloyatlar",
        columns: {
          region: "Viloyat",
          registered: "Ro'yxatda",
          orders: "Buyurtma",
          chicks: "Jo'ja",
          collected: "To'langan",
        },
        empty: "Viloyat ma'lumoti yo'q.",
      },
      managers: {
        title: "Menejerlar",
        columns: {
          manager: "Menejer",
          orders: "Buyurtma",
          booked: "Buyurtma summasi",
          collected: "To'langan",
        },
        unattributed: "Biriktirilmagan",
        unattributedHint: "Menejer qayd etilishidan oldin yaratilgan buyurtmalar.",
        empty: "Bu davrda buyurtma yaratilmagan.",
      },
    },
    pricing: {
      subtitle: "Raqobatchilar narxi va bizning haftalik kesimlarimiz",
      newSurvey: "Yangi narx kesimi",
      unit: "1 dona jo'ja, so'm",
      weekday: {
        0: "yakshanba",
        1: "dushanba",
        2: "seshanba",
        3: "chorshanba",
        4: "payshanba",
        5: "juma",
        6: "shanba",
      },
      current: {
        title: "Hozirgi narx",
        inForce: "Kuchda",
        meta: "{date} · {name} belgiladi",
        metaNoName: "{date}",
      },
      market: {
        title: "Raqobatchilar narxi",
        watchList: "Raqobatchilar ro'yxati",
      },
      chart: {
        title: "Narx dinamikasi",
        subtitle: "Bizning narx, kesimlar bo'yicha · so'm",
      },
      table: {
        title: "Narx kesimlari",
        history: "Narxlar tarixi",
        subtitle: "Har bir kesim — o'sha kundagi bozor va biz belgilagan narx",
        count: "{count} ta kesim",
        date: "Sana",
      },
      diff: {
        below: "o'rtachadan past",
        above: "o'rtachadan yuqori",
        equal: "o'rtacha bilan teng",
        noData: "ma'lumot yo'q",
      },
      movement: {
        period: "Davr",
        allTime: "Butun tarix",
        emptyRange: "Bu oraliqda kesim yo'q",
      },
      history: {
        title: "Raqobatchi narxi",
        neverQuotedClass: "Bu sinf bo'yicha narx aytilmagan",
        chartTitle: "Narx dinamikasi",
        tableTitle: "Kesim bo'yicha narxlar",
      },
      empty: {
        title: "Hali narx kesimi yo'q",
        description:
          "Raqobatchilarni aylanib chiqqach, birinchi kesimni kiriting — bozor va bizning narx bir sanada saqlanadi.",
        action: "Birinchi kesimni kiritish",
      },
      detail: {
        title: "Narx kesimi",
        quotedMeta: "{count} ta raqobatchi aylanib chiqildi",
        createdBy: "kiritdi: {name}",
        edit: "Tahrirlash",
        quotesTitle: "Kim qanday narx aytdi",
        quotesSubtitle: "Har bir katak — o'sha kuni telefonda aytilgan narx",
        noQuotes: "Bu kesimda raqobatchi narxi kiritilmagan.",
        market: "Bozor",
        lowest: "eng past",
        average: "o'rtacha",
        highest: "eng yuqori",
        quotedCount: "{count} ta raqobatchi",
        quotedCountFull: "Bu sinf bo'yicha {count} ta raqobatchi narx aytdi",
        notQuoted: "—",
        marketAverage: "Bozor o'rtachasi",
        marketLowest: "Eng past narx",
        marketHighest: "Eng yuqori narx",
        noMarketData: "Bu sinf bo'yicha hech kim narx aytmagan — solishtirish uchun bozor ma'lumoti yo'q.",
        ourPrice: "Bizning narx",
        ourPriceSet: "Shu kesimda biz belgilagan narx va uning bozorga nisbatan o'rni",
        note: "Izoh",
      },
      form: {
        newTitle: "Yangi narx kesimi",
        editTitle: "Kesimni tahrirlash",
        subtitle: "Raqobatchilar narxini kiriting, so'ng bizning narxni belgilang",
        date: "Sana",
        note: "Izoh",
        optional: "— ixtiyoriy",
        notePlaceholder: "Masalan: bozorda tuxum narxi ko'tarildi",
        quotesTitle: "Raqobatchilar narxi",
        quotesSubtitle: "Bo'sh katak — o'sha kuni narx aytmagan degani",
        removeRow: "Qatorni olib tashlash",
        readdPlaceholder: "Qatorni qaytarish...",
        statsHint: "eng past · o'rtacha · eng yuqori",
        emptyRows: "Raqobatchilar ro'yxati bo'sh",
        emptyRowsHint: "Raqobatchilar ekranida kimni kuzatishni qo'shsangiz, narxi shu jadvalda so'raladi.",
        ourTitle: "Bizning narx",
        ourSubtitle: "Shu haftada kuchga kiradi · uchta katak ham majburiy",
        decision: "Qaror",
        priceMissing: "narx kiritilmagan",
        noCompare: "solishtirish uchun ma'lumot yo'q",
        belowAvg: "o'rtachadan {amount} so'm past",
        aboveAvg: "o'rtachadan {amount} so'm yuqori",
        equalAvg: "o'rtacha bilan teng",
        ready: "Saqlashga tayyor",
        incomplete: "Bizning narx to'liq emas — {list} kiritilmagan",
      },
      competitors: {
        subtitle: "Har kesimda aylanib chiqiladigan inkubatorlar",
        add: "Raqobatchi qo'shish",
        listTitle: "Kuzatuvdagi ro'yxat",
        name: "Raqobatchi",
        phones: "Telefon",
        note: "Izoh",
        lastPrice: "Oxirgi narx",
        actions: "Amal",
        noNote: "— izoh yo'q",
        hide: "Yashirish",
        edit: "Tahrirlash",
        hint: "Raqobatchini yashirsangiz, u yangi kesimlarda so'ralmaydi. Oldingi kesimlarda nomi va narxi o'z joyida qoladi.",
        hideTitle: "{name} ro'yxatdan yashirilsinmi?",
        hideMessage:
          "Keyingi kesimlarda uning narxi so'ralmaydi. Oldingi kesimlarda nomi va aytgan narxi o'z joyida qoladi — hisobot buzilmaydi.",
        empty: {
          title: "Kuzatuvdagi raqobatchi yo'q",
          description:
            "Qaysi inkubatorlarni aylanib chiqasiz — shu ro'yxatga qo'shing. Keyin har kesimda ularning narxi so'raladi.",
          action: "Birinchi raqobatchini qo'shish",
        },
        modal: {
          newTitle: "Yangi raqobatchi",
          editTitle: "Raqobatchini tahrirlash",
          name: "Nomi",
          namePlaceholder: "Masalan: Piskent Parranda",
          phones: "Telefon raqamlar",
          phonePlaceholder: "+998 90 123 45 67",
          addPhone: "Yana raqam qo'shish",
          removePhone: "Raqamni olib tashlash",
          phoneInvalid: "Telefon raqamini to'liq kiriting",
          note: "Izoh",
          notePlaceholder: "Kim bilan gaplashiladi, qanday narx beradi...",
          nameRequired: "Nomi kiritilishi shart",
        },
      },
    },
    plannedBatches: {
      searchPlaceholder: "Partiya qidirish...",
      allBranches: "Barcha filiallar",
      allMonths: "Barcha oylar",
      newPlan: "Yangi partiya",
      emptyDay: "Partiya yo'q",
      showOrders: "Buyurtmalarni ko'rsatish",
      hideOrders: "Buyurtmalarni yashirish",
      status: {
        PLANNED: "Kutilmoqda",
        RECEIVED: "Qabul qilindi",
        HATCHED: "Chiqdi",
      },
      back: "Ortga",
      unit: "dona",
      emptyTitle: "Hali partiya yo'q",
      emptyDescription:
        "Ta'minotchi yetkazib berish jadvalini yuborganda shu yerda partiya oching — buyurtmalar shu partiyaga bog'lanadi.",
      emptyFilteredTitle: "Mos partiya topilmadi",
      emptyFiltered: "Qidiruv, oy yoki filial filtrini o'zgartiring.",
      deleteTitle: "Partiyani o'chirish",
      deleteMessage:
        "\"{name}\" partiyasi o'chiriladi. Unga bog'langan buyurtmalar bo'lsa, avval ularni boshqa partiyaga ko'chiring.",
      columns: {
        plan: "Partiya",
        supplier: "Ta'minotchi",
        branch: "Filial",
        arrivalDate: "Kelish sanasi",
        hatchDate: "Chiqish sanasi",
        totalEggs: "Tuxum",
        orderedChicks: "Buyurtma qilingan jo'ja",
        availableChicks: "Sotuvga mavjud jo'ja",
        chickCount: "Jo'ja soni",
      },
      detail: {
        eggs: "Jami tuxum",
        ordered: "Buyurtma qilingan jo'jalar soni",
        remaining: "Sotuvga mavjud jo'jalar soni",
        occupancy: "Bandlik",
        chicks: {
          PLANNED: "Kutilayotgan jo'jalar soni",
          RECEIVED: "Kutilayotgan jo'jalar soni",
          HATCHED: "Chiqqan jo'jalar soni",
        },
        chicksFromReceipt: "qabul bo'yicha",
        chicksFirstGrade: "1-nav",
        receivedOn: "Qabul: {date}",
        enteredBy: "Kiritdi: {name}",
        plannedEggs: "reja: {count}",
        notReceived: "Tuxum hali kelmagan — barcha raqamlar reja bo'yicha.",
        journey: {
          title: "Partiya yo'li",
          set: "Inkubatsiyada",
          hatcher: "Chiqishda",
          now: "Hozir",
          expected: "Kutilmoqda: {date}",
          eggs: "{count} tuxum",
          chicks: "{count} jo'ja · 1-nav",
          otherGrades: "2-nav {second} · 3-nav {third}",
          lossSorting: "−{count} singan, yaroqsiz",
          lossCandling: "−{count} urug'lanmagan, tumak",
          lossUnhatched: "−{count} chiqmagan",
          totalLosses: "Jami yo'qotish:",
        },
        byWeight: {
          title: "Vazn bo'yicha",
          weight: "Vazn",
          expected: "Kutilayotgan",
          hatched: "Chiqqan · 1-nav",
          ordered: "Buyurtma",
          remaining: "Qolgan",
        },
        orders: "Buyurtmalar",
        noOrders: "Bu partiyaga hali buyurtma bog'lanmagan.",
        customerNo: "Mijoz #{id}",
        orderColumns: {
          customer: "Mijoz",
          orderedCount: "Buyurtma soni",
          bonus: "Bonus",
          dealPrice: "Kelishilgan narx",
          services: "Xizmatlar",
          amount: "Jami summa",
          debt: "Qarzdorlik",
          status: "Holati",
        },
      },
      form: {
        newTitle: "Yangi partiya",
        editTitle: "Partiyani tahrirlash",
        basicsTitle: "Asosiy ma'lumot",
        hatchDate: "Chiqish sanasi",
        hatchDatePlaceholder: "Kelish sanasidan avtomatik",
        supplier: "Ta'minotchi",
        supplierPlaceholder: "Ta'minotchini tanlang",
        branch: "Filial",
        branchPlaceholder: "Filialni tanlang",
        arrivalDate: "Kelish sanasi",
        categoriesTitle: "Tuxum kategoriyalari",
        category: "Kategoriya",
        categoryPlaceholder: "Tanlang",
        eggCount: "Tuxum soni",
        hatchPercent: "Chiqish %",
        expectedChicks: "Kutilayotgan jo'ja",
        addCategory: "Kategoriya qo'shish",
        totalEggs: "Jami tuxum",
        totalExpectedChicks: "Jami kutilgan jo'ja",
        state: { saving: "Saqlanmoqda" },
        save: "Partiyani saqlash",
        notFound: "Partiya topilmadi",
        notFoundDescription: "Bu partiya o'chirilgan yoki umuman mavjud emas.",
        lockedTitle: "Partiya qabul qilingan",
        lockedDescription: "Inkubatsiya bu partiyani qabul qilgan — endi uni o'zgartirib bo'lmaydi.",
        errors: {
          supplier: "Ta'minotchini tanlang.",
          branch: "Filialni tanlang.",
          arrivalDate: "Kelish sanasini tanlang.",
          category: "Kategoriya kodini kiriting.",
          eggCount: "Tuxum soni 0 dan katta bo'lishi kerak.",
          hatchPercent: "Chiqish foizi 1–100 oralig'ida bo'lishi kerak.",
          categoriesRequired: "Kamida bitta kategoriya qo'shing.",
        },
      },
    },
    salesBatches: {
      searchPlaceholder: "Partiya qidirish...",
      estimate: "taxminiy",
      eggsUnit: "tuxum",
      noHatchDate: "Sana belgilanmagan",
      notHatchedYet: "hali chiqmagan",
      notGradedYet: "hali saralanmagan",
      emptyTitle: "Partiya topilmadi",
      emptyDescription: "Tanlangan davrda bu filialda partiya yo'q.",
      emptyFiltered: "Qidiruvga mos partiya yo'q.",
      emptyBranchTitle: "{branch} filialida partiya yo'q",
      emptyBranchDescription:
        "Bu filialga hali tuxum qabul qilinmagan. Partiyalar inkubatsiya bo'limida yaratiladi.",
      columns: {
        hatchDate: "Chiqish sanasi",
        expectedCount: "Kutilayotgan soni",
        ordered: "Buyurtma",
        available: "Qoldiq",
        occupancy: "Bandlik",
        status: "Holati",
      },
      status: {
        PLANNED: "Rejalashtirilgan",
        SELLING: "Sotuvda",
        FULL: "To'ldi",
      },
      stage: {
        RECEIVED: "Qabul qilindi",
        SETTING: "Inkubatsiyada",
        READY_TO_TRANSFER_TO_HATCHING: "O'tkazishga tayyor",
        HATCHING: "Chiqarishda",
        READY_TO_COMPLETE: "Yakunlashga tayyor",
        COMPLETED: "Yakunlandi",
      },
      funnel: {
        eggs: "Tuxum qabul",
        losses: "Yo'qotish",
        expected: "Kutilgan",
        actual: "Chiqqan",
        ordered: "Sotilgan",
      },
      panel: {
        title: "Partiya",
        back: "Partiyalarga qaytish",
        orders: "Bu partiyaning buyurtmalari",
        noOrders: "Bu partiyaga hali buyurtma yo'q.",
        customer: "Mijoz",
        customerNo: "Mijoz #{id}",
        count: "Soni",
        amount: "Summa",
        payment: "To'lov",
        bonus: "bonus",
      },
      aggregate: {
        tab: "Jamlanma",
        metric: "Ko'rsatkich",
        total: "Jami",
        expectedRow: "Kutilayotgan jo'ja soni",
        actualRow: "Chiqqan jo'ja soni",
        orderedRow: "Buyurtma qilingan jo'ja soni",
        availableRow: "Sotuvga mavjud jo'ja soni",
        schedule: "Chiqish jadvali",
        noSchedule: "Tanlangan davrda chiqish rejalashtirilmagan.",
      },
    },
    orders: {
      title: "Buyurtmalar",
      newOrder: "Yangi buyurtma",
      searchPlaceholder: "Mijoz, telefon yoki partiya bo'yicha qidirish",
      jojaUnit: "jo'ja",
      units: { chicks: "jo'ja", chick: "jo'ja", bonus: "bonus", sum: "so'm" },
      kanbanEmpty: "Bu statusda buyurtma yo'q",
      emptyTitle: "Buyurtmalar hali yo'q",
      emptyDescription: "Birinchi buyurtmani yaratib, mijoz, partiya, narx va yetkazishni bir joyda boshqaring.",
      emptyFiltered: "Bu filter bo'yicha buyurtma topilmadi.",
      deleteTitle: "Buyurtmani o'chirish",
      deleteMessage: "#{id} buyurtma o'chiriladi. Davom etasizmi?",
      // A new order left before saving — kept in the browser, never an order until it is saved.
      draft: {
        title: "Tugallanmagan buyurtma",
        restored: "Tugallanmagan buyurtma tiklandi",
        noCustomer: "Mijoz tanlanmagan",
        continue: "Davom ettirish",
        startNew: "Yangisini boshlash",
        deleteTitle: "Tugallanmagan buyurtmani o'chirish",
        deleteMessage: "Kiritilgan ma'lumotlar o'chiriladi. Davom etasizmi?",
        conflictTitle: "Tugallanmagan buyurtma bor",
        conflictMessage:
          "Avval boshlangan buyurtma saqlab qo'yilgan: {summary}. Yangisini boshlasangiz, u o'chiriladi.",
      },
      actions: {
        newOrder: "Yangi buyurtma",
        edit: "Tahrirlash",
        delete: "O'chirish",
      },
      status: {
        PENDING: "Navbatda",
        CONFIRMED: "Tasdiqlangan",
        DELIVERED: "Yetkazilgan",
        CANCELLED: "Bekor qilingan",
      },
      payment: {
        UNPAID: "To'lanmagan",
        PARTIAL: "Qisman",
        PAID: "To'langan",
        ON_ACCOUNT: "Hamyonga yozilgan",
        REFUNDED: "Qaytarildi",
      },
      category: {
        LIGHT: "Yengil",
        MEDIUM: "O'rta",
        HEAVY: "Og'ir",
      },
      delivery: {
        COMPANY_FREE: "Bepul yetkazib berish",
        PICKUP: "Mijoz o'zi olib ketadi",
        PAID: "Pullik yetkazib berish",
      },
      filters: {
        all: "Barchasi",
        allOrders: "Barcha buyurtmalar",
        allPayments: "Barcha to'lovlar",
        allMonths: "Barcha oylar",
      },
      views: {
        table: "Jadval",
        kanban: "Kanban",
        cards: "Kartalar",
      },
      stats: {
        total: "Jami buyurtmalar",
        pending: "Kutilmoqda",
        delivered: "Yetkazilgan",
        revenue: "Tushum",
        debt: "Qarz",
        cancelled: "Bekor qilingan",
      },
      columns: {
        no: "№",
        customer: "Mijoz",
        batch: "Partiya",
        count: "Miqdor",
        dealPrice: "Kelishuv narxi",
        marketPrice: "Bozor narxi",
        total: "Jami",
        status: "Holati",
        payment: "To'lov",
        deliveryDate: "Yetkazish sanasi",
        orderDate: "Qabul sanasi",
        bonus: "Bonus",
        receivedAt: "Qabul vaqti",
      },
      form: {
        newTitle: "Yangi buyurtma",
        editTitle: "Buyurtmani tahrirlash",
        noBranch: "Buyurtma yaratish uchun avval filialni tanlang.",
        customerSection: "Mijoz va buyurtma",
        customer: "Mijoz",
        selectCustomer: "Mijozni tanlang",
        batch: "Partiya (chiqish sanasi)",
        selectBatch: "Partiyani tanlang",
        weight: "Vazni",
        count: "Buyurtma soni",
        batchChicks: {
          PLANNED: "Kutilayotgan jo'ja (reja)",
          RECEIVED: "Kutilayotgan jo'ja (qabul qilingan)",
          HATCHED: "Chiqqan jo'ja",
        },
        batchOrdered: "Buyurtma qilingan",
        batchRemaining: "Sotuvga mavjud",
        categoryRemaining: "Mavjud",
        forecastOverbook:
          "Partiya taxminidan {count} ta oshib ketdi. Bu to'sqinlik qilmaydi — haqiqiy chiqish odatda taxmindan yuqori chiqadi.",
        dealPrice: "Kelishilgan",
        marketPrice: "Bozor",
        bonus: "Bonus",
        bonusPct: "bonus {pct}%",
        totalRow: "Jami: {count} jo'ja · Bonus: {bonus}",
        servicesSection: "Xizmatlar",
        vaccines: "Vaksina",
        noVaccines: "Vaksina qo'shilmagan",
        perChick: "so'm/jo'ja",
        delivery: "Yetkazib berish",
        deliveryPrice: "Narx",
        paymentsSection: "To'lovlar",
        discount: "Umumiy chegirma",
        paid: "To'langan",
        remaining: "Qoldiq",
        walletCharge: "Hamyonga yoziladi",
        walletReturn: "Hamyonga qaytadi",
        deliveredNote: "Buyurtma topshirilgan — summa o'zgarsa, farqi mijoz hamyoniga yoziladi.",
        summary: "Buyurtma xulosasi",
        summaryCategory: {
          LIGHT: "Yengil vaznli",
          MEDIUM: "O'rta vaznli",
          HEAVY: "Og'ir vaznli",
        },
        summaryBonus: "Bonus jo'ja",
        summaryBonusFree: "bepul, vaksinasi ham bepul",
        summaryFree: "bepul",
        summaryNoChicks: "Hali jo'ja kiritilmagan",
        chicksSection: "Jo'jalar",
        total: "Jami",
        sendTelegram: "Telegram orqali yuborish",
        sentTelegram: "Telegramga yuborildi",
        copyBotLink: "Bot havolasini nusxalash",
        linkCopied: "Havola nusxalandi",
        copyFailed: "Havolani nusxalab bo'lmadi.",
        telegramOff: "ulanmagan",
        telegramUnavailable: "Mijoz botni ulamagan yoki bot sozlanmagan.",
        telegramNoPermission: "Telegram orqali yuborishga ruxsatingiz yo'q.",
        pdf: "PDF",
        createOrder: "Buyurtma yaratish",
        saveOrder: "Buyurtmani saqlash",
        confirmSave: {
          createTitle: "Buyurtmani tasdiqlang",
          saveTitle: "O'zgarishlarni tasdiqlang",
          createMessage:
            "{customer} · {count} jo'ja · {total} so'm. Buyurtma yaratilsinmi?",
          saveMessage:
            "{customer} · {count} jo'ja · {total} so'm. O'zgarishlar saqlansinmi?",
        },
        errors: {
          customer: "Mijozni tanlang.",
          batch: "Partiyani tanlang.",
          noItems: "Kamida bitta jo'ja turi qo'shing.",
          deliveryPrice: "Yetkazish narxini kiriting.",
          discount: "Chegirma manfiy bo'lmasligi kerak.",
          total: "Jami summa 0 dan katta bo'lishi kerak.",
          overPaid: "To'lov jami summadan oshib ketdi.",
          wallet: "Hamyon balansi yetarli emas.",
          bonus: "Bonus manfiy bo'lmasligi kerak.",
          bonusWithoutCount: "Bonus faqat miqdori kiritilgan turga qo'shiladi.",
          loadFailed: "Buyurtmani yuklab bo'lmadi.",
          notEditable: "Bekor qilingan buyurtmani tahrirlab bo'lmaydi.",
        },
        backToOrders: "Buyurtmalarga qaytish",
        selectedCount: "{count} tanlandi",
        addVaccine: "Vaksina tanlash",
        vaccineRetired: "katalogda yo'q",
        tenders: "To'lov usullari",
        addTender: "To'lov usulini tanlash",
        settled: "To'langan summa",
        settledHint: "To'lovlar buyurtma sahifasida boshqariladi.",
        discountHint: "Kichik summalarni yaxlitlash uchun — menejer belgilaydi",
        share: "Ulashish",
        shareMenu: "Ulashish menyusi",
      },
      detail: {
        title: "Buyurtma #{id}",
        notFoundTitle: "Buyurtma topilmadi",
        notFoundDescription: "Bu buyurtma mavjud emas yoki o'chirilgan.",
        batch: "Partiya",
        branch: "Filial",
        orderDate: "Buyurtma sanasi",
        deliveryDate: "Yetkazish sanasi",
        enteredBy: "Menejer",
        items: "Jo'jalar va narxlar",
        paymentHistory: "To'lovlar tarixi",
        noPayments: "Hali to'lov qilinmagan",
        editOrder: "Buyurtmani tahrirlash",
        customer: "Mijoz",
        chargedToWallet: "Hamyonga yozildi",
        returnedToWallet: "Hamyonga qaytdi",
        overpaid: "Ortiqcha to'langan",
        overpaidHint: "Topshirilganda hamyonga qaytadi",
        openWallet: "Hamyonni ochish",
        paymentStatus: "To'lov holati",
        acceptPayment: "To'lov qabul qilish",
        acceptPaymentBtn: "To'lov qabul qilish",
        statusActions: "Holatni o'zgartirish",
        move: {
          CONFIRMED: "Tasdiqlash",
          DELIVERED: "Topshirishni tasdiqlash",
          CANCELLED: "Bekor qilish",
        },
        confirm: {
          CONFIRMED: {
            title: "Buyurtmani tasdiqlash",
            message: "Bu buyurtma tasdiqlanadi. Davom etasizmi?",
          },
          DELIVERED: {
            title: "Topshirishni tasdiqlash",
            message: "Buyurtma yetkazilgan deb belgilanadi va zaxira band bo'lib qoladi. Davom etasizmi?",
          },
        },
      },
      cancel: {
        title: "Buyurtmani bekor qilish",
        reason: "Bekor qilish sababi",
        reasonPlaceholder: "Masalan: mijoz buyurtmadan voz kechdi",
        reasonRequired: "Bekor qilish sababini kiriting.",
        paid: "Mijoz bu buyurtma uchun {amount} to'lagan. Pul qanday qaytariladi?",
        refundRequired: "Pulni qaytarish usulini tanlang.",
        refund: {
          WALLET: "Mijoz hamyoniga",
          CASH: "Mijoz o'ziga",
        },
        refunded: {
          WALLET: "{amount} hamyonga qaytarildi",
          CASH: "{amount} naqd qaytarildi",
        },
        note: "Bekor qilish sababi",
        dismiss: "Ortga",
        confirm: "Bekor qilish",
      },
      hatchCalendar: {
        dateRange: "Chiqish sanasi",
        empty: "Bu davrda chiqadigan partiya topilmadi.",
        error: "Chiqish kalendarini yuklab bo'lmadi.",
      },
    },
    payments: {
      deleteTitle: "To'lovni o'chirish",
      deleteMessage: "{amount} so'mlik to'lov o'chiriladi — buyurtmaning to'langan summasi shunchaga kamayadi. Davom etasizmi?",
      deleteAccountMessage: "{amount} so'mlik to'lov o'chiriladi — mijoz hamyonidan shuncha ayriladi. Davom etasizmi?",
      // Shown on the disabled button: why this payment cannot be deleted.
      deleteBlocked: {
        DELIVERED: "Buyurtma topshirilgan — uning to'lovini o'chirib bo'lmaydi. Tuzatishni mijoz hamyoni orqali kiriting.",
        CANCELLED: "Buyurtma bekor qilingan va to'lovi mijozga qaytarilgan — to'lovni o'chirib bo'lmaydi.",
      },
      recordTitle: "To'lov kiritish",
      applyToOrder: "Buyurtmaga biriktirish",
      onWallet: "Hamyonga",
      amount: "Summa",
      method: "To'lov usuli",
      date: "To'lov sanasi",
      note: "Izoh (ixtiyoriy)",
      notePlaceholder: "Bu to'lov haqida izoh...",
      remainingAfter: "To'lovdan keyingi qoldiq",
      record: "To'lov kiritish",
      list: {
        search: "Mijoz, buyurtma yoki izoh bo'yicha qidirish...",
        empty: "Hozircha to'lov yo'q",
        emptyFiltered: "Filtrlarga mos to'lov topilmadi",
        allTypes: "Barcha to'lov usullari",
        month: "Oy",
        totalCollected: "Jami qabul qilingan",
        count: "{count} ta to'lov",
        totalRefunded: "Qaytarilgan",
        fromWallet: "Hamyondan yopildi",
        refundCount: "{count} ta buyurtma",
        columns: {
          date: "Sana",
          customer: "Mijoz",
          order: "Buyurtma",
          methods: "To'lov usullari",
          amount: "Summa",
          attachment: "Chek",
          receivedBy: "Qabul qildi",
          notes: "Izoh",
        },
      },
      detail: {
        title: "To'lov #{id}",
        pageTitle: "To'lov",
        amount: "To'lov summasi",
        walletNote: "Buyurtmasiz qabul qilingan — mijoz hamyoniga yozildi",
        order: "Buyurtma #{id}",
        receipt: "Qabul",
        notFoundTitle: "To'lov topilmadi",
        notFoundDescription: "Bu to'lov o'chirilgan yoki manzil noto'g'ri.",
        receivedBy: "Qabul qildi",
        notes: "Izoh",
        tenders: "To'lov usullari",
      },
      audit: {
        title: "O'zgarishlar tarixi",
        actions: {
          CREATE: "To'lov kiritildi",
          UPDATE: "To'lov tahrirlandi",
          DELETE: "To'lov o'chirildi",
          ATTACH: "Hujjat o'zgardi",
        },
        fields: {
          AMOUNT: "Summa",
          TENDERS: "To'lov usullari",
          PAID_AT: "Sana",
          NOTES: "Izoh",
          ATTACHMENTS: "Cheklar",
        },
      },
      attachment: {
        title: "Chek / kvitansiya",
        add: "Hujjat biriktirish",
        hint: "JPG, PNG yoki PDF · 10 MB gacha",
        addMore: "Yana chek qo'shish",
        previous: "Oldingi",
        next: "Keyingi",
        open: "Hujjatni ochish",
        download: "Yuklab olish",
        noPreview: "Bu faylni bu yerda ko'rsatib bo'lmaydi — yuklab oling.",
        empty: "Hujjat biriktirilmagan.",
        tooLarge: "Fayl hajmi 10 MB dan oshmasligi kerak.",
        uploadFailed: "Faylni yuklab bo'lmadi.",
        removeTitle: "Hujjatni o'chirish",
        removeMessage: "Bu to'lovdagi chek o'chiriladi. Davom etasizmi?",
      },
      type: {
        CASH: "Naqd",
        CARD: "Karta",
        BANK: "Bank",
        WALLET: "Hamyon",
      },
      errors: {
        customer: "Mijozni tanlang.",
        order: "Buyurtmani tanlang.",
        amount: "Summani kiriting.",
        exceeds: "Qoldiqdan oshib ketdi (maks {amount}).",
        wallet: "Hamyon balansi yetarli emas (maks {amount}).",
      },
      actions: {
        newPayment: "Yangi to'lov",
      },
      form: {
        newTitle: "Yangi to'lov",
        editTitle: "To'lovni tahrirlash",
        back: "To'lovlar",
        customer: "Mijoz",
        selectCustomer: "Mijozni tanlang",
        selectOrder: "Buyurtmani tanlang",
        noOutstanding: "Bu mijozda to'lanmagan buyurtma yo'q.",
        target: "Pul qayerga",
        targetOrder: "Buyurtmaga",
        targetWallet: "Hamyonga",
        walletHint: "buyurtmasiz — topshirilgan buyurtmalar qarzi yoki avans",
        walletNow: "Hozirgi balans",
        walletAfter: "To'lovdan keyin",
        orderTotal: "Buyurtma summasi",
        alreadyPaid: "To'langan",
        debt: "Qoldiq",
        tenders: "To'lov usullari",
        addTender: "To'lov usulini tanlash",
        fillRemaining: "Qoldiqni to'ldirish",
        walletBalance: "Hamyon balansi: {amount} so'm",
        time: "Vaqt",
      },
    },
    wallet: {
      topUpTitle: "Hamyonni to'ldirish",
      withdrawTitle: "Hamyondan yechish",
      currentBalance: "Joriy balans",
      amount: "Summa",
      reason: "Sabab",
      order: "Buyurtma",
      description: "Izoh (ixtiyoriy)",
      descriptionRequired: "Izoh (majburiy)",
      descriptionPlaceholder: "Izoh qo'shing...",
      compensationPlaceholder: "Masalan: №41 buyurtma — 50 ta jo'ja nobud bo'ldi",
      reasonInfoLabel: "«{reason}» nima?",
      reasonInfo: {
        TOP_UP: {
          BONUS: "Mijozga sovg'a sifatida beriladigan pul — masalan, katta xarid uchun rag'bat.",
          REFUND: "Mijoz to'lagan pulning qaytarilishi: ortiqcha to'lov, narx tushirilgani yoki xato tuzatilishi. Bekor qilingan buyurtma pulini tizim o'zi qaytaradi.",
          OPENING_BALANCE: "Tizimga o'tishdan oldingi qoldiq: kompaniya mijozga qarzdor bo'lgan summa.",
          COMPENSATION: "Birinchi haftada nobud bo'lgan jo'jalar uchun kompaniya to'laydigan pul. Izohga buyurtma raqamini yozing. Tushumga qo'shilmaydi.",
          OTHER: "Yuqoridagilarga to'g'ri kelmaydigan holat — sababini izohda yozing.",
        },
        WITHDRAWAL: {
          CASH_OUT: "Hamyondagi pulni mijozga naqd berish. Hamyondagi summadan oshmaydi.",
          FINE: "Mijozdan ushlanadigan jarima. Hamyon noldan pastga tushsa, qarz bo'lib yoziladi.",
          OPENING_BALANCE: "Tizimga o'tishdan oldingi qarz: mijoz kompaniyaga qarzdor bo'lgan summa.",
          OTHER: "Yuqoridagilarga to'g'ri kelmaydigan yechish — sababini izohda yozing.",
        },
      },
      balanceAfter: "Amaldan keyingi balans",
      goesIntoDebt: "Hamyon manfiyga tushadi — mijoz qarzdor bo'lib qoladi.",
      submitTopUp: "To'ldirish",
      submitWithdraw: "Yechish",
      types: {
        TOP_UP: "Hamyonga kirim",
        WITHDRAWAL: "Hamyondan chiqim",
      },
      detail: {
        pageTitle: "Hamyon harakati",
        back: "Hamyon",
        facts: "Harakat tafsilotlari",
        performedBy: "Kim bajardi",
        at: "Vaqti",
        payment: "To'lov",
        paymentNumber: "№{id} to'lov",
        noAttachment: "Tasdiqlovchi hujjat biriktirilmagan.",
        notFoundTitle: "Harakat topilmadi",
        notFoundDescription: "Bu hamyon harakati o'chirilgan yoki umuman mavjud emas.",
      },
      reasons: {
        CASH: "Naqd pul",
        CARD: "Karta orqali",
        BANK: "Bank o'tkazmasi",
        BONUS: "Bonus",
        REFUND: "Qaytarilgan mablag'",
        OPENING_BALANCE: "Boshlang'ich qoldiq",
        PAYMENT: "To'lov",
        ORDER_SETTLEMENT: "Buyurtma topshirildi",
        WRITE_OFF: "Hisobdan chiqarildi",
        COMPENSATION: "Zararni qoplab berish",
        CASH_OUT: "Naqd yechish",
        FINE: "Jarima",
        ORDER: "Buyurtma uchun",
        OTHER: "Boshqa",
      },
      attachment: {
        title: "Tasdiqlovchi hujjat",
        label: "Tasdiqlovchi hujjat (ixtiyoriy)",
        add: "Hujjat biriktirish",
        replace: "Hujjatni almashtirish",
        open: "Hujjatni ochish",
        tooLarge: "Fayl hajmi 10 MB dan oshmasligi kerak.",
        uploadFailed: "Faylni yuklab bo'lmadi.",
        removeTitle: "Hujjatni o'chirish",
        removeMessage: "Tasdiqlovchi hujjat o'chiriladi. Summa va balans o'zgarmaydi. Davom etasizmi?",
      },
      errors: {
        amount: "Summani kiriting.",
        scale: "Summa ko'pi bilan 2 kasr xonaga ega bo'lishi mumkin.",
        insufficient: "Hamyonda yetarlicha mablag' yo'q",
        descriptionRequired: "Bu sabab uchun izoh majburiy.",
        descriptionTooLong: "Izoh 500 belgidan oshmasligi kerak.",
      },
    },
    reminders: {
      title: "Eslatmalar",
      formTitle: "Eslatma",
      search: "Eslatma yoki mijoz bo'yicha qidirish...",
      empty: "Hozircha eslatma yo'q",
      emptyFiltered: "Tanlangan filtrlarga mos eslatma topilmadi",
      deleteTitle: "Eslatmani o'chirish",
      deleteMessage: "Bu eslatma o'chiriladi. Davom etasizmi?",
      completeTitle: "Bajarildi deb belgilash",
      completeMessage: "Bu eslatma bajarilgan deb belgilanadi. Buni ortga qaytarib bo'lmaydi.",
      actions: {
        create: "Yangi eslatma",
        edit: "Tahrirlash",
        complete: "Bajarildi",
        delete: "O'chirish",
      },
      views: {
        table: "Jadval",
        kanban: "Kanban",
      },
      kanbanEmpty: "Bu holatda eslatma yo'q",
      status: {
        TODAY: "Bugun",
        OVERDUE: "Muddati o'tgan",
        UPCOMING: "Kelgusi",
        DONE: "Bajarilgan",
      },
      fields: {
        customer: "Mijoz",
        phone: "Telefon",
        note: "Eslatma",
        date: "Sana",
        time: "Vaqt",
        status: "Holat",
        createdBy: "Qayd etdi",
        completedAt: "Bajarilgan sana",
      },
      filters: {
        allReminders: "Barcha eslatmalar",
        dateRange: "Sana oralig'i",
      },
      placeholders: {
        note: "Nima qilish kerak? Masalan: Iyun partiyasi to'lovi haqida qo'ng'iroq qilish",
        selectCustomer: "Mijozni tanlang",
      },
      hints: {
        customerLocked: "Eslatmaning mijozini o'zgartirib bo'lmaydi.",
        overdueIgnoresRange: "Muddati o'tgan eslatmalar sana oralig'iga bog'liq emas.",
        late: "Vaqti o'tdi",
      },
      errors: {
        note: "Eslatma matnini kiriting",
        date: "Sanani tanlang",
        time: "Vaqtni tanlang",
        customer: "Mijozni tanlang",
      },
    },
    customers: {
      formTitle: "Mijoz",
      search: "Mijoz, telefon, hudud yoki manzil bo‘yicha qidirish...",
      sort: {
        label: "Saralash",
        newest: "Avval yangi qo'shilgan",
        oldest: "Avval eski qo'shilgan",
        name: "Nomi bo'yicha",
        region: "Hudud bo'yicha",
        debt: "Avval qarzdorlar",
      },
      empty: "Hozircha mijoz yo'q",
      deleteTitle: "Mijozni o'chirish",
      deleteMessage: "Bu mijoz ro'yxatdan o'chiriladi. Davom etasizmi?",
      deleteWithBalanceMessage: "Hamyondagi {amount} so'm hisobdan chiqariladi va mijoz o'chiriladi. Davom etasizmi?",
      actions: {
        create: "Mijoz qo'shish",
      },
      filters: {
        allRegions: "Barcha hududlar",
      },
      fields: {
        no: "№",
        name: "Mijoz",
        phone: "Telefon",
        country: "Davlat",
        region: "Hudud",
        address: "Manzil",
        walletBalance: "Hamyon",
        type: "Mijoz turi",
        notes: "Eslatmalar",
      },
      typeHint: "Narx va hisobotlar uchun daraja.",
      optional: "— ixtiyoriy",
      notesPlaceholder: "Mijoz haqida eslatma qo'shing...",
      placeholders: {
        address: "Ko'cha, uy, xonadon",
        selectCountry: "Davlatni tanlang",
        selectRegion: "Hududni tanlang",
      },
      avatar: {
        upload: "Rasm yuklash",
        change: "Rasmni o'zgartirish",
        remove: "O'chirish",
        hint: "PNG yoki JPG, 10 MB gacha.",
        tooLarge: "Rasm hajmi 10 MB dan oshmasligi kerak.",
        invalidType: "Faqat rasm fayllari qabul qilinadi.",
        uploadFailed: "Rasmni yuklab bo'lmadi. Qaytadan urinib ko'ring.",
      },
      errors: {
        phoneInvalid: "Telefon raqami noto'g'ri. Format: +998 XX XXX XX XX",
        regionRequired: "Hududni tanlang.",
      },
      detail: {
        title: "Mijoz profili",
        back: "Mijozlar",
        edit: "Tahrirlash",
        customerSince: "Mijoz bo'lgan sana",
        tier: "{type} daraja",
        comingSoon: "Bu bo'lim tez orada qo'shiladi.",
        notFoundTitle: "Mijoz topilmadi",
        notFoundDescription: "Bu mijoz o'chirilgan yoki mavjud emas.",
        tabs: {
          overview: "Umumiy",
          orders: "Buyurtmalar",
          payments: "To'lovlar",
          wallet: "Hamyon",
          reminders: "Eslatmalar",
          activity: "Faollik",
        },
      },
      overview: {
        noNotes: "Eslatmalar yo'q",
        totalOrders: "Jami buyurtmalar",
        cancelled: "Bekor qilingan",
        boughtChicks: "Olingan jo'jalar",
        totalValue: "Umumiy summa",
        walletBalance: "Hamyon balansi",
        debt: "Qarz",
        openOrdersUnpaid: "Kutilayotgan to'lov",
        financeSoon: "Buyurtmalar, to'lovlar va hamyon statistikasi tez orada qo'shiladi.",
      },
      activity: {
        empty: "Hozircha faollik yo'q",
        deleteTitle: "Eslatmani o'chirish",
        deleteMessage: "Bu eslatma o'chiriladi. Davom etasizmi?",
      },
      conversations: {
        title: "Mijoz bilan suhbatlar",
        latest: "Oxirgi suhbat",
        placeholder: "Nima gaplashildi? Keyingi safar nimadan boshlash kerak?",
        save: "Yozib olish",
        charCount: "{n} / {max}",
        expand: "To'liq o'qish",
        collapse: "Yig'ish",
        readOnly: "Suhbat yozishga ruxsatingiz yo'q",
        editSave: "Saqlash",
        editCancel: "Bekor qilish",
        retry: "Qayta urinish",
        errorLoad: "Suhbatlarni yuklab bo'lmadi",
        errorSave: "Suhbatni saqlab bo'lmadi. Matningiz saqlanib turibdi.",
        errorUpdate: "O'zgarishni saqlab bo'lmadi",
        deleteTitle: "Suhbatni o'chirish",
        deleteMessage: "«{excerpt}» yozuvi o'chiriladi. Faoliyat tarixidagi yozuv o'z joyida qoladi.",
        empty: {
          title: "Hali suhbat yozilmagan",
          body: "Mijoz bilan gaplashganingizdan keyin qisqacha yozib qo'ying — keyingi qo'ng'iroqda nimadan boshlashni shu yerdan eslaysiz.",
        },
      },
      orders: {
        priceSensitive: "Narxga sezgir mijoz",
        givenProfit: "Yo'qotilgan foyda",
        avgDeal: "O'rtacha kelishilgan narx",
        avgMarket: "O'rtacha bozor narxi",
        totalDiff: "Umumiy farq",
        orderedChicks: "Jami jo'jalar",
        bonusChicks: "+{count} bonus",
        totalOrders: "Jami buyurtmalar",
        cancelled: "Bekor qilingan",
        totalValue: "Umumiy qiymat",
        empty: "Bu mijozda hali buyurtma yo'q.",
      },
      payments: {
        outstanding: "To'lanmagan buyurtmalar",
        totalDue: "Jami qarz",
        noOutstanding: "To'lanmagan buyurtma yo'q.",
        noHistory: "Hali to'lov yo'q.",
      },
      wallet: {
        balance: "Hamyon balansi",
        debtor: "Qarzdor",
        creditor: "Haqdor",
        openOrdersUnpaid: "Kutilayotgan to'lov",
        noTransactions: "Hali harakat yo'q.",
      },
    },
    debtors: {
      empty: "Qarzdor mijoz yo'q",
      stats: {
        totalDebt: "Jami qarz",
        debtors: "Qarzdorlar",
      },
      columns: {
        no: "№",
        customer: "Mijoz",
        debt: "Qarz",
        status: "Suhbat xulosasi",
      },
      status: {
        placeholder: "Suhbat xulosasi",
        saved: "Saqlandi",
      },
    },
    // The mirror of Qarzdorlar: customers whose wallet is above zero — money held for them.
    creditors: {
      empty: "Haqdor mijoz yo'q",
      stats: {
        totalCredit: "Jami haq",
        creditors: "Haqdorlar",
      },
      columns: {
        no: "№",
        customer: "Mijoz",
        credit: "Haq",
      },
    },
    expenses: {
      locked: "Mijoz hamyonidagi harakatdan yozilgan — o'zgartirib yoki o'chirib bo'lmaydi.",
      form: {
        newTitle: "Yangi xarajat",
        editTitle: "Xarajatni tahrirlash",
      },
      search: "Izoh, kategoriya yoki kim kiritgani bo'yicha qidirish...",
      empty: "Hozircha xarajat yo'q",
      deleteTitle: "Xarajatni o'chirish",
      deleteMessage: "Bu xarajat ro'yxatdan o'chiriladi. Davom etasizmi?",
      actions: {
        create: "Xarajat qo'shish",
      },
      stats: {
        today: "Bugun",
        month: "Shu oy",
        count: "{count} ta xarajat",
      },
      filters: {
        allCategories: "Barcha kategoriyalar",
      },
      fields: {
        category: "Kategoriya",
        amount: "Summa",
        expenseDate: "Xarajat sanasi",
        expenseTime: "Vaqt",
        description: "Izoh",
        paymentType: "To'lov turi",
        walletMovement: "Hamyon harakati",
        currency: "Valyuta",
        createdBy: "Kim kiritdi",
        createdAt: "Kiritilgan vaqt",
      },
      receipt: {
        title: "Chek",
        attach: "Chek biriktirish",
        hint: "PDF yoki rasm, 10 MB gacha",
        tooLarge: "Fayl hajmi 10 MB dan oshmasligi kerak.",
        uploadFailed: "Faylni yuklab bo'lmadi. Qaytadan urinib ko'ring.",
        download: "Yuklab olish",
      },
      detail: {
        title: "Xarajat tafsiloti",
        notFoundTitle: "Xarajat topilmadi",
        notFoundDescription: "Bu xarajat o'chirilgan yoki havola noto'g'ri.",
      },
      placeholders: {
        amount: "Masalan: 250 000",
        description: "Xarajat bo'yicha qisqa izoh",
      },
      errors: {
        category: "Kategoriyani tanlang.",
        amount: "Summani kiriting.",
      },
    },
    branch: {
      label: "Filial",
      activeTag: "Joriy",
      placeholder: "Filialni tanlang",
      none: "Filial yo'q",
      loadError: "Filiallarni yuklab bo'lmadi.",
      retry: "Qayta urinish",
      deleteActiveHint: "Siz turgan filialni o'chirib bo'lmaydi.",
      required: {
        title: "Filial tanlanmagan",
        empty: "Bu bo'lim filialga bog'liq, lekin hali birorta filial yo'q.",
        forbidden: "Sizda filiallarni ko'rish huquqi yo'q. Administratorga murojaat qiling.",
        cta: "Filial qo'shish",
      },
    },
    common: {
      cancel: "Bekor qilish",
      clear: "Tozalash",
      close: "Yopish",
      confirm: "Tasdiqlash",
      details: "Batafsil",
      error: "Xatolik",
      loading: "Yuklanmoqda",
      noData: "Ma'lumot yo'q",
      ready: "Tayyor",
      save: "Saqlash",
      delete: "O'chirish",
      remove: "Olib tashlash",
      edit: "Tahrirlash",
      som: "so'm",
      count: "{count} ta",
      showMore: "Ko'proq ko'rish",
      showLess: "Kamroq ko'rish",
      soon: "tez orada",
      comingSoon: "Bu bo'lim tez orada qo'shiladi.",
      datePlaceholder: "kun.oy.yil",
      dateTimePlaceholder: "kun.oy.yil soat:daq",
      // Chromium ships no Uzbek month data, so Intl and date-fns both fall back to "2026 M07" —
      // the month picker reads its labels from here instead.
      months: {
        1: "Yanvar",
        2: "Fevral",
        3: "Mart",
        4: "Aprel",
        5: "May",
        6: "Iyun",
        7: "Iyul",
        8: "Avgust",
        9: "Sentabr",
        10: "Oktabr",
        11: "Noyabr",
        12: "Dekabr",
      },
      // The month picker's whole-year tile, and what its field then reads.
      wholeYear: "Butun yil",
      wholeYearOf: "Butun {year}-yil",
      errors: {
        unexpected: "Kutilmagan xatolik yuz berdi. Qaytadan urinib ko'ring.",
      },
      status: {
        available: "Bo'sh",
        loaded: "Band",
        broken: "Buzuq",
      },
    },
    enums: {
      weightCategory: {
        LIGHT: "Yengil (<40 g)",
        MEDIUM: "O'rta (40-48 g)",
        HEAVY: "Og'ir (≥48 g)",
      },
      incubationMachineType: {
        SETTER: "Inkubatsiya",
        HATCHER: "Chiqarish",
      },
      expensePaymentType: {
        CASH: "Naqd",
        CARD: "Karta",
        BANK: "Bank",
        WALLET: "Hamyon orqali",
      },
      expenseCurrency: {
        UZS: "so'm",
        USD: "USD",
        EUR: "EUR",
        RUB: "RUB",
      },
      incubationMachineStatus: {
        ACTIVE: "Faol",
        INACTIVE: "Nofaol",
      },
      incubationMachineState: {
        FREE: "Bo'sh",
        LOADED: "Band",
        BROKEN: "Buzuq",
      },
    },
    settingsAdmin: {
      actions: {
        add: "Qo'shish",
        edit: "Tahrirlash",
        delete: "O'chirish",
        save: "Saqlash",
        refresh: "Yangilash",
        close: "Yopish",
      },
      form: {
        create: "Yangi",
        edit: "Tahrirlash",
      },
      states: {
        empty: "Hozircha ma'lumot yo'q",
        error: "Ma'lumotni olishda xatolik",
      },
      labels: {
        total: "Jami",
        search: "Qidirish...",
        name: "Nomi",
        capacity: "Sig'im",
        type: "Turi",
        status: "Holati",
        inactiveReason: "Nofaollik sababi",
        category: "Kategoriya",
        parentAgeInWeeks: "Haftalik yoshi",
        hatchabilityPercent: "Chiqish foizi",
        weight: "Vazni (g)",
        weightCategory: "Vazn toifasi",
        contactPersonName: "Mas'ul shaxs",
        contactPersonPhoneNumber: "Telefon raqami",
        address: "Manzil",
        price: "Narx",
      },
      branches: {
        title: "Filiallar",
        formTitle: "Filial",
        subtitle: "Inkubatsiya filiallarini boshqarish.",
        create: "Filial qo'shish",
        deleteTitle: "Filialni o'chirish",
        deleteMessage:
          "Bu filial ro‘yxatdan o‘chiriladi. Faqat ma'lumoti yo‘q filialni o‘chirish mumkin. Davom etasizmi?",
        nameRequired: "Filial nomini kiriting.",
        nameExists: "Bunday nomli filial allaqachon mavjud.",
      },
      suppliers: {
        title: "Yetkazib beruvchilar",
        formTitle: "Yetkazib beruvchi",
        subtitle: "Yetkazib beruvchi kontaktlari va manzillarini boshqarish.",
        create: "Yetkazib beruvchi qo'shish",
        search: "Nomi, kontakt yoki manzil bo‘yicha qidirish...",
        deleteTitle: "Yetkazib beruvchini o'chirish",
        deleteMessage:
          "Bu yetkazib beruvchi ro‘yxatdan o‘chiriladi. Davom etasizmi?",
      },
      incubationMachines: {
        title: "Inkubator mashinalari",
        formTitle: "Inkubator moshinasi",
        subtitle:
          "Inkubatsiya va chiqish mashinalari sig'imi hamda holatini boshqarish.",
        create: "Mashina qo'shish",
        search: "Mashina nomi yoki holati bo‘yicha qidirish...",
        deleteTitle: "Mashinani o'chirish",
        deleteMessage: "Bu mashina ro‘yxatdan o‘chiriladi. Davom etasizmi?",
      },
      eggStandards: {
        title: "Tuxum standartlari",
        formTitle: "Tuxum standarti",
        subtitle:
          "Kategoriya, haftalik yosh va chiqish foizi standartlarini boshqarish.",
        create: "Standart qo'shish",
        search: "Kategoriya yoki nom bo‘yicha qidirish...",
        deleteTitle: "Standartni o'chirish",
        deleteMessage: "Bu standart ro‘yxatdan o‘chiriladi. Davom etasizmi?",
      },
      expenseCategories: {
        title: "Xarajat toifalari",
        formTitle: "Xarajat toifasi",
        subtitle: "Xarajatlarda ishlatiladigan toifalarni boshqarish.",
        create: "Toifa qo'shish",
        search: "Toifa nomi bo‘yicha qidirish...",
        deleteTitle: "Toifani o'chirish",
        deleteMessage: "Bu toifa ro‘yxatdan o‘chiriladi. Davom etasizmi?",
      },
      vaccines: {
        title: "Vaksinalar",
        formTitle: "Vaksina",
        subtitle: "Buyurtmalarga qo‘shiladigan vaksina xizmatlarini boshqarish.",
        create: "Vaksina qo'shish",
        search: "Vaksina nomi yoki narxi bo‘yicha qidirish...",
        deleteTitle: "Vaksinani o'chirish",
        deleteMessage: "Bu vaksina ro‘yxatdan o‘chiriladi. Davom etasizmi?",
      },
    },
    incubationFlow: {
      active: "Faol",
      avgHumidity: "O'rt. namlik",
      avgTemperature: "O'rt. harorat",
      batch: "Partiya",
      completed: "Tugagan",
      dateRange: "Davr",
      empty: "Hozircha jarayon yo'q",
      eggs: "Tuxum",
      hatchingSubtitle:
        "Hatching jarayonlari va kunlik kuzatuvlar alohida yuritiladi.",
      hatchingTitle: "Chiqish",
      humidity: "Namlik",
      inspectionButton: "Nazorat qildim",
      inspectionHint: "Nazorat tasdiqlanganda rahbarlar xabardor qilinadi.",
      inspectionLast: "Oxirgi nazorat: {time}",
      inspectionSaved: "Nazorat saqlandi",
      inspectionOverdue: "Nazorat kechikmoqda",
      inspectionTitle: "Inkubator nazorati",
      hatcherInspectionHint:
        "Nazorat tasdiqlanganda rahbarlar xabardor qilinadi.",
      hatcherInspectionTitle: "Chiqarish inkubatorlari nazorati",
      latestLog: "Oxirgi log",
      loading: "Yuklanmoqda",
      machines: "Mashinalar",
      settingSubtitle:
        "Inkubatsiya jarayonlari va kunlik harorat/namlik nazorati.",
      settingTitle: "Inkubatsiya",
      status: {
        TRANSFERRED_TO_ANOTHER_SETTER: "Boshqa inkubatorga ko'chirilgan",
        IN_SETTING: "Inkubatsiyada",
        NEW: "Yangi",
        TRANSFERRED_TO_HATCHING: "Hatchingga ko'chirilgan",
      },
      hatchingStatus: {
        TRANSFERRED_TO_ANOTHER_HATCHER:
          "Boshqa chiqish mashinasiga ko'chirilgan",
        IN_HATCHING: "Chiqishda",
        NEW: "Yangi",
        COMPLETED: "Tugagan",
      },
      completeHatching: "Chiqishni yakunlash",
      firstGradeCount: "1-nav",
      hatchingLifecycleEyebrow: "Chiqish holati",
      hatchingLifecycleTitle: "Chiqish jarayonlari",
      results: "Natijalar",
      secondGradeCount: "2-nav",
      selectMachine: "Mashina tanlang",
      settingLifecycleEyebrow: "Inkubatsiya holati",
      settingLifecycleTitle: "Inkubatsiya jarayonlari",
      startConfirmMessage:
        "{setting} ({machine}) inkubatsiya jarayonini boshlaydi. Davom etasizmi?",
      startConfirmTitle: "Inkubatsiyani boshlashni tasdiqlang",
      startShort: "Start",
      startSetting: "Inkubatsiyani boshlash",
      thirdGradeCount: "3-nav",
      temperature: "Harorat",
      totalHatchings: "Chiqishlar",
      totalSettings: "Inkubatsiyalar",
      transferAutoFill: "Avto to'ldirish",
      transferBrokenDefaultReason: "Transfer sabab: inkubator nosoz",
      transferBrokenNo: "yo'q",
      transferBrokenReason: "Nosozlik sababi",
      transferBrokenReasonPlaceholder: "Masalan: motor ishlamayapti",
      transferBrokenReasonRequired: "Nosozlik sababini kiriting",
      transferBrokenYes: "ha",
      transferConfirmMessage:
        "{setting} jarayoni {source} mashinasidan {count} ta inkubatorga ko'chiriladi. Shu mashina buzuq belgilanadi: {broken}. Davom etasizmi?",
      transferConfirmTitle: "Boshqa inkubatorga ko'chirishni tasdiqlang",
      transferCreated: "Inkubatsiya boshqa inkubatorga ko'chirildi",
      transferFailed: "Boshqa inkubatorga ko'chirib bo'lmadi",
      transferInvalidDistribution:
        "Har bir standart bo'yicha tuxumlar to'liq taqsimlanishi kerak",
      transferMarkBroken: "Shu inkubatorni buzuq deb belgilash",
      transferMarkBrokenHint: "Transferdan keyin mashina nofaol holatga o‘tadi",
      transferModalTitle: "Tuxumlarni boshqa inkubatorga taqsimlash",
      transferAvailableTargets: "Bo'sh inkubatorlar",
      transferNoTargets: "Bo'sh inkubator yo'q",
      transferNotEnoughCapacity:
        "Bo'sh sig'im yetmaydi: {eggs} tuxum uchun {capacity} joy bor",
      transferPlaced: "Joylangan tuxum",
      transferRemaining: "Qoldi:",
      transferRemainingCapacity: "Bo'sh qoladigan sig'im",
      transferRequired: "Ko‘chiriladigan tuxum",
      transferSelectTargets: "Ko'chirish uchun bo'sh inkubator tanlang",
      transferShort: "Ko'chirish",
      transferSourcePatchFailed: "Shu mashinani buzuq qilishda xatolik",
      transferSourcePatchFailedWithReason:
        "Transfer bajarildi, lekin shu mashina holati yangilanmadi: {reason}",
      transferStandard: "Standart",
      transferSubmit: "Ko'chirish",
      transferTargetCapacity: "Bo'sh sig'im",
      transferTargetOverflow: "Tanlangan inkubator sig‘imidan oshib ketdi",
      transferTargetTotal: "Inkubator jami",
      transferTargets: "Inkubatorlar",
      transferTotal: "Jami",
      transferToAnotherHatcher: "Boshqa chiqarish inkubatoriga ko'chirish",
      transferToAnotherSetter: "Boshqa inkubatorga ko'chirish",
      unhatchedCount: "Chiqmagan",
    },
    sessionEdit: {
      title: "Tahrirlash",
      maxHint: "Ko'pi bilan {count}",
      eggsLocked: "Tuxumlar chiqarish inkubatoriga o'tgan — sonini endi o'zgartirib bo'lmaydi.",
      splitLocked: "Bu chiqarish avvalroq ko'chirilgan — tuxum soni o'zgarmaydi, faqat foiz.",
      leftSetter: "Inkubatsiyadan chiqqan: {count}",
      invalidDates: "Boshlanish vaqti tugashdan oldin bo'lsin.",
      invalidEggs: "Tuxum sonini tekshiring.",
    },
    machinePark: {
      available: "Bo'sh",
      broken: "Buzuq",
      capacity: "Sig'im",
      period: "Muddat",
      periodOf: "Jami {total} · {percent}%",
      durationDaysHours: "{days} kun {hours} soat",
      durationDays: "{days} kun",
      durationHours: "{hours} soat",
      detailsTitle: "Mashina ma'lumoti",
      empty: "Mashina yo'q",
      eggs: "Tuxum",
      humidity: "Namlik",
      loaded: "Band",
      loadedNoProcess: "Band, jarayon topilmadi",
      machineCount: "Jami {count}ta mashina",
      ready: "Tayyor",
      reason: "Sabab",
      status: "Holati",
      temperature: "Harorat",
      totalCapacity: "Umumiy sig'im",
      transferred: "Hatchingga ko'chirilgan",
    },
    settingAllocator: {
      availableCount: "{count} ta bo'sh",
      availableMachinesSelect: "Setting inkubatorlari",
      availableMachines: "Bo'sh inkubatsiya mashinalari",
      batchLoadFailed: "Partiyalar ro'yxatini yuklab bo'lmadi",
      batchRemaining: "Partiyada qolgan",
      batch: "Partiya",
      capacityExceededBy: "Mashina sig'imidan {count} ta ortiqcha tanlangan",
      capacityLeft: "Bo'sh joy: {count}",
      confirmMessage:
        "{batch} partiyasidan {eggs} ta tuxum {machine} mashinasiga joylanadi. Davom etishni tasdiqlaysizmi?",
      confirmTitle: "Inkubatsiyaga joylashni tasdiqlang",
      createFailed: "Inkubatsiya yaratib bo'lmadi",
      created: "Partiya inkubatsiya mashinalariga joylandi",
      distributions: "Tuxum kategoriyalari",
      duplicateStandard: "Bu kategoriya allaqachon qo‘shilgan",
      duration: "{days} kun inkubatsiya",
      eggCount: "Tuxum soni",
      eyebrow: "Keyingi bosqich",
      expectedChicks: "Kutilayotgan jo'jalar",
      fillMachine: "Mashinaning bo'sh joyini to'ldirish",
      hatchability: "Chiqish foizi",
      startDate: "Boshlangan",
      endDate: "Tugaydi",
      total: "Jami",
      hint: "Tizim sig'im va bo'sh joy bo'yicha eng optimal kombinatsiyani tanlaydi.",
      invalidDistribution: "Tuxum taqsimotini tekshiring",
      invalidEggCount: "Tuxum soni butun va 0 dan kam bo'lmasin",
      invalidEggValues: "{count} ta qatorda tuxum sonini tekshiring",
      machine: "Inkubatsiya mashinasi",
      machineCapacityLeft: "Mashina bo'sh sig'imi",
      machineFill: "Mashina to'lishi",
      machineFull: "Bu mashinada bo'sh joy qolmadi",
      loadMachine: "Yuklash",
      maxEggs: "Maksimum: {count}",
      noAvailableMachines: "Bo'sh inkubatsiya mashina yo'q",
      noBatches: "Joylanmagan partiya yo'q",
      noCapacityLeft: "Mashinada bo'sh sig'im qolmadi",
      noRemainingCategories: "Bu partiyada joylanadigan tuxum qolmagan",
      noPlan: "Avval partiya va mashina tanlang",
      notEnoughCapacity: "Tanlangan mashinalar sig'imi yetmaydi",
      plan: "Joylash rejasi",
      placeEggs: "Joylanadigan tuxum",
      recommend: "Eng mosini tanlash",
      recommended: "Tavsiya",
      remaining: "Yetmayapti",
      remainingLoadFailed: "Qolgan tuxum kategoriyalarini yuklab bo'lmadi",
      rowLimitExceeded:
        "{count} ta qator partiyada qolgan tuxumdan oshib ketdi",
      rowLimitExceededShort: "Partiyada qolgan tuxumdan oshmasin",
      saving: "Saqlanmoqda",
      searchBatch: "Partiya qidirish...",
      selectBatch: "Partiyani tanlang",
      selectBatchEmptyHint:
        "Yuqoridagi maydondan partiyani tanlang, tuxum taqsimoti shu yerda avtomatik chiqadi.",
      selectBatchFirst: "Avval partiyani tanlang",
      selectDistributionFirst: "Kamida bitta tuxum kategoriyasini tanlang",
      selectMachineFirst: "Inkubatsiya mashinasini tanlang",
      selectMachineAndBatch: "Avval mashina va partiyani tanlang",
      placedEggs: "Joylangan tuxum",
      selectedEggs: "Tanlangan tuxum",
      selectedCapacity: "Tanlangan sig'im",
      submit: "Inkubatsiyaga joylash",
      totalPlacementLosses: "Joylashdagi yo'qotish",
      titleEyebrow: "Inkubatsiyaga joylash",
      title: "Partiyani inkubatsiya mashinalariga joylash",
      tooManyEggs: "Tanlangan tuxum mashina bo'sh sig'imidan oshib ketdi",
      wasted: "Mashina bo'sh sig'imi qoladi",
    },
    hatchingAllocator: {
      capacityLeft: "Chiqarish inkubatori bo'sh joyi: {count}",
      confirmMessage:
        "{setting} inkubatsiyasidan {eggs} ta tuxum {machine} hatching mashinasiga ko'chiriladi. Davom etishni tasdiqlaysizmi?",
      confirmTitle: "Chiqishga ko'chirishni tasdiqlang",
      createFailed: "Chiqish jarayonini yaratib bo'lmadi",
      created: "Tuxumlar chiqish mashinasiga ko'chirildi",
      completeCreated: "Chiqish yakunlandi",
      completeFailed: "Chiqishni yakunlab bo'lmadi",
      completeConfirmMessage:
        "{hatching} chiqish natijalari yakunlanadi. Davom etasizmi?",
      completeConfirmTitle: "Chiqishni yakunlashni tasdiqlang",
      completeInvalid:
        "Har bir standart bo'yicha natija jami tuxum soniga teng bo'lishi kerak",
      completeShort: "Yakunlash",
      completeTitle: "Chiqish natijalarini kiriting",
      completedRows: "Tayyor qatorlar",
      currentHatching: "Chiqish jarayoni",
      distributionHint:
        "Tuxumlar bo'sh chiqarish inkubatorlari sig'imiga qarab taqsimlanadi.",
      distributionTitle: "Chiqarish inkubatorlari bo‘yicha taqsimot",
      fillFirstGrade: "Qoldiqni 1-navga qo‘yish",
      hatcherBrokenDefaultReason: "Transfer sabab: chiqarish inkubatori nosoz",
      hatcherTransferConfirmMessage:
        "{hatching} {source} dan {target} ga ko‘chiriladi. Shu inkubator buzuq belgilanadi: {broken}. Davom etasizmi?",
      hatcherTransferConfirmTitle:
        "Boshqa chiqarish inkubatoriga ko‘chirishni tasdiqlang",
      hatcherTransferTitle: "Boshqa chiqarish inkubatoriga ko'chirish",
      hatchingEggs: "Joylanadigan tuxum",
      invalidTransfer: "Tuxum soni yoki yo'qotish qiymatini tekshiring",
      invalidDistribution:
        "Har bir standart bo'yicha tuxumlar to'liq taqsimlanishi kerak",
      machine: "Chiqarish inkubatori",
      markHatcherBroken: "Shu chiqarish inkubatorini buzuq deb belgilash",
      markHatcherBrokenHint: "Transferdan keyin mashina nofaol holatga o‘tadi",
      noAvailableMachines: "Bo'sh chiqarish inkubatori yo'q",
      noSettings: "Chiqishga ko'chiriladigan inkubatsiya yo'q",
      notEnoughCapacity:
        "Bo'sh sig'im yetmaydi: {eggs} tuxum uchun {capacity} joy bor",
      lossesHint: "Setterdan chiqishda ko'ringan yo'qotishlarni kiriting.",
      lossesTitle: "Yo'qotishlar",
      receiptPercent: "Qabuldagi %",
      loadModalTitle: "Tuxumlarni chiqarish inkubatorlariga joylash",
      parkHint: "Bo'sh, band va buzuq chiqarish inkubatorlari holati.",
      parkTitle: "Chiqarish inkubatorlari",
      review: "Ko'chirish rejasi",
      searchSetting: "Inkubatsiya yoki partiya qidirish...",
      selectSetting: "Inkubatsiyani tanlang",
      selectSettingFirst: "Avval inkubatsiyani tanlang",
      selectSettingFirstHint:
        "Yuqoridagi maydondan inkubatsiyani tanlang, tuxum taqsimoti shu yerda avtomatik chiqadi.",
      selectTargetHatcher:
        "Ko‘chirish uchun bo‘sh chiqarish inkubatorini tanlang",
      serviceNeeded: "Servis kerak",
      setting: "Inkubatsiya",
      submit: "Chiqishga ko'chirish",
      targetHatcherUnavailable: "Bu chiqarish inkubatori bo‘sh emas",
      targetOverflow: "Tanlangan chiqarish inkubatori sig‘imidan oshib ketdi",
      transferCreated: "Chiqish boshqa chiqarish inkubatoriga ko'chirildi",
      transferEggs: "Joylanadigan tuxum",
      transferFailed: "Boshqa chiqarish inkubatoriga ko'chirib bo'lmadi",
      standard: "Standart #{id}",
      unfertilizedCount: "Urug‘lanmagan",
      earlyDeadEmbryoCount: "Tumak",
      rottenCount: "Chirigan",
    },
    dailyLogs: {
      add: "Qo'shish",
      avgHumidity: "O'rt. namlik",
      avgTemperature: "O'rt. harorat",
      created: "Log qo‘shildi",
      date: "Sana",
      deleted: "Log o'chirildi",
      deleteConfirmMessage:
        "{date} {time} dagi kunlik log o‘chiriladi. Davom etasizmi?",
      deleteConfirmTitle: "Logni o'chirish",
      deleteFailed: "Logni o'chirib bo'lmadi",
      eyebrow: "Kunlik nazorat",
      hatchingTitle: "Chiqish kunlik loglari",
      humidity: "Namlik",
      latest: "Oxirgi log",
      loadFailed: "Loglarni yuklab bo'lmadi",
      noLogs: "Bu jarayonda hali log yo‘q",
      noProcesses: "Kuzatiladigan jarayon yo‘q",
      process: "Jarayon",
      range: "Harorat oralig‘i",
      saveFailed: "Logni saqlab bo'lmadi",
      search: "Jarayon yoki partiya qidirish...",
      selected: "Tanlangan jarayon",
      selectProcessFirst: "Avval jarayonni tanlang",
      settingTitle: "Inkubatsiya kunlik loglari",
      temperature: "Harorat",
      time: "Vaqt",
      update: "Saqlash",
      updated: "Log yangilandi",
    },
    auth: {
      brandLabel: "Inter Agro",
      footer: "Fabrika boshqaruv paneli",
      invalidCredentials: "Login yoki parol noto'g'ri",
      password: "Parol",
      passwordPlaceholder: "Parolni kiriting",
      passwordRequired: "Parolni kiriting",
      showPassword: "Parolni ko'rsatish",
      hidePassword: "Parolni yashirish",
      signIn: "Kirish",
      username: "Login",
      usernamePlaceholder: "Loginni kiriting",
      usernameRequired: "Loginni kiriting",
      welcomeTitle: "Xush kelibsiz",
      errors: {
        generic: "Kirishda xatolik yuz berdi. Qayta urinib ko'ring.",
        network: "Serverga ulanib bo'lmadi. Internet aloqasini tekshiring.",
      },
      changePassword: {
        title: "Parolni almashtirish",
        subtitle: "Davom etish uchun yangi parol o'rnating.",
        forcedNotice:
          "Hisobingizga vaqtinchalik parol o'rnatilgan. Davom etishdan oldin uni almashtiring.",
        currentPassword: "Joriy parol",
        currentPlaceholder: "Joriy parolni kiriting",
        currentRequired: "Joriy parolni kiriting",
        newPassword: "Yangi parol",
        newPlaceholder: "Yangi parolni kiriting",
        newRequired: "Yangi parolni kiriting",
        confirmPassword: "Yangi parolni tasdiqlang",
        confirmPlaceholder: "Yangi parolni qayta kiriting",
        submit: "Parolni yangilash",
        success: "Parol muvaffaqiyatli almashtirildi",
        mismatch: "Parollar mos kelmadi",
        tooShort: "Parol kamida 8 ta belgidan iborat bo'lishi kerak",
        signOut: "Chiqish",
      },
    },
    admin: {
      users: {
        title: "Foydalanuvchilar",
        count: "{count} ta foydalanuvchi",
        search: "Foydalanuvchi qidirish...",
        empty: "Foydalanuvchilar topilmadi",
        createTitle: "Yangi foydalanuvchi",
        editTitle: "Foydalanuvchini tahrirlash",
        noRoles: "Rollar mavjud emas",
        markerOnlyWarning: "Bu rol yolg'iz o'zi hech qanday ruxsat bermaydi — foydalanuvchi hech bir sahifani ocholmaydi. Unga kamida bitta boshqa rol ham qo'shing.",
        passwordHint: "Kamida 8 ta belgi. Vaqtinchalik parol sifatida beriladi.",
        resetPasswordHint: "O'zgartirmaslik uchun bo'sh qoldiring",
        errors: {
          phoneInvalid: "Telefon raqami noto'g'ri. Format: +998 XX XXX XX XX",
        },
        deleteTitle: "Foydalanuvchini o'chirish",
        deleteMessage: "{name} o'chirilsinmi? Bu amalni orqaga qaytarib bo'lmaydi.",
        blockTitle: "Foydalanuvchini bloklash",
        blockMessage: "{name} bloklansinmi? Uning barcha sessiyalari bekor qilinadi.",
        unblockTitle: "Blokdan chiqarish",
        unblockMessage: "{name} blokdan chiqarilsinmi?",
        status: {
          active: "Faol",
          blocked: "Bloklangan",
        },
        actions: {
          create: "Foydalanuvchi qo'shish",
          edit: "Tahrirlash",
          delete: "O'chirish",
          block: "Bloklash",
          unblock: "Blokdan chiqarish",
          permissions: "Ruxsatlar",
        },
        fields: {
          user: "Foydalanuvchi",
          fullName: "To'liq ism",
          username: "Login",
          phone: "Telefon",
          password: "Parol",
          resetPassword: "Parolni tiklash",
          roles: "Rollar",
          status: "Holat",
          lastLogin: "Oxirgi kirish",
        },
        permissions: {
          title: "Ruxsatlar",
          search: "Ruxsat qidirish...",
          overrides: "{count} ta o'zgartirish",
          empty: "Hech narsa topilmadi",
          inherit: "Meros",
          allow: "Ruxsat",
          deny: "Taqiq",
          on: "Bor",
          off: "Yo'q",
          direct: "To'g'ridan-to'g'ri",
          superAdminNote: "Super-admin ruxsatlari avtomatik boshqariladi va o'zgartirilmaydi.",
        },
        detail: {
          subtitle: "Profil, ruxsatlar va hisob holati",
          back: "Foydalanuvchilarga qaytish",
          notFoundTitle: "Foydalanuvchi topilmadi",
          notFoundDescription: "Bu foydalanuvchi o'chirilgan yoki havola noto'g'ri bo'lishi mumkin.",
          tabs: {
            information: "Foydalanuvchi ma'lumotlari",
            roles: "Rollar",
            permissions: "Ruxsatlar",
          },
          aside: {
            memberSince: "Ro'yxatdan o'tgan",
            roles: "Rollar",
            permissions: "Ruxsatlar",
            effective: "{count} ta amal",
            noRoles: "Rol biriktirilmagan",
            disableAccount: "Hisobni o'chirish",
            enableAccount: "Hisobni faollashtirish",
          },
          information: {
            usernameHint: "Tizimga kirish uchun — foydalanuvchi xohlasa o'zgartirishi mumkin.",
            resetPasswordTitle: "Parolni tiklash",
            resetPasswordNote: "Administrator foydalanuvchiga yangi parol o'rnatadi.",
            setNewPassword: "Yangi parol o'rnatish",
            newPasswordPlaceholder: "Yangi parol",
            statusLabel: "Holat",
            statusNote: "Faol hisoblar tizimga kira oladi.",
            save: "O'zgarishlarni saqlash",
          },
          roles: {
            description: "Rol ruxsatlarni jamlaydi. {name} uchun rollarni bering yoki olib tashlang.",
            assigned: "Biriktirilgan rollar",
            available: "Mavjud rollar",
            grant: "Berish",
            revoke: "Olib tashlash",
            revokeTitle: "Rolni olib tashlash",
            revokeMessage: "{role} roli {name}dan olib tashlansinmi?",
            operationCount: "{count} ta amal",
            empty: "Hali rol biriktirilmagan.",
            allAssigned: "Barcha rollar biriktirilgan.",
            banner: "Rollar ruxsatlarni to'plam sifatida beradi. Alohida amallarni bu foydalanuvchi uchun Ruxsatlar bo'limida sozlang.",
          },
          permissions: {
            searchSections: "Bo'limlarni qidirish",
            banner: "Amallar {name} rollaridan keladi; bu yerda qo'shimcha bering yoki rol bergan amalni olib tashlang — o'zgarishlar faqat shu foydalanuvchiga taalluqli.",
            save: "O'zgarishlarni saqlash",
            empty: "Hech narsa topilmadi",
          },
        },
      },
      roles: {
        title: "Rollar",
        count: "{count} ta rol",
        search: "Rol qidirish...",
        empty: "Rollar topilmadi",
        createTitle: "Yangi rol",
        editTitle: "Rolni tahrirlash",
        codeHint: "masalan: sales_manager",
        operationCount: "{count} ta ruxsat",
        systemBadge: "Tizim roli",
        systemNames: {
          super_admin: "Super administrator",
          configuration_manager: "Sozlama boshqaruvchisi",
          access_manager: "Kirish boshqaruvchisi",
        },
        deleteTitle: "Rolni o'chirish",
        deleteMessage: "{name} roli o'chirilsinmi? U barcha egalaridan darhol olib tashlanadi.",
        actions: {
          create: "Rol qo'shish",
          edit: "Tahrirlash",
          delete: "O'chirish",
          permissions: "Ruxsatlar",
        },
        fields: {
          role: "Rol",
          name: "Nomi",
          code: "Kod",
          description: "Tavsif",
          operations: "Ruxsatlar",
        },
        operations: {
          title: "Rol ruxsatlari",
          searchSections: "Bo'limlarni qidirish",
          banner: "Bu yerda belgilangan amallar {name} roliga ega barcha foydalanuvchilarga tegishli bo'ladi.",
          save: "O'zgarishlarni saqlash",
          selectAll: "Hammasini tanlash",
          clearAll: "Tozalash",
          systemNote: "Tizim roli — ruxsatlari o'zgartirib bo'lmaydi.",
          empty: "Hech narsa topilmadi",
        },
        detail: {
          subtitle: "Rol ruxsatlarini sozlash",
          back: "Rollarga qaytish",
          notFoundTitle: "Rol topilmadi",
          notFoundDescription: "Bu rol o'chirilgan yoki havola noto'g'ri bo'lishi mumkin.",
          loadFailedTitle: "Ma'lumotni yuklab bo'lmadi",
          loadFailedDescription: "Rol ma'lumotlarini olishda xatolik yuz berdi. Qayta urinib ko'ring.",
          retry: "Qayta urinish",
        },
      },
    },
    noAccess: {
      title: "Ruxsat yo'q",
      message: "Sizda hech bir bo'limga ruxsat yo'q. Administrator bilan bog'laning.",
    },
    account: {
      title: "Mening profilim",
      personalInfo: "Shaxsiy ma'lumotlar",
      readOnlyNote: "Ma'lumotlaringizni administrator boshqaradi.",
      changePassword: "Parolni almashtirish",
      yourRoles: "Sizning rollaringiz",
      noRoles: "Rol biriktirilmagan",
      permissionCount: "{count} ta ruxsat",
      managedByAdmin: "Rollar va ruxsatlar administrator tomonidan boshqariladi.",
      signOut: "Chiqish",
      avatar: {
        change: "Rasmni o'zgartirish",
        upload: "Rasm yuklash",
        remove: "O'chirish",
        hint: "PNG yoki JPG, 10 MB gacha.",
        tooLarge: "Rasm hajmi 10 MB dan oshmasligi kerak.",
        invalidType: "Faqat rasm fayllari qabul qilinadi.",
        uploadFailed: "Rasmni yuklab bo'lmadi. Qaytadan urinib ko'ring.",
      },
      fields: {
        fullName: "To'liq ism",
        username: "Login",
        phone: "Telefon",
        memberSince: "Ro'yxatdan o'tgan",
        lastLogin: "Oxirgi kirish",
      },
    },
    dashboard: {
      eyebrow: "Fabrika boshqaruv paneli",
      periodLabel: "Davr tanlash",
      filters: {
        dateRange: "Davr",
        invalidRange: "Boshlanish sanasi tugash sanasidan keyin bo'lmasligi kerak.",
      },
      legend: {
        now: "hozirgi holat",
        notSettled: "hali yakunlanmagan",
      },
      now: {
        eyebrow: "HOZIR",
        scopeNote: "Filialning hozirgi holati — tanlangan davrga bog'liq emas.",
        updatedAt: "{time} da yangilandi",
        refresh: "Yangilash",
        never: "hali yangilanmagan",
      },
      period: {
        eyebrow: "DAVR",
        scopeNote: "Quyidagi bo'limlar {range} davri uchun.",
        emptyHint: "Bu davrda partiya qabul qilinmagan. Davrni kengaytirib ko'ring.",
        receivedHelper: "davrda qabul qilingan",
      },
      metrics: {
        batchCount: "Partiyalar",
        eggsInSetting: "Inkubatsiyada",
        eggsInHatching: "Chiqarishda",
        inProduction: "hali ishlab chiqarishda",
      },
      floor: {
        title: "Mashinalar to'ldirilishi",
        type: {
          SETTER: "Inkubator",
          HATCHER: "Chiqarish shkafi",
        },
        free: "bo'sh",
        loaded: "yuklangan",
        broken: "nosoz",
        capacityNote: "Sig'imga nosoz mashinalar ham kiradi, shuning uchun bo'sh joy ko'rsatilganidan kamroq bo'lishi mumkin.",
        noMachines: "Bu turdagi mashina yo'q",
        noneRegistered: "Bu filialda inkubator mashinalari ro'yxatga olinmagan",
        machineCount: "{count} mashina",
        eggsOfCapacity: "{loaded} / {capacity} tuxum",
      },
      attention: {
        title: "Diqqat talab qiladi",
        brokenMachines: "Nosoz mashinalar",
        readyToTransfer: "Chiqarishga o'tkazishga tayyor",
        readyToComplete: "Yakunlashga tayyor",
        unsortedBatches: "Saralanmagan partiyalar",
        goSorting: "Saralashga o'tish",
        goHatching: "Chiqarishga o'tish",
        more: "yana {count} ta",
        groupClear: "Bo'sh",
        allClear: "Hozircha e'tibor talab qiladigan narsa yo'q",
      },
      journey: {
        title: "Tuxum yo'li",
        subtitle: "Davrda qabul qilingan tuxumlar hozir qayerda.",
        stage: {
          RECEIVED: "Qabul qilindi",
          AFTER_SORTING: "Saralashdan keyin",
          SET: "Inkubatorga yuklandi",
          MOVED_TO_HATCHER: "Chiqarish shkafiga o'tkazildi",
          CHICKS: "Joja",
        },
        lost: "yo'qotildi",
        gap: {
          sorting: "hali saralanmagan",
          loading: "hali yuklanmagan",
          transfer: "hali o'tkazilmagan",
          hatch: "hali chiqmagan",
        },
        unattributed: "farq taqsimlanmadi",
        settled: "Davr yopiq — barcha partiyalar chiqib bo'lgan",
        open: "{count} dona hali jarayonda",
        lossLink: "Qayd etilgan yo'qotishlarning to'liq daftari quyida",
        emptyTitle: "Bu davrda qabul qilingan partiya yo'q",
        emptyDescription: "Davrni kengaytiring yoki boshqa filialni tanlang.",
        noEggs: "Davrdagi partiyalarda tuxum qayd etilmagan",
        stageCount: "{count} bosqich",
        scaleNote: "Har bir qator kengligi qabul qilingan hajmga nisbatan",
        legend: {
          stage: "bosqichda",
          inFlight: "hali jarayonda",
        },
      },
      lossSteps: {
        title: "Yo'qotishlar daftari",
        subtitle: "Qayd etilgan yo'qotishlar sabablari bo'yicha.",
        step: {
          BROKEN: "Siniq",
          DEFECTED: "Yaroqsiz",
          UNFERTILIZED: "Urug'lanmagan",
          EARLY_DEAD_EMBRYO: "Erta nobud embrion",
          UNHATCHED: "Chiqmagan",
        },
        stage: {
          ARRIVAL: "Qabul",
          INCUBATION: "Inkubatsiya",
          HATCHING: "Chiqarish",
        },
        total: "Jami yo'qotish",
        none: "Bu davrda yo'qotish qayd etilmagan",
        reasonCount: "{count} sabab",
        opacityNote: "Rang to'yinganligi bosqichni bildiradi",
      },
      suppliers: {
        title: "Yetkazib beruvchilar",
        subtitle: "Har bir yetkazib beruvchi o'z katalog prognozi bilan solishtiriladi.",
        name: "Yetkazib beruvchi",
        batches: "{count} partiya",
        eggs: "Tuxum",
        expected: "Kutilgan %",
        actual: "Haqiqiy %",
        variance: "Farq",
        lossRate: "Yo'qotish %",
        // Was "f.p.", then "punkt" — both unexplained abbreviations that told the reader nothing.
        // The chip now carries the one symbol every locale reads identically, and the sentence keys
        // below carry the actual claim into the tooltip and the accessible name. Wording matches
        // `standardEfficiency.belowExpected`, which has said "kutilgandan ... past" all along.
        pointsSuffix: "%",
        pointsAbove: "Kutilgandan {value} foiz yuqori",
        pointsBelow: "Kutilgandan {value} foiz past",
        pointsEqual: "Kutilgan daraja bilan bir xil",
        stillInProduction: "partiyalar hali chiqib bo'lmagan",
        empty: "Bu davrda yetkazib berish bo'lmagan",
        sortNote: "eng yomondan boshlab tartiblangan",
      },
      chicks: {
        title: "Jo'ja natijalari",
        cardSubtitle: "Sifat bo'yicha",
        firstGrade: "1-nav",
        secondGrade: "2-nav",
        thirdGrade: "3-nav",
        gradeCount: "{count} nav",
        total: "Jami",
        unit: "joja",
        empty: "Bu davrda jo'ja natijalari yo'q",
      },
      standardEfficiency: {
        eyebrow: "Standartlar bo'yicha samaradorlik",
        title: "Kutilgan va haqiqiy chiqish foizi",
        subtitle: "Har bir tuxum standarti uchun prognoz va natija solishtiriladi.",
        expected: "Kutilgan",
        actual: "Haqiqiy",
        empty: "Bu davrda standartlar bo'yicha chiqish ma'lumoti yo'q",
        aboveExpected: "Kutilgandan {value} foiz yuqori",
        belowExpected: "Kutilgandan {value} foiz past",
        onExpected: "Kutilgan bilan teng",
        countBadge: "{count} nasl",
      },
      batches: {
        title: "Partiyalar performansi",
        eyebrow: "Oxirgi partiyalar",
        subtitle: "Davrda qabul qilingan barcha partiyalar, eng eskisidan boshlab.",
        emptyTitle: "Partiya natijalari hali yo'q",
        name: "Partiya",
        receivedDate: "Qabul sanasi",
        tableNote: "Davrda qabul qilingan barcha partiyalar, eng eskisidan boshlab.",
      },
      table: {
        totalEggs: "Jami",
        chicks: "Joja",
        lossRate: "Yo'qotish",
        remaining: "Qolgan",
        hatchability: "Chiqish foizi",
      },
      state: {
        loadFailed: "Bu bo'limni yuklab bo'lmadi",
      },
      finance: {
        title: "Daromad va xarajatlar",
      },
      title: "Inkubatsiya boshqaruvi",
      tagline: "Fabrika bo'yicha jonli holat va tanlangan davr natijalari",
      kpi: {
        eggsReceived: "Qabul qilingan tuxum",
        eggUnit: "dona",
        chicks: "Joja",
        chickUnit: "dona chiqdi",
        hatchRate: "Chiqish foizi",
        hatchRateHelper: "qabul qilinganga nisbatan",
        loss: "Yo'qotish",
        lossHelper: "{count} dona qayd etilgan",
        inFlight: "Hali jarayonda",
        inFlightHelper: "dona natija kutilmoqda",
      },
      cards: {
        live: "Jonli",
        liveNow: "Jonli · hozir",
        periodHelper: "tanlangan davrda",
        liveHelper: "joriy holat · sana bo'yicha emas",
        kpi: {
          batchesReceived: "Qabul qilingan partiyalar",
          totalEggs: "Jami tuxum",
          eggsInIncubation: "Inkubatsiyadagi tuxum",
          eggsInHatchers: "Chiqishdagi tuxum",
        },
        attention: {
          headline: "{count} ta e'tibor talab qiladi",
          brokenCount: "{count} buzuq",
          batchCount: "{count} partiya",
          view: "Ko'rish",
          resolve: "Hal qilish",
          expand: "Ro'yxatni ochish",
          collapse: "Ro'yxatni yopish",
          tag: {
            broken: "Buzuq mashina",
            unsorted: "Saralanmagan",
            transfer: "O'tkazish",
            complete: "Yakunlash",
          },
          detail: {
            unsorted: "Hali saralanmagan",
            transfer: "Chiqarishga o'tkazishga tayyor",
            complete: "Yakunlashga tayyor",
          },
        },
        funnel: {
          title: "Voronka",
          dropped: "kamaydi {count}",
          summaryOpen: "Hozircha {percent} jo'ja · {count} dona hali jarayonda",
          summarySettled: "Davr yopiq — qabul qilinganning {percent} i jo'ja bo'ldi",
          summaryPlain: "Qabul qilinganning {percent} i jo'ja bo'ldi",
        },
        losses: {
          title: "Yo'qotishlar",
          total: "Jami yo'qotish",
          topStage: "Yo'qotishlarning {share} i {stage} bosqichida",
          eggShare: "{value} — qabul qilingan tuxumga nisbatan",
        },
        chicks: {
          hatched: "jo'ja chiqdi",
          expected: "Kutilgan",
          actual: "Haqiqiy",
          hatchRate: "Chiqish foizi",
        },
        machines: {
          title: "Mashinalar",
          setters: "Inkubatsiya mashinalari",
          hatchers: "Chiqarish mashinalari",
          unitCount: "{count} ta",
          free: "Bo'sh {count}",
          loaded: "Yuklangan {count}",
          broken: "Buzuq {count}",
          capacityLine: "Sig'im {capacity} · Yuklangan {loaded}",
          occupancy: "Bandlik",
        },
        standards: {
          title: "Standart bo'yicha samaradorlik",
          subtitle: "Kutilgan va haqiqiy chiqish",
          rowMeta: "{eggs} tuxum · {chicks} jo'ja",
          variance: "Farq {value}",
        },
        suppliers: {
          title: "Yetkazib beruvchilar samaradorligi",
          subtitle: "Eng yomon farq birinchi",
          batchesShort: "Partiya",
        },
      },
    },
    // The hatched-chick correction dialog (BatchGradesModal), opened from the batch page and the sales plan.
    batchGrades: {
      action: "Tahrirlash",
      title: "Chiqqan jo'jalar sonini tuzatish",
      subtitle: "Har bir tuxum standarti bo'yicha 1, 2 va 3-nav jo'jalar soni. Chiqmagan — chiqarilgan tuxumdan navlarga kirmagani.",
      standard: "Standart",
      hatchedOut: "Chiqarilgan tuxum",
      total: "Jami",
      notHatchedOut: "Chiqish hali yakunlanmagan",
      hint: "1-nav jami — sotuvdagi chiqqan jo'jalar soni.",
    },
    eggBatches: {
      accepted: "Qabul",
      active: "Faol",
      addRow: "Qo'shish",
      allocationResults: "Taqsimot va natijalar",
      all: "Hammasi",
      averageLoss: "O'rt. yo'qotish",
      back: "Ortga",
      batch: "Partiya",
      batchName: "Partiya nomi",
      batchNamePlaceholder: "Masalan: Partiya-2026-012",
      batchNameRequired: "Partiya nomini kiriting.",
      age: "Yoshi",
      category: "Kategoriya",
      categoryAge: "Kategoriya / yosh",
      completed: "Tugatildi",
      date: "Sana",
      delete: "O'chirish",
      deleteBatchDescription:
        '"{name}" partiyasi o‘chiriladi. Bu amalni qaytarib bo‘lmaydi.',
      deleteBatchTitle: "Partiyani o‘chirish",
      distribution: "Tuxum taqsimoti",
      edit: "Tahrirlash",
      editBatch: "Partiyani tahrirlash",
      gradesAfterHatchOut: "Navlar chiqish yakunlangandan keyin kiritiladi",
      eggCount: "Tuxum soni",
      eggCountRequired: "Tuxum sonini kiriting",
      eggUnit: "tuxum",
      emptyData: "Ma'lumot yo'q",
      actualEggs: "Haqiqiy",
      availableEggs: "Mavjud",
      orderedEggs: "Buyurtmada",
      expectedChicks: "Kutilayotgan jo'jalar",
      expectedEggs: "Kutilgan",
      expectedHatchDate: "Kutilgan chiqish",
      filter: "Holat",
      forecastChicks: "Prognoz jo'ja",
      flowEmptyLane: "Bu bosqichda jarayon yo'q",
      flowHatchingTitle: "Chiqish",
      flowHatchingSubtitle: "Chiqarish inkubatoridagi yakuniy bosqich",
      flowRecords: "qayd",
      flowSettingTitle: "Inkubatsiya",
      flowSettingSubtitle: "Setter mashinasidagi asosiy jarayon",
      flowSettingEmptyTitle: "Inkubatsiya hali boshlanmagan",
      flowSettingEmptyDescription:
        "Partiya inkubatsiya mashinasiga joylashtirilganda jarayon, mashina va tuxum taqsimoti shu yerda ko'rinadi.",
      flowHatchingEmptyTitle: "Chiqish hali boshlanmagan",
      flowHatchingEmptyBeforeSetting:
        "Avval partiyani inkubatsiyaga joylashtiring, keyin chiqish bosqichi ochiladi.",
      flowHatchingEmptyAfterSetting:
        "Inkubatsiya yakunlangach tuxumlar chiqarish inkubatoriga ko'chiriladi va shu yerda chiqish jarayoni ko'rinadi.",
      flowMetricSettingEggs: "Inkubatsiyadagi tuxum",
      flowMetricHatchingEggs: "Chiqishdagi tuxum",
      flowMetricProcessCount: "{count} ta jarayon qaydi",
      flowMetricForecastHelper: "normativ bo‘yicha",
      flowProgressReady: "Boshlashga tayyor",
      flowProgressDay: "{current}/{total}-kun",
      flowProgressMovedToHatching: "Chiqishga ko'chirilgan",
      flowProgressMovedToSetter: "Boshqa setterga ko'chirilgan",
      flowProgressMovedToHatcher: "Boshqa chiqarish inkubatoriga ko'chirilgan",
      flowProgressCompleted: "Yakunlangan",
      flowTitle: "Jarayon oqimi",
      formNeedsAttention: "To'ldirilmagan joylar bor",
      formNotFound: "Partiya topilmadi",
      formNotFoundDescription:
        "Tanlangan partiya mavjud emas yoki o'chirilgan.",
      formReady: "Saqlashga tayyor",
      free: "bo'sh",
      fullyReserved: "To'liq band",
      gradesExceedHatchedOut: "1, 2 va 3-nav jami chiqarilgan tuxumdan ({count}) oshmasin",
      hatchingStage: "Chiqish",
      hatchability: "Chiqish",
      hatchingEnteredEggs: "Chiqishga kirgan",
      incubationEggs: "Inkubatsiyaga kiradi",
      incubationStatus: "Inkubatsiyada",
      lossAccounting: "Yo'qotishlar hisobi",
      lossDetails: "Yo'qotishlar",
      newBatch: "Partiyani qabul qilish",
      due: {
        title: "Bugun qabul qilinadi",
        today: "Bugun keladi",
        late: "{count} kun kechikdi",
        badge: "Kechikkan: {overdue} · Bugun: {today}",
        receive: "Qabul qilish",
      },
      deliveries: {
        searchPlaceholder: "Partiya yoki ta'minotchi bo'yicha qidiring",
        allMonths: "Barcha oylar",
        columns: {
          delivery: "Partiya",
          supplier: "Ta'minotchi",
          arrivalDate: "Kelish sanasi",
          eggs: "Tuxum",
          status: "Holat",
        },
        pending: "Kutilmoqda",
        emptyTitle: "Rejalashtirilgan partiya yo'q",
        emptyDescription:
          "Bu filial uchun yetkazib berish rejalashtirilmagan. Partiyalar sotuv bo'limining rejasidan qabul qilinadi.",
        emptyFilteredTitle: "Partiya topilmadi",
        emptyFiltered: "Boshqa oyni tanlang yoki qidiruvni o'zgartiring.",
        missingTitle: "Reja topilmadi",
        missingDescription:
          "Partiya faqat sotuv bo'limining rejasidan qabul qilinadi. Bu reja boshqa filialga tegishli yoki o'chirilgan.",
        receivedTitle: "Partiya allaqachon qabul qilingan",
        receivedDescription:
          "Bu yetkazib berish inkubatsiyaga qabul qilingan — uni ikkinchi marta qabul qilib bo'lmaydi. Ma'lumotlarni partiya sahifasida ko'ring.",
      },
      plan: {
        title: "Sotuv rejasi",
        arrival: "Kelish sanasi",
        eggs: "Reja bo'yicha tuxum",
        chicks: "Reja bo'yicha jo'ja",
        difference: "Rejadan farqi",
        matches: "Reja bilan mos",
        more: "Rejadan {count} ta ko'p",
        less: "Rejadan {count} ta kam",
        rowHint: "{category} · reja {count}",
      },
      netEggs: "Inkubatsiyaga kirgan",
      normativeStandard: "Normativ standart",
      normativeStandardRequired: "Normativ standartni tanlang",
      outputPercent: "Chiqish %",
      standardPercent: "Standart %",
      specialistPercent: "Mutaxassis %",
      hatchPercentRequired: "Foizni kiriting (0–100)",
      processData: "Jarayon ma'lumotlari",
      receivingDetails: "Qabul ma'lumotlari",
      receivingTemperature: "Temperatura",
      receivingInfo: "Qabul ma'lumoti",
      remaining: "qoldiq",
      reserved: "band",
      salesCapacity: "Sotuv sig’imi",
      salesProcess: "Sotuv jarayoni",
      save: "Saqlash",
      saving: "Saqlanmoqda...",
      search: "Partiya yoki yetkazib beruvchi bo'yicha qidirish...",
      sold: "Sotildi",
      standards: "Standartlar",
      supplier: "Yetkazib beruvchi",
      supplierPlaceholder: "Masalan: Agromir LLC",
      supplierRequired: "Yetkazib beruvchini tanlang.",
      temperature: "Harorat",
      temperatureInfo: "Temperatura ma'lumoti",
      total: "jami",
      totalEggs: "Jami tuxum",
      totalExpectedChicks: "Jami kutilgan jo'ja",
      totalLoss: "Jami yo'qotish",
      transport: "Transport ma'lumotlari",
      vehiclePlate: "Mashina raqami",
      vehiclePlatePlaceholder: "01 A 777 AA",
      vehiclePlateRequired: "Mashina raqamini kiriting.",
      vehiclePlateIncomplete: "Raqamni to'liq kiriting: 01 A 777 AA yoki 01 777 AAA.",
      driver: "Haydovchi",
      driverPlaceholder: "Haydovchi F.I.Sh.",
      driverRequired: "Haydovchi F.I.Sh. kiriting.",
      brokenCount: "Singan",
      defectedCount: "Yaroqsiz",
      roadLoss: "Yo'ldagi yo'qotish",
      unloadingLoss: "Tushirishdagi yo‘qotish",
      sortingRejected: "Yaroqsiz",
      sortingLoss: "Saralashdagi yo‘qotish",
      outsideTemperature: "Tashqaridagi harorat",
      vehicleTemperature: "Mashina harorati",
      eggTemperature: "Tuxum harorati",
      roomTemperature: "Xona harorati",
      warehouseTemperature: "Ombor harorati",
      temperatureRequired: "Haroratni kiriting.",
      weekShort: "hafta",
      viewOrders: "Buyurtmalarni ko'rish",
      ordersPanelTitle: "Partiya buyurtmalari",
      ordersPanelSubtitle:
        "Bu partiya bo'yicha buyurtmalar yaratilganda shu yerda ko'rinadi.",
      usedByOrders: "Buyurtmalarda band",
      canAcceptOrders: "Buyurtma qabul qiladi",
      closedForOrders: "Buyurtmaga yopiq",
      noOrdersForBatch: "Bu partiyada buyurtma yo'q",
      validationDistribution:
        "Kamida bitta to’ldirilgan taqsimot qatori kerak.",
      validationNegativeNumber: "Qiymatlar manfiy bo’lishi mumkin emas.",
      validationLossTooHigh: "Yo’qotishlar jami tuxumdan oshib ketdi.",
      statusReceived: "Qabul qilingan",
      statusReadyToHatching: "Chiqishga tayyor",
      statusHatching: "Chiqishda",
      statusReadyToComplete: "Yakunlashga tayyor",
      statusCompleted: "Yakunlangan",
    },
    modules: {
      eggBatches: {
        title: "Partiyalar moduli",
        description:
          "Partiyalar ro‘yxati, qabul formasi va tafsilotlari backend v2 maydonlari bilan ishlaydi.",
      },
      incubations: {
        title: "Inkubatsiya moduli",
        description:
          "Inkubatsiya va chiqish workflowlari v2 setting/hatching jarayonlariga ulangan.",
      },
      orders: {
        title: "Buyurtmalar moduli",
        description:
          "Mockupdagi order pipeline ni keyingi iteratsiyada real komponentlar va validatsiyali formalar bilan yig'amiz.",
      },
      settings: {
        title: "Sozlamalar moduli",
        description:
          "Inkubatorlar, sig’imlar va normativ standartlar uchun alohida maintainable settings slices shu yerga joylashadi.",
      },
    },
  },
  en: {
    app: {
      name: "InterAgro ERP",
      descriptor: "Interagro Hatchery",
      search: "Search...",
      openMenu: "Open menu",
      screenshot: {
        idle: "Screenshot",
        hint: "Copies a picture of the screen — paste it into Telegram",
        busy: "Preparing",
        copied: "Copied",
        downloaded: "Downloaded",
        failed: "Couldn't take it",
      },
      collapseMenu: "Collapse menu",
      expandMenu: "Expand menu",
      navigationLabel: "Main navigation",
      darkTheme: "Dark theme",
      lightTheme: "Light theme",
      logout: "Log out",
      logoutDescription: "You will be signed out of your account. Continue?",
      logoutTitle: "Log out",
      notifications: "Notifications",
      help: "Help",
      roleInspector: "Inspector",
      roleAdmin: "Administrator",
      roleSuperAdmin: "Super administrator",
      roleSalesManager: "Sales manager",
    },
    nav: {
      dashboard: "Dashboard",
      salesDashboard: "Sales panel",
      orders: "Orders",
      hatchCalendar: "Hatch calendar",
      customers: "Customers",
      payments: "Receipts",
      debtors: "Debtors",
      creditors: "Creditors",
      reminders: "Reminders",
      expenses: "Expenses",
      eggBatches: "Batches",
      plannedBatches: "Batches",
      pricing: "Prices",
      competitors: "Competitors",
      receiving: "Receiving",
      sorting: "Sorting",
      incubations: "Incubation",
      settingFlow: "Incubation",
      hatchingFlow: "Hatching",
      branchOrders: "Orders",
      settings: "Settings",
      branches: "Branches",
      suppliers: "Suppliers",
      incubationMachines: "Incubation machines",
      eggStandards: "Egg standards",
      vaccines: "Vaccines",
      users: "Users",
      roles: "Roles",
      sections: {
        sales: "Sales",
        incubation: "Incubation",
        finance: "Finance",
        settings: "Settings",
        administration: "Administration",
      },
    },
    branchOrders: {
      searchPlaceholder: "Search by customer, phone or batch",
      scopeLabel: "Orders",
      scope: { active: "To hand out", history: "History" },
      dueTitle: "To hand out today",
      today: "Today",
      late: "{count} days late",
      totalChicks: "{count} chicks in all",
      columns: {
        customer: "Customer",
        chicks: "Chicks",
        vaccines: "Vaccines",
        handover: "Handover",
        payment: "Payment",
        status: "Status",
      },
      handoverKind: { pickup: "Customer collects", delivery: "Delivered" },
      noVaccines: "No vaccines",
      handOver: "Handed over",
      handOverTitle: "Hand the order over",
      handOverMessage:
        "Has {customer} taken the {count} chicks? The order is completed, the customer is told on Telegram, and this cannot be undone.",
      emptyTitle: "Nothing to hand out",
      emptyDescription: "When the sales department takes orders on this branch's deliveries, they appear here by hatch day.",
      emptyHistoryTitle: "No history yet",
      emptyHistoryDescription: "Handed-over and cancelled orders are kept here.",
      emptyFilteredTitle: "No order found",
      emptyFiltered: "Try a different search.",
    },
    sorting: {
      title: "Egg sorting",
      subtitle: "Sort accepted batches before placing them into incubation.",
      refresh: "Refresh",
      acceptedBatches: "Accepted batches",
      acceptedTitle: "Batches to sort",
      unsortedEggs: "Unsorted eggs",
      sortedUnsetted: "Sorted unplaced",
      sortedUnsettedTitle: "Batches ready for incubation",
      batch: "Batch",
      category: "Category",
      selectBatch: "Select batch",
      selectBatchFirst: "Select a batch first",
      selectCategory: "Select category",
      noUnsortedCategories: "Nothing left to sort in this batch",
      noAcceptedBatches: "No batches to sort",
      noSortedUnsetted: "No batches ready for incubation",
      tableTitle: "Added sorting rows",
      noTableRows: "No sorting rows added yet",
      eggStandardId: "Standard #{id}",
      netEggs: "Placeable",
      add: "Add",
      edit: "Edit",
      update: "Update",
      saveSorting: "Save sorting",
      lossCannotExceedEggs: "Loss count cannot exceed egg count",
    },
    regions: {
      ANDIJON: "Andijan",
      BUXORO: "Bukhara",
      FARGONA: "Fergana",
      JIZZAX: "Jizzakh",
      QASHQADARYO: "Qashqadaryo",
      NAMANGAN: "Namangan",
      NAVOIY: "Navoi",
      SAMARQAND: "Samarkand",
      SIRDARYO: "Sirdaryo",
      SURXONDARYO: "Surxondaryo",
      TOSHKENT_VILOYATI: "Tashkent region",
      XORAZM: "Khorezm",
      TOSHKENT_SHAHRI: "Tashkent city",
      QORAQALPOGISTON: "Karakalpakstan",
    },
    salesDashboard: {
      title: "Sales panel",
      emptyHint: "Try a different period.",
      kpi: {
        orders: "Orders",
        chicks: "Chicks sold",
        chicksBonus: "+{count} bonus",
        received: "Revenue",
        outstanding: "Expected payments",
        debt: "Debt",
        compensation: "Loss compensation",
      },
      orders: {
        title: "Order status",
        columns: {
          status: "Status",
          orders: "Orders",
          chicks: "Chicks",
          collected: "Paid",
        },
        categoryTitle: "By weight",
        empty: "No orders in this period.",
      },
      payments: {
        title: "Payment methods",
        received: "Money received",
        fromWallet: "Paid from wallets",
        refunded: "Refunded",
        transactions: "transactions",
        transactionsBadge: "{count} transactions",
        columns: {
          method: "Method",
          amount: "Amount",
          share: "Share",
          transactions: "Transactions",
        },
        empty: "No payments received in this period.",
      },
      customers: {
        title: "Top customers",
        columns: {
          customer: "Customer",
          type: "Tier",
          region: "Region",
          orders: "Orders",
          chicks: "Chicks",
          collected: "Paid",
          balance: "Balance",
        },
        empty: "No customer ordered in this period.",
      },
      regions: {
        title: "Regions",
        columns: {
          region: "Region",
          registered: "Registered",
          orders: "Orders",
          chicks: "Chicks",
          collected: "Paid",
        },
        empty: "No region data.",
      },
      managers: {
        title: "Managers",
        columns: {
          manager: "Manager",
          orders: "Orders",
          booked: "Booked",
          collected: "Paid",
        },
        unattributed: "Unattributed",
        unattributedHint: "Orders created before author tracking existed.",
        empty: "No orders were created in this period.",
      },
    },
    pricing: {
      subtitle: "Competitor prices and our weekly rounds",
      newSurvey: "New price round",
      unit: "per chick, UZS",
      weekday: {
        0: "Sunday",
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday",
      },
      current: {
        title: "Current price",
        inForce: "In force",
        meta: "{date} · set by {name}",
        metaNoName: "{date}",
      },
      market: {
        title: "Competitor prices",
        watchList: "Watch list",
      },
      chart: {
        title: "Price dynamics",
        subtitle: "Our price, by round · UZS",
      },
      table: {
        title: "Price rounds",
        history: "Price history",
        subtitle: "Each round — the market and our price on that day",
        count: "{count} rounds",
        date: "Date",
      },
      diff: {
        below: "below average",
        above: "above average",
        equal: "equal to average",
        noData: "no data",
      },
      movement: {
        period: "Period",
        allTime: "All history",
        emptyRange: "No rounds in this period",
      },
      history: {
        title: "Competitor prices",
        neverQuotedClass: "No price quoted for this class",
        chartTitle: "Price dynamics",
        tableTitle: "Prices by round",
      },
      empty: {
        title: "No price rounds yet",
        description:
          "After calling the competitors, enter the first round — the market and our price are saved on one date.",
        action: "Enter the first round",
      },
      detail: {
        title: "Price round",
        quotedMeta: "{count} competitors surveyed",
        createdBy: "entered by {name}",
        edit: "Edit",
        quotesTitle: "Who quoted what",
        quotesSubtitle: "Each cell — the price quoted by phone that day",
        noQuotes: "No competitor prices were entered in this round.",
        market: "Market",
        lowest: "lowest",
        average: "average",
        highest: "highest",
        quotedCount: "{count} competitors",
        quotedCountFull: "{count} competitors quoted a price for this class",
        notQuoted: "—",
        marketAverage: "Market average",
        marketLowest: "Lowest price",
        marketHighest: "Highest price",
        noMarketData: "Nobody quoted a price for this class — there is no market figure to compare against.",
        ourPrice: "Our price",
        ourPriceSet: "The price we set in this round, and where it sits against the market",
        note: "Note",
      },
      form: {
        newTitle: "New price round",
        editTitle: "Edit round",
        subtitle: "Enter the competitors' prices, then set ours",
        date: "Date",
        note: "Note",
        optional: "— optional",
        notePlaceholder: "E.g.: egg prices went up at the market",
        quotesTitle: "Competitor prices",
        quotesSubtitle: "An empty cell means no quote that day",
        removeRow: "Remove row",
        readdPlaceholder: "Restore a row...",
        statsHint: "lowest · average · highest",
        emptyRows: "The competitor list is empty",
        emptyRowsHint: "Add who you survey on the Competitors screen and their prices will be asked here.",
        ourTitle: "Our price",
        ourSubtitle: "Takes effect this week · all three cells required",
        decision: "Decision",
        priceMissing: "price not entered",
        noCompare: "nothing to compare against",
        belowAvg: "{amount} UZS below average",
        aboveAvg: "{amount} UZS above average",
        equalAvg: "equal to average",
        ready: "Ready to save",
        incomplete: "Our price is incomplete — {list} missing",
      },
      competitors: {
        subtitle: "The hatcheries surveyed in every round",
        add: "Add competitor",
        listTitle: "Watch list",
        name: "Competitor",
        phones: "Phone",
        note: "Note",
        lastPrice: "Last price",
        actions: "Actions",
        noNote: "— no note",
        hide: "Hide",
        edit: "Edit",
        hint: "Hiding a competitor stops asking about them in new rounds. Past rounds keep their name and prices.",
        hideTitle: "Hide {name} from the list?",
        hideMessage:
          "Their price won't be asked in future rounds. Past rounds keep their name and quotes — reports stay intact.",
        empty: {
          title: "No competitors watched",
          description:
            "Add the hatcheries you survey to this list. Their prices will then be asked in every round.",
          action: "Add the first competitor",
        },
        modal: {
          newTitle: "New competitor",
          editTitle: "Edit competitor",
          name: "Name",
          namePlaceholder: "E.g.: Piskent Parranda",
          phones: "Phone numbers",
          phonePlaceholder: "+998 90 123 45 67",
          addPhone: "Add another number",
          removePhone: "Remove number",
          phoneInvalid: "Enter the phone number in full",
          note: "Note",
          notePlaceholder: "Who to talk to, how they price...",
          nameRequired: "Name is required",
        },
      },
    },
    plannedBatches: {
      searchPlaceholder: "Search batches...",
      allBranches: "All branches",
      allMonths: "All months",
      newPlan: "New batch",
      emptyDay: "No batch",
      showOrders: "Show orders",
      hideOrders: "Hide orders",
      status: {
        PLANNED: "Expected",
        RECEIVED: "Received",
        HATCHED: "Hatched",
      },
      back: "Back",
      unit: "pcs",
      emptyTitle: "No batches yet",
      emptyDescription:
        "When a supplier sends its delivery schedule, book it here — orders sell from these batches.",
      emptyFilteredTitle: "No matching batch",
      emptyFiltered: "Change the search, the month or the branch filter.",
      deleteTitle: "Delete batch",
      deleteMessage:
        "\"{name}\" will be deleted. If orders still sell from it, move them to another batch first.",
      columns: {
        plan: "Batch",
        supplier: "Supplier",
        branch: "Branch",
        arrivalDate: "Arrival",
        hatchDate: "Hatch date",
        totalEggs: "Eggs",
        orderedChicks: "Ordered chicks",
        availableChicks: "Available for sale",
        chickCount: "Chicks",
      },
      detail: {
        eggs: "Total eggs",
        ordered: "Ordered chicks",
        remaining: "Available for sale",
        occupancy: "Occupancy",
        chicks: {
          PLANNED: "Expected chicks",
          RECEIVED: "Expected chicks",
          HATCHED: "Hatched chicks",
        },
        chicksFromReceipt: "as received",
        chicksFirstGrade: "1st grade",
        receivedOn: "Received: {date}",
        enteredBy: "Entered by {name}",
        plannedEggs: "planned: {count}",
        notReceived: "No eggs yet — every figure here is the plan's.",
        journey: {
          title: "Batch journey",
          set: "In setters",
          hatcher: "In hatchers",
          now: "Now",
          expected: "Due {date}",
          eggs: "{count} eggs",
          chicks: "{count} chicks · 1st grade",
          otherGrades: "2nd {second} · 3rd {third}",
          lossSorting: "−{count} broken, defective",
          lossCandling: "−{count} unfertilized, early dead",
          lossUnhatched: "−{count} unhatched",
          totalLosses: "Total lost:",
        },
        byWeight: {
          title: "By weight",
          weight: "Weight",
          expected: "Expected",
          hatched: "Hatched · 1st grade",
          ordered: "Ordered",
          remaining: "Left",
        },
        orders: "Orders",
        noOrders: "No order is booked against this batch yet.",
        customerNo: "Customer #{id}",
        orderColumns: {
          customer: "Customer",
          orderedCount: "Ordered",
          bonus: "Bonus",
          dealPrice: "Agreed price",
          services: "Services",
          amount: "Total amount",
          debt: "Debt",
          status: "Status",
        },
      },
      form: {
        newTitle: "New batch",
        editTitle: "Edit batch",
        basicsTitle: "Basics",
        hatchDate: "Hatch date",
        hatchDatePlaceholder: "Set from the arrival date",
        supplier: "Supplier",
        supplierPlaceholder: "Select a supplier",
        branch: "Branch",
        branchPlaceholder: "Select a branch",
        arrivalDate: "Arrival date",
        categoriesTitle: "Egg categories",
        category: "Category",
        categoryPlaceholder: "Select",
        eggCount: "Egg count",
        hatchPercent: "Hatch %",
        expectedChicks: "Expected chicks",
        addCategory: "Add category",
        totalEggs: "Total eggs",
        totalExpectedChicks: "Total expected chicks",
        state: { saving: "Saving" },
        save: "Save batch",
        notFound: "Batch not found",
        notFoundDescription: "This batch was deleted or never existed.",
        lockedTitle: "Batch received",
        lockedDescription: "The hatchery has received this batch — it can no longer be changed.",
        errors: {
          supplier: "Select a supplier.",
          branch: "Select a branch.",
          arrivalDate: "Select an arrival date.",
          category: "Enter a category code.",
          eggCount: "Egg count must be greater than 0.",
          hatchPercent: "Hatch percent must be between 1 and 100.",
          categoriesRequired: "Add at least one category.",
        },
      },
    },
    salesBatches: {
      searchPlaceholder: "Search batch...",
      estimate: "estimate",
      eggsUnit: "eggs",
      noHatchDate: "No date set",
      notHatchedYet: "not hatched yet",
      notGradedYet: "not graded yet",
      emptyTitle: "No batches found",
      emptyDescription: "This branch has no batches in the selected period.",
      emptyFiltered: "No batch matches the search.",
      emptyBranchTitle: "No batches in {branch}",
      emptyBranchDescription:
        "No eggs have been received at this branch yet. Batches are created in the hatchery module.",
      columns: {
        hatchDate: "Hatch date",
        expectedCount: "Expected count",
        ordered: "Ordered",
        available: "Remaining",
        occupancy: "Occupancy",
        status: "Status",
      },
      status: {
        PLANNED: "Planned",
        SELLING: "On sale",
        FULL: "Full",
      },
      stage: {
        RECEIVED: "Received",
        SETTING: "In setter",
        READY_TO_TRANSFER_TO_HATCHING: "Ready to transfer",
        HATCHING: "In hatcher",
        READY_TO_COMPLETE: "Ready to complete",
        COMPLETED: "Completed",
      },
      funnel: {
        eggs: "Eggs received",
        losses: "Losses",
        expected: "Expected",
        actual: "Hatched",
        ordered: "Sold",
      },
      panel: {
        title: "Batch",
        back: "Back to batches",
        orders: "Orders on this batch",
        noOrders: "No orders on this batch yet.",
        customer: "Customer",
        customerNo: "Customer #{id}",
        count: "Count",
        amount: "Amount",
        payment: "Payment",
        bonus: "bonus",
      },
      aggregate: {
        tab: "Summary",
        metric: "Metric",
        total: "Total",
        expectedRow: "Expected chicks",
        actualRow: "Hatched chicks",
        orderedRow: "Ordered chicks",
        availableRow: "Chicks available for sale",
        schedule: "Hatch schedule",
        noSchedule: "No hatches scheduled in the selected period.",
      },
    },
    orders: {
      title: "Orders",
      newOrder: "New order",
      searchPlaceholder: "Search by customer, phone, or batch",
      jojaUnit: "chicks",
      units: { chicks: "chicks", chick: "chick", bonus: "bonus", sum: "sum" },
      kanbanEmpty: "No orders in this status",
      emptyTitle: "No orders yet",
      emptyDescription: "Create the first order and manage customer, batch, pricing, and delivery in one place.",
      emptyFiltered: "No orders match this filter.",
      deleteTitle: "Delete order",
      deleteMessage: "Order #{id} will be deleted. Continue?",
      draft: {
        title: "Unfinished order",
        restored: "Unfinished order restored",
        noCustomer: "No customer chosen",
        continue: "Continue",
        startNew: "Start a new one",
        deleteTitle: "Delete the unfinished order",
        deleteMessage: "What was entered will be deleted. Continue?",
        conflictTitle: "There is an unfinished order",
        conflictMessage: "An order started earlier is still kept: {summary}. Starting a new one deletes it.",
      },
      actions: {
        newOrder: "New order",
        edit: "Edit",
        delete: "Delete",
      },
      status: {
        PENDING: "Pending",
        CONFIRMED: "Confirmed",
        DELIVERED: "Delivered",
        CANCELLED: "Cancelled",
      },
      payment: {
        UNPAID: "Unpaid",
        PARTIAL: "Partial",
        PAID: "Paid",
        ON_ACCOUNT: "On the wallet",
        REFUNDED: "Refunded",
      },
      category: {
        LIGHT: "Light",
        MEDIUM: "Medium",
        HEAVY: "Heavy",
      },
      delivery: {
        COMPANY_FREE: "Free delivery",
        PICKUP: "Customer picks up",
        PAID: "Paid delivery",
      },
      filters: {
        all: "All",
        allOrders: "All orders",
        allPayments: "All payment states",
        allMonths: "All months",
      },
      views: {
        table: "Table",
        kanban: "Kanban",
        cards: "Cards",
      },
      stats: {
        total: "Total orders",
        pending: "Pending",
        delivered: "Delivered",
        revenue: "Revenue",
        debt: "Debt",
        cancelled: "Cancelled",
      },
      columns: {
        no: "No.",
        customer: "Customer",
        batch: "Batch",
        count: "Quantity",
        dealPrice: "Deal price",
        marketPrice: "Market price",
        total: "Total",
        status: "Status",
        payment: "Payment",
        deliveryDate: "Delivery date",
        orderDate: "Order date",
        bonus: "Bonus",
        receivedAt: "Received at",
      },
      form: {
        newTitle: "New order",
        editTitle: "Edit order",
        noBranch: "Select a branch first to create an order.",
        customerSection: "Customer & order",
        customer: "Customer",
        selectCustomer: "Select customer",
        batch: "Batch (hatch date)",
        selectBatch: "Select batch",
        weight: "Weight",
        count: "Order count",
        batchChicks: {
          PLANNED: "Expected chicks (planned)",
          RECEIVED: "Expected chicks (received)",
          HATCHED: "Hatched chicks",
        },
        batchOrdered: "Already booked",
        batchRemaining: "Available for sale",
        categoryRemaining: "Available",
        forecastOverbook:
          "This books {count} past the batch's forecast. It does not block the order — real hatchability usually beats the estimate.",
        dealPrice: "Agreed",
        marketPrice: "Market",
        bonus: "Bonus",
        bonusPct: "bonus {pct}%",
        totalRow: "Total: {count} chicks · Bonus: {bonus}",
        servicesSection: "Services",
        vaccines: "Vaccines",
        noVaccines: "No vaccines added",
        perChick: "sum/chick",
        delivery: "Delivery",
        deliveryPrice: "Price",
        paymentsSection: "Payments",
        tenders: "Payment methods",
        discount: "Overall discount",
        paid: "Paid",
        remaining: "Remaining",
        walletCharge: "Charged to the wallet",
        walletReturn: "Returned to the wallet",
        deliveredNote: "This order is handed over — if the total changes, the difference goes onto the customer's wallet.",
        summary: "Order summary",
        summaryCategory: {
          LIGHT: "Light weight",
          MEDIUM: "Medium weight",
          HEAVY: "Heavy weight",
        },
        summaryBonus: "Bonus chicks",
        summaryBonusFree: "free, vaccine included",
        summaryFree: "free",
        summaryNoChicks: "No chicks added yet",
        chicksSection: "Chicks",
        total: "Total",
        sendTelegram: "Send via Telegram",
        sentTelegram: "Sent on Telegram",
        copyBotLink: "Copy bot link",
        linkCopied: "Link copied",
        copyFailed: "Could not copy the link.",
        telegramOff: "not linked",
        telegramUnavailable: "The customer has not linked the bot, or the bot is not configured.",
        telegramNoPermission: "You do not have permission to send on Telegram.",
        pdf: "PDF",
        createOrder: "Create order",
        saveOrder: "Save order",
        confirmSave: {
          createTitle: "Confirm the order",
          saveTitle: "Confirm the changes",
          createMessage:
            "{customer} · {count} chicks · {total} so'm. Create this order?",
          saveMessage:
            "{customer} · {count} chicks · {total} so'm. Save these changes?",
        },
        errors: {
          customer: "Select a customer.",
          batch: "Select a batch.",
          noItems: "Add at least one chick category.",
          deliveryPrice: "Enter the delivery price.",
          discount: "Discount cannot be negative.",
          total: "Total must be greater than 0.",
          overPaid: "Payments exceed the total.",
          wallet: "Insufficient wallet balance.",
          bonus: "Bonus cannot be negative.",
          bonusWithoutCount: "A bonus needs a count on the same category.",
          loadFailed: "Could not load this order.",
          notEditable: "A cancelled order cannot be edited.",
        },
        backToOrders: "Back to orders",
        selectedCount: "{count} selected",
        addVaccine: "Select vaccine",
        vaccineRetired: "not in catalogue",
        addTender: "Select payment method",
        settled: "Settled amount",
        settledHint: "Payments are managed on the order page.",
        discountHint: "For rounding small amounts — set by the manager",
        share: "Share",
        shareMenu: "Share menu",
      },
      detail: {
        title: "Order #{id}",
        notFoundTitle: "Order not found",
        notFoundDescription: "This order does not exist or has been deleted.",
        batch: "Batch",
        branch: "Branch",
        orderDate: "Order date",
        deliveryDate: "Delivery date",
        enteredBy: "Manager",
        items: "Chicks and prices",
        paymentHistory: "Payment history",
        noPayments: "No payments yet",
        editOrder: "Edit order",
        customer: "Customer",
        chargedToWallet: "Moved to wallet",
        returnedToWallet: "Returned to wallet",
        overpaid: "Overpaid",
        overpaidHint: "Returned to the wallet at hand-over",
        openWallet: "Open the wallet",
        paymentStatus: "Payment status",
        acceptPayment: "Accept payment",
        acceptPaymentBtn: "Accept payment",
        statusActions: "Change status",
        move: {
          CONFIRMED: "Confirm",
          DELIVERED: "Confirm handover",
          CANCELLED: "Cancel",
        },
        confirm: {
          CONFIRMED: {
            title: "Confirm order",
            message: "This order will be confirmed. Continue?",
          },
          DELIVERED: {
            title: "Confirm handover",
            message: "This order will be marked delivered and stock stays consumed. Continue?",
          },
        },
      },
      cancel: {
        title: "Cancel order",
        reason: "Reason for cancelling",
        reasonPlaceholder: "E.g. the customer withdrew the order",
        reasonRequired: "Enter the reason for cancelling.",
        paid: "The customer has paid {amount} for this order. How is it returned?",
        refundRequired: "Choose how the money is returned.",
        refund: {
          WALLET: "To the customer's wallet",
          CASH: "To the customer directly",
        },
        refunded: {
          WALLET: "{amount} returned to the wallet",
          CASH: "{amount} returned in cash",
        },
        note: "Cancellation reason",
        dismiss: "Back",
        confirm: "Cancel order",
      },
      hatchCalendar: {
        dateRange: "Hatch date",
        empty: "No hatching batches found in this period.",
        error: "Hatch calendar could not be loaded.",
      },
    },
    payments: {
      deleteTitle: "Delete payment",
      deleteMessage: "This {amount} sum payment will be deleted — the order's paid amount drops by as much. Continue?",
      deleteAccountMessage: "This {amount} sum payment will be deleted — the customer's wallet goes down by as much. Continue?",
      deleteBlocked: {
        DELIVERED: "The order has been handed over — its payment can't be deleted. Make the correction through the customer's wallet.",
        CANCELLED: "The order was cancelled and its payment returned to the customer — the payment can't be deleted.",
      },
      recordTitle: "Record payment",
      applyToOrder: "Apply to order",
      onWallet: "Wallet",
      amount: "Amount",
      method: "Payment method",
      date: "Payment date",
      note: "Note (optional)",
      notePlaceholder: "Add a note about this payment...",
      remainingAfter: "Remaining after payment",
      record: "Record payment",
      list: {
        search: "Search by customer, order or note...",
        empty: "No payments yet",
        emptyFiltered: "No payments match the filters",
        allTypes: "All payment methods",
        month: "Month",
        totalCollected: "Total received",
        count: "{count} payments",
        totalRefunded: "Refunded",
        fromWallet: "Paid from wallets",
        refundCount: "{count} orders",
        columns: {
          date: "Date",
          customer: "Customer",
          order: "Order",
          methods: "Payment methods",
          amount: "Amount",
          attachment: "Receipt",
          receivedBy: "Received by",
          notes: "Note",
        },
      },
      detail: {
        title: "Payment #{id}",
        pageTitle: "Payment",
        amount: "Amount received",
        walletNote: "Received with no order — credited to the customer's wallet",
        order: "Order #{id}",
        receipt: "Receipt",
        notFoundTitle: "Payment not found",
        notFoundDescription: "This payment was deleted, or the address is wrong.",
        receivedBy: "Received by",
        notes: "Note",
        tenders: "Payment methods",
      },
      audit: {
        title: "Change history",
        actions: {
          CREATE: "Payment recorded",
          UPDATE: "Payment edited",
          DELETE: "Payment deleted",
          ATTACH: "Document changed",
        },
        fields: {
          AMOUNT: "Amount",
          TENDERS: "Payment methods",
          PAID_AT: "Date",
          NOTES: "Note",
          ATTACHMENTS: "Receipts",
        },
      },
      attachment: {
        title: "Receipt / slip",
        add: "Attach document",
        hint: "JPG, PNG or PDF · up to 10 MB",
        addMore: "Add another receipt",
        previous: "Previous",
        next: "Next",
        open: "Open the document",
        download: "Download",
        noPreview: "This file cannot be shown here — download it.",
        empty: "No document attached.",
        tooLarge: "The file must not exceed 10 MB.",
        uploadFailed: "The file could not be uploaded.",
        removeTitle: "Remove the document",
        removeMessage: "The receipt on this payment will be removed. Continue?",
      },
      type: {
        CASH: "Cash",
        CARD: "Card",
        BANK: "Bank",
        WALLET: "Wallet",
      },
      errors: {
        customer: "Select a customer.",
        order: "Select an order.",
        amount: "Enter an amount.",
        exceeds: "Exceeds remaining (max {amount}).",
        wallet: "Insufficient wallet balance (max {amount}).",
      },
      actions: {
        newPayment: "New payment",
      },
      form: {
        newTitle: "New payment",
        editTitle: "Edit payment",
        back: "Payments",
        customer: "Customer",
        selectCustomer: "Select a customer",
        selectOrder: "Select an order",
        noOutstanding: "This customer has no unpaid orders.",
        target: "Where the money goes",
        targetOrder: "An order",
        targetWallet: "The wallet",
        walletHint: "no order — debt of handed-over orders, or an advance",
        walletNow: "Balance now",
        walletAfter: "After this payment",
        orderTotal: "Order total",
        alreadyPaid: "Paid",
        debt: "Remaining",
        tenders: "Payment methods",
        addTender: "Select payment method",
        fillRemaining: "Fill remaining",
        walletBalance: "Wallet balance: {amount} so'm",
        time: "Time",
      },
    },
    wallet: {
      topUpTitle: "Top up wallet",
      withdrawTitle: "Withdraw from wallet",
      currentBalance: "Current balance",
      amount: "Amount",
      reason: "Reason",
      order: "Order",
      description: "Description (optional)",
      descriptionRequired: "Description (required)",
      descriptionPlaceholder: "Add a description...",
      compensationPlaceholder: "E.g. order #41 — 50 chicks died",
      reasonInfoLabel: "What is “{reason}”?",
      reasonInfo: {
        TOP_UP: {
          BONUS: "Money given to the customer as a gift — e.g. a reward for a large purchase.",
          REFUND: "Money the customer paid, given back: an overpayment, a lowered price or a correction. A cancelled order's money is returned by the system itself.",
          OPENING_BALANCE: "The balance from before the system: what the company owed the customer.",
          COMPENSATION: "Money the company pays for chicks that died in their first week. Write the order number in the note. Not counted as revenue.",
          OTHER: "Anything the reasons above don't cover — say what it is in the note.",
        },
        WITHDRAWAL: {
          CASH_OUT: "The wallet's money handed to the customer in cash. Never more than the wallet holds.",
          FINE: "A fine charged to the customer. Below zero it is recorded as debt.",
          OPENING_BALANCE: "The debt from before the system: what the customer owed the company.",
          OTHER: "Any other charge the reasons above don't cover — say what it is in the note.",
        },
      },
      balanceAfter: "Balance after",
      goesIntoDebt: "The wallet goes below zero — the customer will be in debt.",
      submitTopUp: "Top up",
      submitWithdraw: "Withdraw",
      types: {
        TOP_UP: "Wallet credit",
        WITHDRAWAL: "Wallet debit",
      },
      detail: {
        pageTitle: "Wallet movement",
        back: "Wallet",
        facts: "Movement details",
        performedBy: "Performed by",
        at: "Time",
        payment: "Payment",
        paymentNumber: "Payment #{id}",
        noAttachment: "No proof document filed.",
        notFoundTitle: "Movement not found",
        notFoundDescription: "This wallet movement was removed, or never existed.",
      },
      reasons: {
        CASH: "Cash",
        CARD: "Card",
        BANK: "Bank transfer",
        BONUS: "Bonus",
        REFUND: "Refund",
        OPENING_BALANCE: "Opening balance",
        PAYMENT: "Payment",
        ORDER_SETTLEMENT: "Order handed over",
        WRITE_OFF: "Written off",
        COMPENSATION: "Loss compensation",
        CASH_OUT: "Cash out",
        FINE: "Fine",
        ORDER: "For an order",
        OTHER: "Other",
      },
      attachment: {
        title: "Proof document",
        label: "Proof document (optional)",
        add: "Attach document",
        replace: "Replace document",
        open: "Open document",
        tooLarge: "The file must not exceed 10 MB.",
        uploadFailed: "The file could not be uploaded.",
        removeTitle: "Remove document",
        removeMessage: "The proof document will be removed. The amount and balance stay unchanged. Continue?",
      },
      errors: {
        amount: "Enter an amount.",
        scale: "The amount may have at most 2 decimal places.",
        insufficient: "The wallet does not have enough funds",
        descriptionRequired: "A description is required for this reason.",
        descriptionTooLong: "The description must not exceed 500 characters.",
      },
    },
    reminders: {
      title: "Reminders",
      formTitle: "Reminder",
      search: "Search by note or customer...",
      empty: "No reminders yet",
      emptyFiltered: "No reminders match the selected filters",
      deleteTitle: "Delete reminder",
      deleteMessage: "This reminder will be deleted. Continue?",
      completeTitle: "Mark as done",
      completeMessage: "This reminder will be marked as done. This cannot be undone.",
      actions: {
        create: "New reminder",
        edit: "Edit",
        complete: "Done",
        delete: "Delete",
      },
      views: {
        table: "Table",
        kanban: "Kanban",
      },
      kanbanEmpty: "No reminders in this status",
      status: {
        TODAY: "Today",
        OVERDUE: "Overdue",
        UPCOMING: "Upcoming",
        DONE: "Done",
      },
      fields: {
        customer: "Customer",
        phone: "Phone",
        note: "Note",
        date: "Date",
        time: "Time",
        status: "Status",
        createdBy: "Recorded by",
        completedAt: "Completed at",
      },
      filters: {
        allReminders: "All reminders",
        dateRange: "Date range",
      },
      placeholders: {
        note: "What needs doing? e.g. Call about the June batch payment",
        selectCustomer: "Select a customer",
      },
      hints: {
        customerLocked: "A reminder's customer cannot be changed.",
        overdueIgnoresRange: "Overdue reminders are shown regardless of the date range.",
        late: "Time passed",
      },
      errors: {
        note: "Enter the reminder text",
        date: "Pick a date",
        time: "Pick a time",
        customer: "Select a customer",
      },
    },
    customers: {
      formTitle: "Customer",
      search: "Search by customer, phone, region, or address...",
      sort: {
        label: "Sort",
        newest: "Newest added first",
        oldest: "Oldest added first",
        name: "By name",
        region: "By region",
        debt: "Debtors first",
      },
      empty: "No customers yet",
      deleteTitle: "Delete customer",
      deleteMessage: "This customer will be removed from the list. Continue?",
      deleteWithBalanceMessage: "The wallet's {amount} so'm will be written off and the customer deleted. Continue?",
      actions: {
        create: "Add customer",
      },
      filters: {
        allRegions: "All regions",
      },
      fields: {
        no: "No.",
        name: "Customer",
        phone: "Phone",
        country: "Country",
        region: "Region",
        address: "Address",
        walletBalance: "Wallet",
        type: "Customer type",
        notes: "Notes",
      },
      typeHint: "Tier used for pricing and reports.",
      optional: "— optional",
      notesPlaceholder: "Add a note about this customer...",
      placeholders: {
        address: "Street, building, apt.",
        selectCountry: "Select country",
        selectRegion: "Select region",
      },
      avatar: {
        upload: "Upload photo",
        change: "Change photo",
        remove: "Remove",
        hint: "PNG or JPG, up to 10 MB.",
        tooLarge: "The image must not exceed 10 MB.",
        invalidType: "Only image files are allowed.",
        uploadFailed: "Could not upload the image. Please try again.",
      },
      errors: {
        phoneInvalid: "Invalid phone number. Format: +998 XX XXX XX XX",
        regionRequired: "Select a region.",
      },
      detail: {
        title: "Customer profile",
        back: "Customers",
        edit: "Edit",
        customerSince: "Customer since",
        tier: "Tier {type}",
        comingSoon: "This section is coming soon.",
        notFoundTitle: "Customer not found",
        notFoundDescription: "This customer was deleted or does not exist.",
        tabs: {
          overview: "Overview",
          orders: "Orders",
          payments: "Payments",
          wallet: "Wallet",
          reminders: "Reminders",
          activity: "Activity",
        },
      },
      overview: {
        noNotes: "No notes yet",
        totalOrders: "Total orders",
        cancelled: "Cancelled",
        boughtChicks: "Chicks bought",
        totalValue: "Total value",
        walletBalance: "Wallet balance",
        debt: "Debt",
        openOrdersUnpaid: "Expected payments",
        financeSoon: "Orders, payments and wallet stats are coming soon.",
      },
      activity: {
        empty: "No activity yet",
        deleteTitle: "Delete note",
        deleteMessage: "This note will be deleted. Continue?",
      },
      conversations: {
        title: "Customer conversations",
        latest: "Last conversation",
        placeholder: "What did you talk about? What should you raise next time?",
        save: "Record",
        charCount: "{n} / {max}",
        expand: "Read more",
        collapse: "Show less",
        readOnly: "You don't have permission to record conversations",
        editSave: "Save",
        editCancel: "Cancel",
        retry: "Try again",
        errorLoad: "Couldn't load conversations",
        errorSave: "Couldn't save the conversation. Your text is still here.",
        errorUpdate: "Couldn't save the change",
        deleteTitle: "Delete conversation",
        deleteMessage: "“{excerpt}” will be deleted. The entry in the activity log stays.",
        empty: {
          title: "No conversations recorded yet",
          body: "After you speak with the customer, jot down the gist — next time you call, you'll know exactly where to pick up.",
        },
      },
      orders: {
        priceSensitive: "Price-sensitive customer",
        givenProfit: "Forgone profit",
        avgDeal: "Avg agreed price",
        avgMarket: "Avg market price",
        totalDiff: "Total difference",
        orderedChicks: "Chicks ordered",
        bonusChicks: "+{count} bonus",
        totalOrders: "Total orders",
        cancelled: "Cancelled",
        totalValue: "Total value",
        empty: "This customer has no orders yet.",
      },
      payments: {
        outstanding: "Outstanding invoices",
        totalDue: "Total due",
        noOutstanding: "No outstanding invoices.",
        noHistory: "No payments yet.",
      },
      wallet: {
        balance: "Wallet balance",
        debtor: "In debt",
        creditor: "In credit",
        openOrdersUnpaid: "Expected payments",
        noTransactions: "No activity yet.",
      },
    },
    debtors: {
      empty: "No customers owe money",
      stats: {
        totalDebt: "Total debt",
        debtors: "Debtors",
      },
      columns: {
        no: "No.",
        customer: "Customer",
        debt: "Debt",
        status: "Call summary",
      },
      status: {
        placeholder: "Call summary",
        saved: "Saved",
      },
    },
    creditors: {
      empty: "No customers are owed money",
      stats: {
        totalCredit: "Total owed to customers",
        creditors: "Creditors",
      },
      columns: {
        no: "No.",
        customer: "Customer",
        credit: "Credit",
      },
    },
    expenses: {
      locked: "Written from a customer's wallet movement — cannot be edited or deleted.",
      form: {
        newTitle: "New expense",
        editTitle: "Edit expense",
      },
      search: "Search by description, category, or author...",
      empty: "No expenses yet",
      deleteTitle: "Delete expense",
      deleteMessage: "This expense will be removed from the list. Continue?",
      actions: {
        create: "Add expense",
      },
      stats: {
        today: "Today",
        month: "This month",
        count: "{count} expenses",
      },
      filters: {
        allCategories: "All categories",
      },
      fields: {
        category: "Category",
        amount: "Amount",
        expenseDate: "Expense date",
        expenseTime: "Time",
        description: "Description",
        paymentType: "Payment type",
        walletMovement: "Wallet movement",
        currency: "Currency",
        createdBy: "Added by",
        createdAt: "Entered at",
      },
      receipt: {
        title: "Receipt",
        attach: "Attach receipt",
        hint: "PDF or image, up to 10 MB",
        tooLarge: "The file must not exceed 10 MB.",
        uploadFailed: "Upload failed. Try again.",
        download: "Download",
      },
      detail: {
        title: "Expense details",
        notFoundTitle: "Expense not found",
        notFoundDescription: "This expense was deleted or the link is wrong.",
      },
      placeholders: {
        amount: "Example: 250,000",
        description: "Short note about this expense",
      },
      errors: {
        category: "Select a category.",
        amount: "Enter an amount.",
      },
    },
    branch: {
      label: "Branch",
      activeTag: "Current",
      placeholder: "Select a branch",
      none: "No branches",
      loadError: "Could not load branches.",
      retry: "Try again",
      deleteActiveHint: "You cannot delete the branch you are working in.",
      required: {
        title: "No branch selected",
        empty: "This section is branch-scoped, but no branch exists yet.",
        forbidden: "You do not have permission to view branches. Contact an administrator.",
        cta: "Add branch",
      },
    },
    common: {
      cancel: "Cancel",
      clear: "Clear",
      close: "Close",
      confirm: "Confirm",
      details: "Details",
      error: "Error",
      loading: "Loading",
      noData: "No data",
      ready: "Ready",
      save: "Save",
      delete: "Delete",
      remove: "Remove",
      edit: "Edit",
      som: "so'm",
      count: "{count}",
      showMore: "Show more",
      showLess: "Show less",
      soon: "coming soon",
      comingSoon: "This section is coming soon.",
      datePlaceholder: "dd.mm.yyyy",
      dateTimePlaceholder: "dd.mm.yyyy hh:mm",
      months: {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December",
      },
      wholeYear: "Whole year",
      wholeYearOf: "All of {year}",
      errors: {
        unexpected: "Something went wrong. Please try again.",
      },
      status: {
        available: "Available",
        loaded: "Busy",
        broken: "Broken",
      },
    },
    enums: {
      weightCategory: {
        LIGHT: "Light (<40 g)",
        MEDIUM: "Medium (40-48 g)",
        HEAVY: "Heavy (≥48 g)",
      },
      incubationMachineType: {
        SETTER: "Incubation",
        HATCHER: "Hatching",
      },
      expensePaymentType: {
        CASH: "Cash",
        CARD: "Card",
        BANK: "Bank",
        WALLET: "Via wallet",
      },
      expenseCurrency: {
        UZS: "UZS",
        USD: "USD",
        EUR: "EUR",
        RUB: "RUB",
      },
      incubationMachineStatus: {
        ACTIVE: "Active",
        INACTIVE: "Inactive",
      },
      incubationMachineState: {
        FREE: "Free",
        LOADED: "Loaded",
        BROKEN: "Broken",
      },
    },
    settingsAdmin: {
      actions: {
        add: "Add",
        edit: "Edit",
        delete: "Delete",
        save: "Save",
        refresh: "Refresh",
        close: "Close",
      },
      form: {
        create: "New",
        edit: "Edit",
      },
      states: {
        empty: "No data yet",
        error: "Could not load data",
      },
      labels: {
        total: "Total",
        search: "Search...",
        name: "Name",
        capacity: "Capacity",
        type: "Type",
        status: "Status",
        inactiveReason: "Inactive reason",
        category: "Category",
        parentAgeInWeeks: "Age in weeks",
        hatchabilityPercent: "Hatchability",
        weight: "Weight (g)",
        weightCategory: "Weight category",
        contactPersonName: "Contact person",
        contactPersonPhoneNumber: "Phone number",
        address: "Address",
        price: "Price",
      },
      branches: {
        title: "Branches",
        formTitle: "Branch",
        subtitle: "Manage the hatchery branches.",
        create: "Add branch",
        deleteTitle: "Delete branch",
        deleteMessage:
          "This branch will be removed. Only a branch with no data can be deleted. Continue?",
        nameRequired: "Enter a branch name.",
        nameExists: "A branch with this name already exists.",
      },
      suppliers: {
        title: "Suppliers",
        formTitle: "Supplier",
        subtitle: "Manage supplier contacts and addresses.",
        create: "Add supplier",
        search: "Search by name, contact, or address...",
        deleteTitle: "Delete supplier",
        deleteMessage: "This supplier will be removed from the list. Continue?",
      },
      incubationMachines: {
        title: "Incubation machines",
        formTitle: "Incubation machine",
        subtitle: "Manage incubation and hatching machine capacity and status.",
        create: "Add machine",
        search: "Search by machine name or status...",
        deleteTitle: "Delete machine",
        deleteMessage: "This machine will be removed from the list. Continue?",
      },
      eggStandards: {
        title: "Egg standards",
        formTitle: "Egg standard",
        subtitle: "Manage category, age in weeks, and hatchability standards.",
        create: "Add standard",
        search: "Search by category or name...",
        deleteTitle: "Delete standard",
        deleteMessage: "This standard will be removed from the list. Continue?",
      },
      expenseCategories: {
        title: "Expense categories",
        formTitle: "Expense category",
        subtitle: "Manage categories used by expense entries.",
        create: "Add category",
        search: "Search by category name...",
        deleteTitle: "Delete category",
        deleteMessage: "This category will be removed from the list. Continue?",
      },
      vaccines: {
        title: "Vaccines",
        formTitle: "Vaccine",
        subtitle: "Manage vaccine add-ons offered with orders.",
        create: "Add vaccine",
        search: "Search by vaccine name or price...",
        deleteTitle: "Delete vaccine",
        deleteMessage:
          "This vaccine will be removed from the list. Continue?",
      },
    },
    incubationFlow: {
      active: "Active",
      avgHumidity: "Avg. humidity",
      avgTemperature: "Avg. temperature",
      batch: "Batch",
      completed: "Completed",
      dateRange: "Date range",
      empty: "No processes yet",
      eggs: "Eggs",
      hatchingSubtitle:
        "Hatching processes and daily observations are tracked separately.",
      hatchingTitle: "Hatching",
      humidity: "Humidity",
      inspectionButton: "Inspection done",
      inspectionHint: "Confirming the inspection notifies the managers.",
      inspectionLast: "Last inspection: {time}",
      inspectionSaved: "Inspection saved",
      inspectionOverdue: "Inspection overdue",
      inspectionTitle: "Setter inspection",
      hatcherInspectionHint: "Confirming the inspection notifies the managers.",
      hatcherInspectionTitle: "Hatching incubator inspection",
      latestLog: "Latest log",
      loading: "Loading",
      machines: "Machines",
      settingSubtitle:
        "Incubation processes with daily temperature and humidity control.",
      settingTitle: "Incubation",
      status: {
        TRANSFERRED_TO_ANOTHER_SETTER: "Transferred to another setter",
        IN_SETTING: "In incubation",
        NEW: "New",
        TRANSFERRED_TO_HATCHING: "Transferred to hatching",
      },
      hatchingStatus: {
        TRANSFERRED_TO_ANOTHER_HATCHER:
          "Transferred to another hatching machine",
        IN_HATCHING: "In hatching",
        NEW: "New",
        COMPLETED: "Completed",
      },
      completeHatching: "Complete hatching",
      firstGradeCount: "1st grade",
      hatchingLifecycleEyebrow: "Hatching status",
      hatchingLifecycleTitle: "Hatching processes",
      results: "Results",
      secondGradeCount: "2nd grade",
      selectMachine: "Select machine",
      settingLifecycleEyebrow: "Incubation status",
      settingLifecycleTitle: "Incubation processes",
      startConfirmMessage:
        "{setting} ({machine}) will start incubation. Do you want to continue?",
      startConfirmTitle: "Confirm incubation start",
      startShort: "Start",
      startSetting: "Start incubation",
      thirdGradeCount: "3rd grade",
      temperature: "Temperature",
      totalHatchings: "Hatchings",
      totalSettings: "Incubations",
      transferAutoFill: "Auto-fill",
      transferBrokenDefaultReason: "Transfer reason: incubator is broken",
      transferBrokenNo: "no",
      transferBrokenReason: "Breakdown reason",
      transferBrokenReasonPlaceholder: "Example: motor failure",
      transferBrokenReasonRequired: "Enter the breakdown reason",
      transferBrokenYes: "yes",
      transferConfirmMessage:
        "{setting} will be transferred from {source} into {count} target setters. Mark source as broken: {broken}. Continue?",
      transferConfirmTitle: "Confirm setter transfer",
      transferCreated: "Incubation was transferred to another setter",
      transferFailed: "Could not transfer to another setter",
      transferInvalidDistribution:
        "Eggs must be fully distributed for every standard",
      transferMarkBroken: "Mark source setter as broken",
      transferMarkBrokenHint:
        "After transfer, the source machine becomes inactive",
      transferModalTitle: "Distribute eggs to another setter",
      transferAvailableTargets: "Free setters",
      transferNoTargets: "No free target setters",
      transferNotEnoughCapacity:
        "Not enough free capacity: {capacity} spaces for {eggs} eggs",
      transferPlaced: "Placed eggs",
      transferRemaining: "Left:",
      transferRemainingCapacity: "Remaining free capacity",
      transferRequired: "Eggs to transfer",
      transferSelectTargets: "Select free setters for transfer",
      transferShort: "Transfer",
      transferSourcePatchFailed: "Could not mark source machine as broken",
      transferSourcePatchFailedWithReason:
        "Transfer completed, but source machine status was not updated: {reason}",
      transferStandard: "Standard",
      transferSubmit: "Transfer",
      transferTargetCapacity: "Free capacity",
      transferTargetOverflow: "Target setter capacity was exceeded",
      transferTargetTotal: "Target total",
      transferTargets: "Targets",
      transferTotal: "Total",
      transferToAnotherHatcher: "Transfer to another hatching incubator",
      transferToAnotherSetter: "Transfer to another setter",
      unhatchedCount: "Unhatched",
    },
    sessionEdit: {
      title: "Edit",
      maxHint: "At most {count}",
      eggsLocked: "Eggs have moved to a hatcher — the counts can no longer change.",
      splitLocked: "Moved before the split was kept — only the rate can change.",
      leftSetter: "Left the setter: {count}",
      invalidDates: "The start must be before the end.",
      invalidEggs: "Check the egg counts.",
    },
    machinePark: {
      available: "Available",
      broken: "Broken",
      capacity: "Capacity",
      period: "Period",
      periodOf: "Of {total} · {percent}%",
      durationDaysHours: "{days} d {hours} h",
      durationDays: "{days} d",
      durationHours: "{hours} h",
      detailsTitle: "Machine details",
      empty: "No machines yet",
      eggs: "Eggs",
      humidity: "Humidity",
      loaded: "Busy",
      loadedNoProcess: "Busy, no process found",
      machineCount: "Total {count} machines",
      ready: "Ready",
      reason: "Reason",
      status: "Status",
      temperature: "Temperature",
      totalCapacity: "Total capacity",
      transferred: "Transferred to hatching",
    },
    settingAllocator: {
      availableCount: "{count} available",
      availableMachinesSelect: "Setting incubators",
      availableMachines: "Available incubation machines",
      batchLoadFailed: "Could not load batches",
      batchRemaining: "Batch remaining",
      batch: "Batch",
      capacityExceededBy: "Selected eggs exceed machine capacity by {count}",
      capacityLeft: "Free space: {count}",
      confirmMessage:
        "{eggs} eggs from {batch} will be placed into {machine}. Do you want to continue?",
      confirmTitle: "Confirm incubation placement",
      createFailed: "Could not create incubation",
      created: "Batch was placed into incubation machines",
      distributions: "Egg distributions",
      duplicateStandard: "This category has already been added",
      duration: "{days} days in incubation",
      eggCount: "Egg count",
      eyebrow: "Next stage",
      expectedChicks: "Expected chicks",
      fillMachine: "Fill machine space",
      hatchability: "Hatchability",
      startDate: "Started",
      endDate: "Ends",
      total: "Total",
      hint: "The system chooses the most optimal combination by capacity and unused space.",
      invalidDistribution: "Check the egg distribution",
      invalidEggCount: "Egg count must be a whole number and at least 0",
      invalidEggValues: "Check egg count in {count} rows",
      machine: "Incubation machine",
      machineCapacityLeft: "Machine free capacity",
      machineFill: "Machine fill",
      machineFull: "This machine has no free space left",
      loadMachine: "Load",
      maxEggs: "Max: {count}",
      noAvailableMachines: "No available incubation machines",
      noBatches: "No unplaced batches",
      noCapacityLeft: "No machine free capacity left",
      noRemainingCategories: "No remaining eggs for this batch",
      noPlan: "Select a batch and machines first",
      notEnoughCapacity: "Selected machines do not have enough capacity",
      plan: "Placement plan",
      placeEggs: "Eggs to place",
      recommend: "Recommend best fit",
      recommended: "Recommended",
      remaining: "Remaining",
      remainingLoadFailed: "Could not load remaining categories",
      rowLimitExceeded: "{count} rows exceed remaining eggs in the batch",
      rowLimitExceededShort: "Cannot exceed remaining eggs in the batch",
      saving: "Saving",
      searchBatch: "Search batch...",
      selectBatch: "Select batch",
      selectBatchEmptyHint:
        "Choose a batch above and the egg distribution will appear here automatically.",
      selectBatchFirst: "Select a batch first",
      selectDistributionFirst: "Select at least one egg distribution",
      selectMachineFirst: "Select an incubation machine",
      selectMachineAndBatch: "Select a machine and batch first",
      placedEggs: "Placed eggs",
      selectedEggs: "Selected eggs",
      selectedCapacity: "Selected capacity",
      submit: "Place into incubation",
      totalPlacementLosses: "Placement losses",
      titleEyebrow: "Setter placement",
      title: "Place batch into incubation machines",
      tooManyEggs: "Selected eggs exceed machine free capacity",
      wasted: "Machine free capacity left",
    },
    hatchingAllocator: {
      capacityLeft: "Hatching incubator free space: {count}",
      confirmMessage:
        "{eggs} eggs from {setting} will be transferred into {machine}. Do you want to continue?",
      confirmTitle: "Confirm hatching transfer",
      createFailed: "Could not create hatching",
      created: "Eggs were transferred into hatching",
      completeCreated: "Hatching completed",
      completeFailed: "Could not complete hatching",
      completeConfirmMessage:
        "{hatching} hatching results will be completed. Continue?",
      completeConfirmTitle: "Confirm hatching completion",
      completeInvalid: "Each standard result total must match its egg count",
      completeShort: "Complete",
      completeTitle: "Enter hatching results",
      completedRows: "Completed rows",
      currentHatching: "Hatching process",
      distributionHint:
        "Eggs are distributed by free hatching incubator capacity.",
      distributionTitle: "Distribution by hatching incubators",
      fillFirstGrade: "Put remaining into 1st grade",
      hatcherBrokenDefaultReason:
        "Transfer reason: hatching incubator is broken",
      hatcherTransferConfirmMessage:
        "{hatching} will be transferred from {source} to {target}. Mark this incubator as broken: {broken}. Continue?",
      hatcherTransferConfirmTitle:
        "Confirm transfer to another hatching incubator",
      hatcherTransferTitle: "Transfer to another hatching incubator",
      hatchingEggs: "Eggs entering hatching",
      invalidTransfer: "Check the egg count or transfer loss value",
      invalidDistribution: "Eggs must be fully distributed for every standard",
      machine: "Hatching incubator",
      markHatcherBroken: "Mark this hatching incubator as broken",
      markHatcherBrokenHint: "After transfer, the machine becomes inactive",
      noAvailableMachines: "No available hatching incubators",
      noSettings: "No incubations ready for hatching",
      notEnoughCapacity:
        "Not enough free capacity: {capacity} spaces for {eggs} eggs",
      lossesHint: "Enter the losses observed when leaving the setter.",
      lossesTitle: "Losses",
      receiptPercent: "At receipt %",
      loadModalTitle: "Place eggs into hatching incubators",
      parkHint: "Status of free, loaded, and broken hatching incubators.",
      parkTitle: "Hatching incubators",
      review: "Transfer plan",
      searchSetting: "Search incubation or batch...",
      selectSetting: "Select incubation",
      selectSettingFirst: "Select an incubation first",
      selectSettingFirstHint:
        "Select an incubation from the field above, and the egg distribution will appear here automatically.",
      selectTargetHatcher: "Select a free hatching incubator for transfer",
      serviceNeeded: "Service needed",
      setting: "Incubation",
      submit: "Transfer to hatching",
      targetHatcherUnavailable: "This hatching incubator is not free",
      targetOverflow: "Selected hatching incubator capacity was exceeded",
      transferCreated: "Hatching was transferred to another hatching incubator",
      transferEggs: "Eggs to transfer",
      transferFailed: "Could not transfer to another hatching incubator",
      standard: "Standard #{id}",
      unfertilizedCount: "Unfertilized",
      earlyDeadEmbryoCount: "Tumak",
      rottenCount: "Rotten",
    },
    dailyLogs: {
      add: "Add",
      avgHumidity: "Avg humidity",
      avgTemperature: "Avg temperature",
      created: "Log added",
      date: "Date",
      deleted: "Log deleted",
      deleteConfirmMessage:
        "The daily log from {date} {time} will be deleted. Continue?",
      deleteConfirmTitle: "Delete log",
      deleteFailed: "Could not delete log",
      eyebrow: "Daily monitoring",
      hatchingTitle: "Hatching daily logs",
      humidity: "Humidity",
      latest: "Latest log",
      loadFailed: "Could not load logs",
      noLogs: "No logs for this process yet",
      noProcesses: "No processes to monitor",
      process: "Process",
      range: "Temperature range",
      saveFailed: "Could not save log",
      search: "Search process or batch...",
      selected: "Selected process",
      selectProcessFirst: "Select a process first",
      settingTitle: "Incubation daily logs",
      temperature: "Temperature",
      time: "Time",
      update: "Save",
      updated: "Log updated",
    },
    auth: {
      brandLabel: "Inter Agro",
      footer: "Factory control panel",
      invalidCredentials: "Incorrect username or password",
      password: "Password",
      passwordPlaceholder: "Enter password",
      passwordRequired: "Enter password",
      showPassword: "Show password",
      hidePassword: "Hide password",
      signIn: "Sign in",
      username: "Username",
      usernamePlaceholder: "Enter username",
      usernameRequired: "Enter username",
      welcomeTitle: "Welcome back",
      errors: {
        generic: "Something went wrong while signing in. Please try again.",
        network: "Could not reach the server. Check your connection.",
      },
      changePassword: {
        title: "Change password",
        subtitle: "Set a new password to continue.",
        forcedNotice:
          "Your account has a temporary password. Change it before you continue.",
        currentPassword: "Current password",
        currentPlaceholder: "Enter current password",
        currentRequired: "Enter current password",
        newPassword: "New password",
        newPlaceholder: "Enter new password",
        newRequired: "Enter new password",
        confirmPassword: "Confirm new password",
        confirmPlaceholder: "Re-enter new password",
        submit: "Update password",
        success: "Password changed successfully",
        mismatch: "Passwords do not match",
        tooShort: "Password must be at least 8 characters",
        signOut: "Log out",
      },
    },
    admin: {
      users: {
        title: "Users",
        count: "{count} members",
        search: "Search users...",
        empty: "No users found",
        createTitle: "Create user",
        editTitle: "Edit user",
        noRoles: "No roles available",
        markerOnlyWarning: "This role grants nothing on its own — the user won't be able to open any page. Add at least one other role as well.",
        passwordHint: "At least 8 characters. Set as a temporary password.",
        resetPasswordHint: "Leave blank to keep unchanged",
        errors: {
          phoneInvalid: "Invalid phone number. Format: +998 XX XXX XX XX",
        },
        deleteTitle: "Delete user",
        deleteMessage: "Delete {name}? This action cannot be undone.",
        blockTitle: "Block user",
        blockMessage: "Block {name}? All of their sessions will be revoked.",
        unblockTitle: "Unblock user",
        unblockMessage: "Unblock {name}?",
        status: {
          active: "Active",
          blocked: "Blocked",
        },
        actions: {
          create: "Create user",
          edit: "Edit",
          delete: "Delete",
          block: "Block",
          unblock: "Unblock",
          permissions: "Permissions",
        },
        fields: {
          user: "User",
          fullName: "Full name",
          username: "Username",
          phone: "Phone",
          password: "Password",
          resetPassword: "Reset password",
          roles: "Roles",
          status: "Status",
          lastLogin: "Last login",
        },
        permissions: {
          title: "Permissions",
          search: "Search permissions...",
          overrides: "{count} overrides",
          empty: "Nothing found",
          inherit: "Inherit",
          allow: "Allow",
          deny: "Deny",
          on: "On",
          off: "Off",
          direct: "Direct",
          superAdminNote: "A super-admin's permissions are managed automatically and cannot be overridden.",
        },
        detail: {
          subtitle: "Profile, access and account status",
          back: "Back to Users",
          notFoundTitle: "User not found",
          notFoundDescription: "This user may have been removed or the link is invalid.",
          tabs: {
            information: "User Information",
            roles: "Roles",
            permissions: "Permissions",
          },
          aside: {
            memberSince: "Member since",
            roles: "Roles",
            permissions: "Permissions",
            effective: "{count} effective",
            noRoles: "No roles",
            disableAccount: "Disable account",
            enableAccount: "Enable account",
          },
          information: {
            usernameHint: "Used to sign in — can be changed if the user prefers a different one.",
            resetPasswordTitle: "Reset password",
            resetPasswordNote: "Admins set a new password for the user.",
            setNewPassword: "Set new password",
            newPasswordPlaceholder: "New password",
            statusLabel: "Status",
            statusNote: "Active accounts can sign in.",
            save: "Save changes",
          },
          roles: {
            description: "A role bundles permissions. Grant or revoke roles for {name}.",
            assigned: "Assigned roles",
            available: "Available roles",
            grant: "Grant",
            revoke: "Revoke",
            revokeTitle: "Revoke role",
            revokeMessage: "Remove the {role} role from {name}?",
            operationCount: "{count} operations",
            empty: "No roles assigned yet.",
            allAssigned: "All roles are assigned.",
            banner: "Roles grant permissions in bundles. Fine-tune individual operations for this user in the Permissions tab.",
          },
          permissions: {
            searchSections: "Search sections",
            banner: "Operations come from {name}'s roles; grant extra or remove role-given ones here — changes apply to this user only.",
            save: "Save changes",
            empty: "Nothing found",
          },
        },
      },
      roles: {
        title: "Roles",
        count: "{count} roles",
        search: "Search roles...",
        empty: "No roles found",
        createTitle: "Create role",
        editTitle: "Edit role",
        codeHint: "e.g. sales_manager",
        operationCount: "{count} permissions",
        systemBadge: "System role",
        systemNames: {
          super_admin: "Super Administrator",
          configuration_manager: "Configuration Manager",
          access_manager: "Access Manager",
        },
        deleteTitle: "Delete role",
        deleteMessage: "Delete the {name} role? It is removed from all holders immediately.",
        actions: {
          create: "Create role",
          edit: "Edit",
          delete: "Delete",
          permissions: "Permissions",
        },
        fields: {
          role: "Role",
          name: "Name",
          code: "Code",
          description: "Description",
          operations: "Permissions",
        },
        operations: {
          title: "Role permissions",
          searchSections: "Search sections",
          banner: "Operations enabled here apply to every user who holds the {name} role.",
          save: "Save changes",
          selectAll: "Select all",
          clearAll: "Clear",
          systemNote: "System role — its permissions cannot be changed.",
          empty: "Nothing found",
        },
        detail: {
          subtitle: "Configure role permissions",
          back: "Back to Roles",
          notFoundTitle: "Role not found",
          notFoundDescription: "This role may have been removed or the link is invalid.",
          loadFailedTitle: "Could not load the data",
          loadFailedDescription: "Something went wrong while fetching the role. Please try again.",
          retry: "Try again",
        },
      },
    },
    noAccess: {
      title: "No access",
      message: "You don't have access to any section. Please contact your administrator.",
    },
    account: {
      title: "My profile",
      personalInfo: "Personal information",
      readOnlyNote: "Your details are managed by your administrator.",
      changePassword: "Change password",
      yourRoles: "Your roles",
      noRoles: "No roles assigned",
      permissionCount: "{count} permissions",
      managedByAdmin: "Roles and permissions are managed by your administrator.",
      signOut: "Sign out",
      avatar: {
        change: "Change picture",
        upload: "Upload picture",
        remove: "Remove",
        hint: "PNG or JPG, up to 10 MB.",
        tooLarge: "Image size must not exceed 10 MB.",
        invalidType: "Only image files are accepted.",
        uploadFailed: "Failed to upload image. Please try again.",
      },
      fields: {
        fullName: "Full name",
        username: "Username",
        phone: "Phone",
        memberSince: "Member since",
        lastLogin: "Last login",
      },
    },
    dashboard: {
      eyebrow: "Factory control panel",
      periodLabel: "Select period",
      filters: {
        dateRange: "Date range",
        invalidRange: "Start date cannot be after end date.",
      },
      legend: {
        now: "live floor",
        notSettled: "not settled yet",
      },
      now: {
        eyebrow: "NOW",
        scopeNote: "The branch as it stands right now — not affected by the selected period.",
        updatedAt: "updated at {time}",
        refresh: "Refresh",
        never: "not fetched yet",
      },
      period: {
        eyebrow: "PERIOD",
        scopeNote: "The sections below cover {range}.",
        emptyHint: "No batches were received in this period. Try widening the range.",
        receivedHelper: "received in the period",
      },
      metrics: {
        batchCount: "Batches",
        eggsInSetting: "In setting",
        eggsInHatching: "In hatching",
        inProduction: "still in production",
      },
      floor: {
        title: "Machine load",
        type: {
          SETTER: "Setter",
          HATCHER: "Hatcher",
        },
        free: "free",
        loaded: "loaded",
        broken: "broken",
        capacityNote: "Capacity includes broken machines, so real headroom can be smaller than shown.",
        noMachines: "No machines of this type",
        noneRegistered: "No incubation machines registered for this branch",
        machineCount: "{count} machines",
        eggsOfCapacity: "{loaded} / {capacity} eggs",
      },
      attention: {
        title: "Needs attention",
        brokenMachines: "Broken machines",
        readyToTransfer: "Ready to transfer",
        readyToComplete: "Ready to complete",
        unsortedBatches: "Unsorted batches",
        goSorting: "Go to sorting",
        goHatching: "Go to hatching",
        more: "{count} more",
        groupClear: "Clear",
        allClear: "Nothing needs attention right now",
      },
      journey: {
        title: "Egg journey",
        subtitle: "Where the eggs received in this period are now.",
        stage: {
          RECEIVED: "Received",
          AFTER_SORTING: "After sorting",
          SET: "Set",
          MOVED_TO_HATCHER: "Moved to hatcher",
          CHICKS: "Chicks",
        },
        lost: "lost",
        gap: {
          sorting: "not sorted yet",
          loading: "not loaded yet",
          transfer: "not transferred yet",
          hatch: "not hatched yet",
        },
        unattributed: "drop not attributed",
        settled: "Period closed — every batch has hatched out",
        open: "{count} eggs still in production",
        lossLink: "The full ledger of recorded losses is below",
        emptyTitle: "No batches received in this period",
        emptyDescription: "Widen the period or pick another branch.",
        noEggs: "The batches in this period hold no eggs",
        stageCount: "{count} stages",
        scaleNote: "Every row is drawn against the eggs received",
        legend: {
          stage: "at this stage",
          inFlight: "still in production",
        },
      },
      lossSteps: {
        title: "Loss ledger",
        subtitle: "Recorded losses by reason.",
        step: {
          BROKEN: "Broken",
          DEFECTED: "Defected",
          UNFERTILIZED: "Unfertilized",
          EARLY_DEAD_EMBRYO: "Early dead embryo",
          UNHATCHED: "Unhatched",
        },
        stage: {
          ARRIVAL: "Arrival",
          INCUBATION: "Incubation",
          HATCHING: "Hatching",
        },
        total: "Total loss",
        none: "No losses recorded in this period",
        reasonCount: "{count} reasons",
        opacityNote: "Colour saturation indicates the stage",
      },
      suppliers: {
        title: "Suppliers",
        subtitle: "Each supplier compared against its own catalogue forecast.",
        name: "Supplier",
        batches: "{count} batches",
        eggs: "Eggs",
        expected: "Expected %",
        actual: "Actual %",
        variance: "Variance",
        lossRate: "Loss %",
        pointsSuffix: "%",
        pointsAbove: "{value} percent above expected",
        pointsBelow: "{value} percent below expected",
        pointsEqual: "Exactly as expected",
        stillInProduction: "batches have not hatched out yet",
        empty: "No deliveries in this period",
        sortNote: "sorted worst first",
      },
      chicks: {
        title: "Chick results",
        cardSubtitle: "By quality grade",
        firstGrade: "1st grade",
        secondGrade: "2nd grade",
        thirdGrade: "3rd grade",
        gradeCount: "{count} grades",
        total: "Total",
        unit: "chicks",
        empty: "No chick results in this period",
      },
      standardEfficiency: {
        eyebrow: "Efficiency by standards",
        title: "Expected vs actual hatchability",
        subtitle: "Forecast and result are compared for each egg standard.",
        expected: "Expected",
        actual: "Actual",
        empty: "No hatchability data by standard in this period",
        aboveExpected: "{value} pts above expected",
        belowExpected: "{value} pts below expected",
        onExpected: "Matches expected",
        countBadge: "{count} breeds",
      },
      batches: {
        title: "Batch performance",
        eyebrow: "Latest batches",
        subtitle: "Every batch received in the period, oldest first.",
        emptyTitle: "No batch results yet",
        name: "Batch",
        receivedDate: "Received",
        tableNote: "Every batch received in the period, oldest first.",
      },
      table: {
        totalEggs: "Total",
        chicks: "Chicks",
        lossRate: "Loss rate",
        remaining: "Remaining",
        hatchability: "Hatchability",
      },
      state: {
        loadFailed: "This section could not be loaded",
      },
      finance: {
        title: "Revenue and expenses",
      },
      title: "Incubation control",
      tagline: "Live floor status and results for the selected period",
      kpi: {
        eggsReceived: "Eggs received",
        eggUnit: "eggs",
        chicks: "Chicks",
        chickUnit: "hatched",
        hatchRate: "Hatch rate",
        hatchRateHelper: "of eggs received",
        loss: "Losses",
        lossHelper: "{count} recorded",
        inFlight: "Still in production",
        inFlightHelper: "eggs awaiting a result",
      },
      cards: {
        live: "Live",
        liveNow: "Live · now",
        periodHelper: "in the selected period",
        liveHelper: "current state · not date-filtered",
        kpi: {
          batchesReceived: "Batches received",
          totalEggs: "Total eggs",
          eggsInIncubation: "Eggs in incubation",
          eggsInHatchers: "Eggs in hatchers",
        },
        attention: {
          headline: "{count} need attention",
          brokenCount: "{count} broken",
          batchCount: "{count} batches",
          view: "View",
          resolve: "Resolve",
          expand: "Expand list",
          collapse: "Collapse list",
          tag: {
            broken: "Broken machine",
            unsorted: "Unsorted",
            transfer: "Transfer",
            complete: "Complete",
          },
          detail: {
            unsorted: "Not sorted yet",
            transfer: "Ready to move to hatcher",
            complete: "Ready to complete",
          },
        },
        funnel: {
          title: "Funnel",
          dropped: "down {count}",
          summaryOpen: "{percent} hatched so far · {count} still in production",
          summarySettled: "Period closed — {percent} of eggs received became chicks",
          summaryPlain: "{percent} of eggs received became chicks",
        },
        losses: {
          title: "Losses",
          total: "Total loss",
          topStage: "{share} of all losses at the {stage} stage",
          eggShare: "{value} of eggs received",
        },
        chicks: {
          hatched: "chicks hatched",
          expected: "Expected",
          actual: "Actual",
          hatchRate: "Hatch rate",
        },
        machines: {
          title: "Machines",
          setters: "Incubation machines",
          hatchers: "Hatchers",
          unitCount: "{count} units",
          free: "Free {count}",
          loaded: "Loaded {count}",
          broken: "Broken {count}",
          capacityLine: "Capacity {capacity} · Loaded {loaded}",
          occupancy: "Occupancy",
        },
        standards: {
          title: "Efficiency by standard",
          subtitle: "Expected vs actual hatch",
          rowMeta: "{eggs} eggs · {chicks} chicks",
          variance: "Variance {value}",
        },
        suppliers: {
          title: "Supplier efficiency",
          subtitle: "Worst variance first",
          batchesShort: "Batches",
        },
      },
    },
    batchGrades: {
      action: "Update",
      title: "Correct the hatched chick count",
      subtitle: "1st, 2nd and 3rd-grade chicks per egg standard. Unhatched is what is left of the eggs hatched out.",
      standard: "Standard",
      hatchedOut: "Eggs hatched out",
      total: "Total",
      notHatchedOut: "Hatch-out not recorded yet",
      hint: "The 1st-grade total is the hatched chick count sales sells against.",
    },
    eggBatches: {
      accepted: "Accepted",
      active: "Active",
      addRow: "Add row",
      allocationResults: "Allocation and results",
      all: "All",
      averageLoss: "Avg. loss",
      back: "Back",
      batch: "Batch",
      batchName: "Batch name",
      batchNamePlaceholder: "Example: Партия-2026-012",
      batchNameRequired: "Enter batch name.",
      age: "Age",
      category: "Category",
      categoryAge: "Category / age",
      completed: "Completed",
      date: "Date",
      delete: "Delete",
      deleteBatchDescription:
        '"{name}" will be deleted. This action cannot be undone.',
      deleteBatchTitle: "Delete batch",
      distribution: "Egg distribution",
      edit: "Edit",
      editBatch: "Edit batch",
      gradesAfterHatchOut: "Grades are entered once hatch-out is recorded",
      eggCount: "Egg count",
      eggCountRequired: "Enter egg count",
      eggUnit: "eggs",
      emptyData: "No data",
      actualEggs: "Actual",
      availableEggs: "Available",
      orderedEggs: "Ordered",
      expectedChicks: "Expected chicks",
      expectedEggs: "Expected",
      expectedHatchDate: "Expected hatch",
      filter: "Status",
      forecastChicks: "Forecast chicks",
      flowEmptyLane: "No processes in this stage",
      flowHatchingTitle: "Hatching",
      flowHatchingSubtitle: "Final stage in hatcher machines",
      flowRecords: "records",
      flowSettingTitle: "Incubation",
      flowSettingSubtitle: "Main process in setter machines",
      flowSettingEmptyTitle: "Incubation has not started",
      flowSettingEmptyDescription:
        "Once the batch is loaded into a setter, its process, machine, and egg allocation will appear here.",
      flowHatchingEmptyTitle: "Hatching has not started",
      flowHatchingEmptyBeforeSetting:
        "Load the batch into incubation first; the hatching stage opens after that.",
      flowHatchingEmptyAfterSetting:
        "After incubation finishes, eggs are moved to a hatcher and the hatching process appears here.",
      flowMetricSettingEggs: "Eggs in incubation",
      flowMetricHatchingEggs: "Eggs in hatching",
      flowMetricProcessCount: "{count} process records",
      flowMetricForecastHelper: "by standard",
      flowProgressReady: "Ready to start",
      flowProgressDay: "Day {current}/{total}",
      flowProgressMovedToHatching: "Moved to hatching",
      flowProgressMovedToSetter: "Moved to another setter",
      flowProgressMovedToHatcher: "Moved to another hatcher",
      flowProgressCompleted: "Completed",
      flowTitle: "Process flow",
      formNeedsAttention: "Some fields need attention",
      formNotFound: "Batch not found",
      formNotFoundDescription:
        "The selected batch does not exist or was removed.",
      formReady: "Ready to save",
      free: "free",
      fullyReserved: "Fully reserved",
      gradesExceedHatchedOut: "Grades 1–3 together must not exceed the eggs hatched out ({count})",
      hatchingStage: "Hatching",
      hatchability: "Hatchability",
      hatchingEnteredEggs: "Entering hatching",
      incubationEggs: "Entering incubation",
      incubationStatus: "Incubating",
      lossAccounting: "Loss accounting",
      lossDetails: "Loss details",
      newBatch: "Receive batch",
      due: {
        title: "To receive today",
        today: "Due today",
        late: "{count} days late",
        badge: "Late: {overdue} · Today: {today}",
        receive: "Receive",
      },
      deliveries: {
        searchPlaceholder: "Search by delivery or supplier",
        allMonths: "All months",
        columns: {
          delivery: "Delivery",
          supplier: "Supplier",
          arrivalDate: "Arrival date",
          eggs: "Eggs",
          status: "Status",
        },
        pending: "Expected",
        emptyTitle: "No delivery booked",
        emptyDescription:
          "Nothing is booked for this branch. Batches are received from the sales department's plan.",
        emptyFilteredTitle: "No delivery found",
        emptyFiltered: "Pick another month, or change the search.",
        missingTitle: "Plan not found",
        missingDescription:
          "A batch is only received from the sales department's plan. This plan belongs to another branch, or was deleted.",
        receivedTitle: "Already received",
        receivedDescription:
          "The hatchery has taken this delivery in — it cannot be received a second time. Its figures are on the batch.",
      },
      plan: {
        title: "Sales plan",
        arrival: "Arrival date",
        eggs: "Planned eggs",
        chicks: "Planned chicks",
        difference: "Against the plan",
        matches: "Matches the plan",
        more: "{count} more than planned",
        less: "{count} fewer than planned",
        rowHint: "{category} · planned {count}",
      },
      netEggs: "Net eggs",
      normativeStandard: "Normative standard",
      normativeStandardRequired: "Select normative standard",
      outputPercent: "Output %",
      standardPercent: "Standard %",
      specialistPercent: "Specialist %",
      hatchPercentRequired: "Enter a rate (0–100)",
      processData: "Process data",
      receivingDetails: "Receiving details",
      receivingTemperature: "Receiving temperature",
      receivingInfo: "Receiving information",
      remaining: "remaining",
      reserved: "reserved",
      salesCapacity: "Sales capacity",
      salesProcess: "Sales process",
      save: "Save",
      saving: "Saving...",
      search: "Search by batch or supplier...",
      sold: "Sold",
      standards: "Standards",
      supplier: "Supplier",
      supplierPlaceholder: "Example: Agromir LLC",
      supplierRequired: "Select a supplier.",
      temperature: "Temperature",
      temperatureInfo: "Temperature information",
      total: "total",
      totalEggs: "Total eggs",
      totalExpectedChicks: "Total expected chicks",
      totalLoss: "Total loss",
      transport: "Transport details",
      vehiclePlate: "Vehicle plate",
      vehiclePlatePlaceholder: "01 A 777 AA",
      vehiclePlateRequired: "Enter vehicle plate.",
      vehiclePlateIncomplete: "Enter the full plate: 01 A 777 AA or 01 777 AAA.",
      driver: "Driver",
      driverPlaceholder: "Driver full name",
      driverRequired: "Enter driver full name.",
      brokenCount: "Broken",
      defectedCount: "Defective",
      roadLoss: "Road loss",
      unloadingLoss: "Unloading loss",
      sortingRejected: "Rejected",
      sortingLoss: "Sorting loss",
      outsideTemperature: "Outside",
      vehicleTemperature: "Vehicle",
      eggTemperature: "Egg",
      roomTemperature: "Room",
      warehouseTemperature: "Warehouse",
      temperatureRequired: "Enter temperature.",
      weekShort: "week",
      viewOrders: "View orders",
      ordersPanelTitle: "Batch orders",
      ordersPanelSubtitle: "Orders created for this batch will appear here.",
      usedByOrders: "Used by orders",
      canAcceptOrders: "Accepting orders",
      closedForOrders: "Closed for orders",
      noOrdersForBatch: "No orders for this batch",
      validationDistribution:
        "At least one completed distribution row is required.",
      validationNegativeNumber: "Values cannot be negative.",
      validationLossTooHigh: "Losses cannot exceed total eggs.",
      statusReceived: "Received",
      statusReadyToHatching: "Ready to hatch",
      statusHatching: "Hatching",
      statusReadyToComplete: "Ready to complete",
      statusCompleted: "Completed",
    },
    modules: {
      eggBatches: {
        title: "Batches module",
        description:
          "Batch list, receiving form, and details use backend v2 fields.",
      },
      incubations: {
        title: "Incubation module",
        description:
          "Incubation and hatching workflows are wired to v2 setting/hatching processes.",
      },
      orders: {
        title: "Orders module",
        description:
          "In the next iteration we will build the mockup order pipeline with real components and validated forms.",
      },
      settings: {
        title: "Settings module",
        description:
          "Incubators, capacities, and normative standards will live here as focused settings slices.",
      },
    },
  },
  ru: {
    app: {
      name: "InterAgro ERP",
      descriptor: "Interagro Hatchery",
      search: "Поиск...",
      openMenu: "Открыть меню",
      screenshot: {
        idle: "Скриншот",
        hint: "Снимок экрана копируется — вставьте его в Telegram",
        busy: "Готовится",
        copied: "Скопировано",
        downloaded: "Скачано",
        failed: "Не удалось",
      },
      collapseMenu: "Свернуть меню",
      expandMenu: "Развернуть меню",
      navigationLabel: "Основная навигация",
      darkTheme: "Темная тема",
      lightTheme: "Светлая тема",
      logout: "Выйти",
      logoutDescription: "Вы выйдете из аккаунта. Продолжить?",
      logoutTitle: "Выход из системы",
      notifications: "Уведомления",
      help: "Помощь",
      roleInspector: "Инспектор",
      roleAdmin: "Администратор",
      roleSuperAdmin: "Супер администратор",
      roleSalesManager: "Менеджер продаж",
    },
    nav: {
      dashboard: "Дашборд",
      salesDashboard: "Панель продаж",
      orders: "Заказы",
      hatchCalendar: "Календарь вывода",
      customers: "Клиенты",
      payments: "Поступления",
      debtors: "Должники",
      creditors: "Кредиторы",
      reminders: "Напоминания",
      expenses: "Расходы",
      eggBatches: "Партии",
      plannedBatches: "Партии",
      pricing: "Цены",
      competitors: "Конкуренты",
      receiving: "Приемка",
      sorting: "Сортировка",
      incubations: "Инкубация",
      settingFlow: "Инкубация",
      hatchingFlow: "Вывод",
      branchOrders: "Заказы",
      settings: "Настройки",
      branches: "Филиалы",
      suppliers: "Поставщики",
      incubationMachines: "Инкубационные машины",
      eggStandards: "Стандарты яиц",
      vaccines: "Вакцины",
      users: "Пользователи",
      roles: "Роли",
      sections: {
        sales: "Продажи",
        incubation: "Инкубация",
        finance: "Финансы",
        settings: "Настройки",
        administration: "Администрирование",
      },
    },
    branchOrders: {
      searchPlaceholder: "Поиск по клиенту, телефону или партии",
      scopeLabel: "Заказы",
      scope: { active: "К выдаче", history: "История" },
      dueTitle: "Выдать сегодня",
      today: "Сегодня",
      late: "Опоздание: {count} дн.",
      totalChicks: "Всего {count} цыпл.",
      columns: {
        customer: "Клиент",
        chicks: "Цыплята",
        vaccines: "Вакцины",
        handover: "Выдача",
        payment: "Оплата",
        status: "Статус",
      },
      handoverKind: { pickup: "Клиент забирает", delivery: "Доставка" },
      noVaccines: "Без вакцин",
      handOver: "Выдано",
      handOverTitle: "Выдача заказа",
      handOverMessage:
        "{customer} забрал(а) {count} цыплят? Заказ будет завершён, клиенту придёт сообщение в Telegram, и отменить это нельзя.",
      emptyTitle: "Выдавать нечего",
      emptyDescription: "Когда отдел продаж примет заказы на партии этого филиала, они появятся здесь по дням вывода.",
      emptyHistoryTitle: "История пуста",
      emptyHistoryDescription: "Здесь хранятся выданные и отменённые заказы.",
      emptyFilteredTitle: "Заказ не найден",
      emptyFiltered: "Попробуйте изменить поиск.",
    },
    sorting: {
      title: "Сортировка яиц",
      subtitle: "Отсортируйте принятые партии перед размещением в инкубации.",
      refresh: "Обновить",
      acceptedBatches: "Принятые партии",
      acceptedTitle: "Партии для сортировки",
      unsortedEggs: "Несортированные яйца",
      sortedUnsetted: "Сортированные не размещены",
      sortedUnsettedTitle: "Партии готовы к инкубации",
      batch: "Партия",
      category: "Категория",
      selectBatch: "Выберите партию",
      selectBatchFirst: "Сначала выберите партию",
      selectCategory: "Выберите категорию",
      noUnsortedCategories: "В этой партии нечего сортировать",
      noAcceptedBatches: "Нет партий для сортировки",
      noSortedUnsetted: "Нет партий, готовых к инкубации",
      tableTitle: "Добавленные строки сортировки",
      noTableRows: "Строки сортировки еще не добавлены",
      eggStandardId: "Стандарт #{id}",
      netEggs: "К размещению",
      add: "Добавить",
      edit: "Редактировать",
      update: "Обновить",
      saveSorting: "Сохранить сортировку",
      lossCannotExceedEggs: "Потери не могут превышать количество яиц",
    },
    regions: {
      ANDIJON: "Андижан",
      BUXORO: "Бухара",
      FARGONA: "Фергана",
      JIZZAX: "Джизак",
      QASHQADARYO: "Кашкадарья",
      NAMANGAN: "Наманган",
      NAVOIY: "Навои",
      SAMARQAND: "Самарканд",
      SIRDARYO: "Сырдарья",
      SURXONDARYO: "Сурхандарья",
      TOSHKENT_VILOYATI: "Ташкентская область",
      XORAZM: "Хорезм",
      TOSHKENT_SHAHRI: "Город Ташкент",
      QORAQALPOGISTON: "Каракалпакстан",
    },
    salesDashboard: {
      title: "Панель продаж",
      emptyHint: "Попробуйте выбрать другой период.",
      kpi: {
        orders: "Заказы",
        chicks: "Продано цыплят",
        chicksBonus: "+{count} бонус",
        received: "Выручка",
        outstanding: "Ожидаемые платежи",
        debt: "Долг",
        compensation: "Возмещение ущерба",
      },
      orders: {
        title: "Статусы заказов",
        columns: {
          status: "Статус",
          orders: "Заказы",
          chicks: "Цыплят",
          collected: "Оплачено",
        },
        categoryTitle: "По весу",
        empty: "В этом периоде заказов нет.",
      },
      payments: {
        title: "Способы оплаты",
        received: "Поступило в кассу",
        fromWallet: "Оплачено из кошельков",
        refunded: "Возвращено",
        transactions: "операций",
        transactionsBadge: "{count} операций",
        columns: {
          method: "Способ",
          amount: "Сумма",
          share: "Доля",
          transactions: "Операции",
        },
        empty: "В этом периоде оплат не было.",
      },
      customers: {
        title: "Лучшие клиенты",
        columns: {
          customer: "Клиент",
          type: "Тип",
          region: "Область",
          orders: "Заказы",
          chicks: "Цыплят",
          collected: "Оплачено",
          balance: "Баланс",
        },
        empty: "В этом периоде клиенты не заказывали.",
      },
      regions: {
        title: "Области",
        columns: {
          region: "Область",
          registered: "В базе",
          orders: "Заказы",
          chicks: "Цыплят",
          collected: "Оплачено",
        },
        empty: "Нет данных по областям.",
      },
      managers: {
        title: "Менеджеры",
        columns: {
          manager: "Менеджер",
          orders: "Заказы",
          booked: "Сумма заказов",
          collected: "Оплачено",
        },
        unattributed: "Не закреплено",
        unattributedHint: "Заказы, созданные до появления учёта автора.",
        empty: "В этом периоде заказы не создавались.",
      },
    },
    pricing: {
      subtitle: "Цены конкурентов и наши еженедельные срезы",
      newSurvey: "Новый срез цен",
      unit: "за 1 цыплёнка, сум",
      weekday: {
        0: "воскресенье",
        1: "понедельник",
        2: "вторник",
        3: "среда",
        4: "четверг",
        5: "пятница",
        6: "суббота",
      },
      current: {
        title: "Текущая цена",
        inForce: "Действует",
        meta: "{date} · установил {name}",
        metaNoName: "{date}",
      },
      market: {
        title: "Цены конкурентов",
        watchList: "Список конкурентов",
      },
      chart: {
        title: "Динамика цен",
        subtitle: "Наша цена по срезам · сум",
      },
      table: {
        title: "Срезы цен",
        history: "История цен",
        subtitle: "Каждый срез — рынок и наша цена в тот день",
        count: "{count} срезов",
        date: "Дата",
      },
      diff: {
        below: "ниже средней",
        above: "выше средней",
        equal: "равна средней",
        noData: "нет данных",
      },
      movement: {
        period: "Период",
        allTime: "Вся история",
        emptyRange: "В этом периоде срезов нет",
      },
      history: {
        title: "Цены конкурента",
        neverQuotedClass: "Цена по этому классу не называлась",
        chartTitle: "Динамика цен",
        tableTitle: "Цены по срезам",
      },
      empty: {
        title: "Срезов цен пока нет",
        description:
          "Обзвонив конкурентов, внесите первый срез — рынок и наша цена сохранятся одной датой.",
        action: "Внести первый срез",
      },
      detail: {
        title: "Срез цен",
        quotedMeta: "опрошено конкурентов: {count}",
        createdBy: "внёс: {name}",
        edit: "Изменить",
        quotesTitle: "Кто какую цену назвал",
        quotesSubtitle: "Каждая ячейка — цена, названная по телефону в тот день",
        noQuotes: "В этом срезе цены конкурентов не вносились.",
        market: "Рынок",
        lowest: "минимум",
        average: "средняя",
        highest: "максимум",
        quotedCount: "{count} конкурентов",
        quotedCountFull: "По этому классу цену назвали {count} конкурентов",
        notQuoted: "—",
        marketAverage: "Средняя по рынку",
        marketLowest: "Самая низкая цена",
        marketHighest: "Самая высокая цена",
        noMarketData: "По этому классу цену никто не назвал — сравнивать с рынком нечего.",
        ourPrice: "Наша цена",
        ourPriceSet: "Цена, которую мы установили в этом срезе, и её место относительно рынка",
        note: "Комментарий",
      },
      form: {
        newTitle: "Новый срез цен",
        editTitle: "Изменить срез",
        subtitle: "Внесите цены конкурентов, затем установите нашу",
        date: "Дата",
        note: "Комментарий",
        optional: "— необязательно",
        notePlaceholder: "Например: на рынке подорожало яйцо",
        quotesTitle: "Цены конкурентов",
        quotesSubtitle: "Пустая ячейка — в тот день цену не назвал",
        removeRow: "Убрать строку",
        readdPlaceholder: "Вернуть строку...",
        statsHint: "минимум · средняя · максимум",
        emptyRows: "Список конкурентов пуст",
        emptyRowsHint: "Добавьте наблюдаемых на экране «Конкуренты» — их цены будут запрашиваться здесь.",
        ourTitle: "Наша цена",
        ourSubtitle: "Вступает в силу на этой неделе · обязательны все три ячейки",
        decision: "Решение",
        priceMissing: "цена не внесена",
        noCompare: "не с чем сравнить",
        belowAvg: "на {amount} сум ниже средней",
        aboveAvg: "на {amount} сум выше средней",
        equalAvg: "равна средней",
        ready: "Готово к сохранению",
        incomplete: "Наша цена не полна — не внесено: {list}",
      },
      competitors: {
        subtitle: "Инкубаторы, которых обзванивают в каждом срезе",
        add: "Добавить конкурента",
        listTitle: "Список наблюдения",
        name: "Конкурент",
        phones: "Телефон",
        note: "Комментарий",
        lastPrice: "Последняя цена",
        actions: "Действия",
        noNote: "— без комментария",
        hide: "Скрыть",
        edit: "Изменить",
        hint: "Если скрыть конкурента, в новых срезах его цена не запрашивается. В прошлых срезах имя и цены остаются.",
        hideTitle: "Скрыть {name} из списка?",
        hideMessage:
          "В следующих срезах его цена не запрашивается. В прошлых срезах имя и названные цены остаются — отчёты не ломаются.",
        empty: {
          title: "Наблюдаемых конкурентов нет",
          description:
            "Добавьте инкубаторы, которые вы обзваниваете. Их цены будут запрашиваться в каждом срезе.",
          action: "Добавить первого конкурента",
        },
        modal: {
          newTitle: "Новый конкурент",
          editTitle: "Изменить конкурента",
          name: "Название",
          namePlaceholder: "Например: Piskent Parranda",
          phones: "Телефоны",
          phonePlaceholder: "+998 90 123 45 67",
          addPhone: "Добавить ещё номер",
          removePhone: "Удалить номер",
          phoneInvalid: "Введите номер телефона полностью",
          note: "Комментарий",
          notePlaceholder: "С кем говорить, какие цены даёт...",
          nameRequired: "Название обязательно",
        },
      },
    },
    plannedBatches: {
      searchPlaceholder: "Поиск партии...",
      allBranches: "Все филиалы",
      allMonths: "Все месяцы",
      newPlan: "Новая партия",
      emptyDay: "Нет партии",
      showOrders: "Показать заказы",
      hideOrders: "Скрыть заказы",
      status: {
        PLANNED: "Ожидается",
        RECEIVED: "Принята",
        HATCHED: "Выведена",
      },
      back: "Назад",
      unit: "шт",
      emptyTitle: "Партий пока нет",
      emptyDescription:
        "Когда поставщик пришлёт график поставки, заведите партию здесь — заказы продаются с этих партий.",
      emptyFilteredTitle: "Партия не найдена",
      emptyFiltered: "Измените поиск, месяц или фильтр филиала.",
      deleteTitle: "Удалить партию",
      deleteMessage:
        "Партия «{name}» будет удалена. Если с неё ещё продаются заказы, сначала перенесите их в другую партию.",
      columns: {
        plan: "Партия",
        supplier: "Поставщик",
        branch: "Филиал",
        arrivalDate: "Дата поставки",
        hatchDate: "Дата вывода",
        totalEggs: "Яйца",
        orderedChicks: "Заказанные цыплята",
        availableChicks: "Доступно для продажи",
        chickCount: "Цыплят",
      },
      detail: {
        eggs: "Всего яиц",
        ordered: "Заказанные цыплята",
        remaining: "Доступно для продажи",
        occupancy: "Занятость",
        chicks: {
          PLANNED: "Ожидаемые цыплята",
          RECEIVED: "Ожидаемые цыплята",
          HATCHED: "Выведенные цыплята",
        },
        chicksFromReceipt: "по приёмке",
        chicksFirstGrade: "1-й сорт",
        receivedOn: "Принята: {date}",
        enteredBy: "Внёс: {name}",
        plannedEggs: "по плану: {count}",
        notReceived: "Яйца ещё не прибыли — все цифры здесь плановые.",
        journey: {
          title: "Путь партии",
          set: "В инкубаторе",
          hatcher: "В выводном",
          now: "Сейчас",
          expected: "Ожидается {date}",
          eggs: "{count} яиц",
          chicks: "{count} цыплят · 1 сорт",
          otherGrades: "2 сорт {second} · 3 сорт {third}",
          lossSorting: "−{count} бой, брак",
          lossCandling: "−{count} неоплод., замершие",
          lossUnhatched: "−{count} не вывелось",
          totalLosses: "Всего потерь:",
        },
        byWeight: {
          title: "По весу",
          weight: "Вес",
          expected: "Ожидается",
          hatched: "Вывелось · 1 сорт",
          ordered: "Заказано",
          remaining: "Осталось",
        },
        orders: "Заказы",
        noOrders: "К этой партии ещё не привязан ни один заказ.",
        customerNo: "Клиент #{id}",
        orderColumns: {
          customer: "Клиент",
          orderedCount: "Заказано",
          bonus: "Бонус",
          dealPrice: "Согласованная цена",
          services: "Услуги",
          amount: "Общая сумма",
          debt: "Задолженность",
          status: "Статус",
        },
      },
      form: {
        newTitle: "Новая партия",
        editTitle: "Редактирование партии",
        basicsTitle: "Основные данные",
        hatchDate: "Дата вывода",
        hatchDatePlaceholder: "Считается от даты поставки",
        supplier: "Поставщик",
        supplierPlaceholder: "Выберите поставщика",
        branch: "Филиал",
        branchPlaceholder: "Выберите филиал",
        arrivalDate: "Дата поставки",
        categoriesTitle: "Категории яиц",
        category: "Категория",
        categoryPlaceholder: "Выберите",
        eggCount: "Количество яиц",
        hatchPercent: "Вывод %",
        expectedChicks: "Ожидаемые цыплята",
        addCategory: "Добавить категорию",
        totalEggs: "Всего яиц",
        totalExpectedChicks: "Всего ожидается цыплят",
        state: { saving: "Сохранение" },
        save: "Сохранить партию",
        notFound: "Партия не найдена",
        notFoundDescription: "Эта партия удалена или никогда не существовала.",
        lockedTitle: "Партия принята",
        lockedDescription: "Инкубаторий принял эту партию — изменить её больше нельзя.",
        errors: {
          supplier: "Выберите поставщика.",
          branch: "Выберите филиал.",
          arrivalDate: "Выберите дату поставки.",
          category: "Введите код категории.",
          eggCount: "Количество яиц должно быть больше 0.",
          hatchPercent: "Процент вывода должен быть от 1 до 100.",
          categoriesRequired: "Добавьте хотя бы одну категорию.",
        },
      },
    },
    salesBatches: {
      searchPlaceholder: "Поиск партии...",
      estimate: "прогноз",
      eggsUnit: "яиц",
      noHatchDate: "Дата не задана",
      notHatchedYet: "ещё не выведено",
      notGradedYet: "ещё не отсортировано",
      emptyTitle: "Партии не найдены",
      emptyDescription: "В выбранном периоде у этого филиала нет партий.",
      emptyFiltered: "Нет партий по запросу.",
      emptyBranchTitle: "В филиале {branch} нет партий",
      emptyBranchDescription:
        "В этот филиал ещё не поступали яйца. Партии создаются в модуле инкубации.",
      columns: {
        hatchDate: "Дата вывода",
        expectedCount: "Ожидаемое количество",
        ordered: "Заказано",
        available: "Остаток",
        occupancy: "Занятость",
        status: "Статус",
      },
      status: {
        PLANNED: "Запланировано",
        SELLING: "В продаже",
        FULL: "Заполнено",
      },
      stage: {
        RECEIVED: "Принято",
        SETTING: "В инкубаторе",
        READY_TO_TRANSFER_TO_HATCHING: "Готово к переводу",
        HATCHING: "В выводном шкафу",
        READY_TO_COMPLETE: "Готово к завершению",
        COMPLETED: "Завершено",
      },
      funnel: {
        eggs: "Принято яиц",
        losses: "Потери",
        expected: "Ожидается",
        actual: "Выведено",
        ordered: "Продано",
      },
      panel: {
        title: "Партия",
        back: "К партиям",
        orders: "Заказы по этой партии",
        noOrders: "По этой партии ещё нет заказов.",
        customer: "Клиент",
        customerNo: "Клиент №{id}",
        count: "Количество",
        amount: "Сумма",
        payment: "Оплата",
        bonus: "бонус",
      },
      aggregate: {
        tab: "Сводка",
        metric: "Показатель",
        total: "Итого",
        expectedRow: "Ожидаемое количество цыплят",
        actualRow: "Выведено цыплят",
        orderedRow: "Заказано цыплят",
        availableRow: "Доступно к продаже, цыплят",
        schedule: "График вывода",
        noSchedule: "В выбранном периоде вывод не запланирован.",
      },
    },
    orders: {
      title: "Заказы",
      newOrder: "Новый заказ",
      searchPlaceholder: "Поиск по клиенту, телефону или партии",
      jojaUnit: "цыплят",
      units: { chicks: "цыплят", chick: "цыпленок", bonus: "бонус", sum: "сум" },
      kanbanEmpty: "В этом статусе заказов нет",
      emptyTitle: "Заказов пока нет",
      emptyDescription: "Создайте первый заказ и управляйте клиентом, партией, ценой и доставкой в одном месте.",
      emptyFiltered: "Заказы по этому фильтру не найдены.",
      deleteTitle: "Удалить заказ",
      deleteMessage: "Заказ #{id} будет удален. Продолжить?",
      draft: {
        title: "Незавершенный заказ",
        restored: "Незавершенный заказ восстановлен",
        noCustomer: "Клиент не выбран",
        continue: "Продолжить",
        startNew: "Начать новый",
        deleteTitle: "Удалить незавершенный заказ",
        deleteMessage: "Введенные данные будут удалены. Продолжить?",
        conflictTitle: "Есть незавершенный заказ",
        conflictMessage: "Ранее начатый заказ сохранен: {summary}. Если начать новый, он будет удален.",
      },
      actions: {
        newOrder: "Новый заказ",
        edit: "Редактировать",
        delete: "Удалить",
      },
      status: {
        PENDING: "В очереди",
        CONFIRMED: "Подтвержден",
        DELIVERED: "Доставлен",
        CANCELLED: "Отменен",
      },
      payment: {
        UNPAID: "Не оплачен",
        PARTIAL: "Частично",
        PAID: "Оплачен",
        ON_ACCOUNT: "На кошельке",
        REFUNDED: "Возвращён",
      },
      category: {
        LIGHT: "Лёгкие",
        MEDIUM: "Средние",
        HEAVY: "Тяжёлые",
      },
      delivery: {
        COMPANY_FREE: "Бесплатная доставка",
        PICKUP: "Самовывоз",
        PAID: "Платная доставка",
      },
      filters: {
        all: "Все",
        allOrders: "Все заказы",
        allPayments: "Все статусы оплаты",
        allMonths: "Все месяцы",
      },
      views: {
        table: "Таблица",
        kanban: "Канбан",
        cards: "Карточки",
      },
      stats: {
        total: "Всего заказов",
        pending: "В ожидании",
        delivered: "Доставлено",
        revenue: "Выручка",
        debt: "Долг",
        cancelled: "Отменено",
      },
      columns: {
        no: "№",
        customer: "Клиент",
        batch: "Партия",
        count: "Количество",
        dealPrice: "Цена сделки",
        marketPrice: "Рыночная цена",
        total: "Итого",
        status: "Статус",
        payment: "Оплата",
        deliveryDate: "Дата доставки",
        orderDate: "Дата заказа",
        bonus: "Бонус",
        receivedAt: "Принят",
      },
      form: {
        newTitle: "Новый заказ",
        editTitle: "Редактировать заказ",
        noBranch: "Сначала выберите филиал, чтобы создать заказ.",
        customerSection: "Клиент и заказ",
        customer: "Клиент",
        selectCustomer: "Выберите клиента",
        batch: "Партия (дата вывода)",
        selectBatch: "Выберите партию",
        weight: "Вес",
        count: "Количество",
        batchChicks: {
          PLANNED: "Ожидаемые цыплята (план)",
          RECEIVED: "Ожидаемые цыплята (принято)",
          HATCHED: "Выведенные цыплята",
        },
        batchOrdered: "Уже заказано",
        batchRemaining: "Доступно для продажи",
        categoryRemaining: "Доступно",
        forecastOverbook:
          "Заказ превышает прогноз партии на {count}. Это не мешает сохранению — фактический вывод обычно выше прогноза.",
        dealPrice: "Согласовано",
        marketPrice: "Рынок",
        bonus: "Бонус",
        bonusPct: "бонус {pct}%",
        totalRow: "Итого: {count} цыплят · Бонус: {bonus}",
        servicesSection: "Услуги",
        vaccines: "Вакцины",
        noVaccines: "Вакцины не добавлены",
        perChick: "сум/цыпленок",
        delivery: "Доставка",
        deliveryPrice: "Цена",
        paymentsSection: "Платежи",
        discount: "Общая скидка",
        paid: "Оплачено",
        remaining: "Остаток",
        walletCharge: "Спишется с кошелька",
        walletReturn: "Вернётся в кошелёк",
        deliveredNote: "Заказ выдан — если сумма изменится, разница пройдёт через кошелёк клиента.",
        summary: "Сводка заказа",
        summaryCategory: {
          LIGHT: "Лёгкого веса",
          MEDIUM: "Среднего веса",
          HEAVY: "Тяжёлого веса",
        },
        summaryBonus: "Бонусные цыплята",
        summaryBonusFree: "бесплатно, вакцинация тоже",
        summaryFree: "бесплатно",
        summaryNoChicks: "Цыплята ещё не добавлены",
        chicksSection: "Цыплята",
        total: "Итого",
        sendTelegram: "Отправить в Telegram",
        sentTelegram: "Отправлено в Telegram",
        copyBotLink: "Скопировать ссылку на бота",
        linkCopied: "Ссылка скопирована",
        copyFailed: "Не удалось скопировать ссылку.",
        telegramOff: "не подключён",
        telegramUnavailable: "Клиент не подключил бота, или бот не настроен.",
        telegramNoPermission: "У вас нет прав на отправку через Telegram.",
        pdf: "PDF",
        createOrder: "Создать заказ",
        saveOrder: "Сохранить заказ",
        confirmSave: {
          createTitle: "Подтвердите заказ",
          saveTitle: "Подтвердите изменения",
          createMessage:
            "{customer} · {count} цыплят · {total} сум. Создать заказ?",
          saveMessage:
            "{customer} · {count} цыплят · {total} сум. Сохранить изменения?",
        },
        errors: {
          customer: "Выберите клиента.",
          batch: "Выберите партию.",
          noItems: "Добавьте хотя бы одну категорию цыплят.",
          deliveryPrice: "Введите цену доставки.",
          discount: "Скидка не может быть отрицательной.",
          total: "Итого должно быть больше 0.",
          overPaid: "Платежи превышают сумму заказа.",
          wallet: "Недостаточно средств в кошельке.",
          bonus: "Бонус не может быть отрицательным.",
          bonusWithoutCount: "Бонус требует количества в той же категории.",
          loadFailed: "Не удалось загрузить заказ.",
          notEditable: "Отменённый заказ нельзя редактировать.",
        },
        backToOrders: "К заказам",
        selectedCount: "выбрано {count}",
        addVaccine: "Выберите вакцину",
        vaccineRetired: "нет в каталоге",
        tenders: "Способы оплаты",
        addTender: "Выберите способ оплаты",
        settled: "Оплаченная сумма",
        settledHint: "Платежи управляются на странице заказа.",
        discountHint: "Для округления небольших сумм — задаёт менеджер",
        share: "Поделиться",
        shareMenu: "Меню «Поделиться»",
      },
      detail: {
        title: "Заказ #{id}",
        notFoundTitle: "Заказ не найден",
        notFoundDescription: "Этот заказ не существует или был удален.",
        batch: "Партия",
        branch: "Филиал",
        orderDate: "Дата заказа",
        deliveryDate: "Дата доставки",
        enteredBy: "Менеджер",
        items: "Цыплята и цены",
        paymentHistory: "История платежей",
        noPayments: "Платежей ещё нет",
        editOrder: "Редактировать заказ",
        customer: "Клиент",
        chargedToWallet: "Перенесено в кошелёк",
        returnedToWallet: "Возвращено в кошелёк",
        overpaid: "Переплата",
        overpaidHint: "Вернётся в кошелёк при выдаче",
        openWallet: "Открыть кошелёк",
        paymentStatus: "Статус оплаты",
        acceptPayment: "Принять оплату",
        acceptPaymentBtn: "Принять оплату",
        statusActions: "Изменить статус",
        move: {
          CONFIRMED: "Подтвердить",
          DELIVERED: "Подтвердить передачу",
          CANCELLED: "Отменить",
        },
        confirm: {
          CONFIRMED: {
            title: "Подтвердить заказ",
            message: "Заказ будет подтвержден. Продолжить?",
          },
          DELIVERED: {
            title: "Подтвердить передачу",
            message: "Заказ будет отмечен как доставленный, остаток останется списанным. Продолжить?",
          },
        },
      },
      cancel: {
        title: "Отмена заказа",
        reason: "Причина отмены",
        reasonPlaceholder: "Например: клиент отказался от заказа",
        reasonRequired: "Укажите причину отмены.",
        paid: "Клиент оплатил {amount} по этому заказу. Как вернуть деньги?",
        refundRequired: "Выберите способ возврата.",
        refund: {
          WALLET: "В кошелёк клиента",
          CASH: "Клиенту на руки",
        },
        refunded: {
          WALLET: "{amount} возвращено в кошелёк",
          CASH: "{amount} возвращено наличными",
        },
        note: "Причина отмены",
        dismiss: "Назад",
        confirm: "Отменить заказ",
      },
      hatchCalendar: {
        dateRange: "Дата вывода",
        empty: "В этом периоде партий на вывод не найдено.",
        error: "Не удалось загрузить календарь вывода.",
      },
    },
    payments: {
      deleteTitle: "Удалить оплату",
      deleteMessage: "Оплата на {amount} сум будет удалена — оплаченная сумма заказа уменьшится на столько же. Продолжить?",
      deleteAccountMessage: "Оплата на {amount} сум будет удалена — баланс кошелька клиента уменьшится на столько же. Продолжить?",
      deleteBlocked: {
        DELIVERED: "Заказ выдан — его оплату удалить нельзя. Исправление вносите через кошелёк клиента.",
        CANCELLED: "Заказ отменён, оплата возвращена клиенту — удалить оплату нельзя.",
      },
      recordTitle: "Внести платеж",
      applyToOrder: "Привязать к заказу",
      onWallet: "В кошелёк",
      amount: "Сумма",
      method: "Способ оплаты",
      date: "Дата платежа",
      note: "Примечание (необязательно)",
      notePlaceholder: "Примечание к платежу...",
      remainingAfter: "Остаток после платежа",
      record: "Внести платеж",
      list: {
        search: "Поиск по клиенту, заказу или примечанию...",
        empty: "Платежей пока нет",
        emptyFiltered: "Нет платежей по выбранным фильтрам",
        allTypes: "Все способы оплаты",
        month: "Месяц",
        totalCollected: "Всего принято",
        count: "{count} платежей",
        totalRefunded: "Возвращено",
        fromWallet: "Оплачено из кошельков",
        refundCount: "{count} заказов",
        columns: {
          date: "Дата",
          customer: "Клиент",
          order: "Заказ",
          methods: "Способы оплаты",
          amount: "Сумма",
          attachment: "Чек",
          receivedBy: "Принял",
          notes: "Примечание",
        },
      },
      detail: {
        title: "Платёж #{id}",
        pageTitle: "Платёж",
        amount: "Сумма платежа",
        walletNote: "Принят без заказа — зачислен в кошелёк клиента",
        order: "Заказ #{id}",
        receipt: "Приём",
        notFoundTitle: "Платёж не найден",
        notFoundDescription: "Платёж удалён или адрес неверный.",
        receivedBy: "Принял",
        notes: "Примечание",
        tenders: "Способы оплаты",
      },
      audit: {
        title: "История изменений",
        actions: {
          CREATE: "Платёж внесён",
          UPDATE: "Платёж изменён",
          DELETE: "Платёж удалён",
          ATTACH: "Документ изменён",
        },
        fields: {
          AMOUNT: "Сумма",
          TENDERS: "Способы оплаты",
          PAID_AT: "Дата",
          NOTES: "Примечание",
          ATTACHMENTS: "Чеки",
        },
      },
      attachment: {
        title: "Чек / квитанция",
        add: "Прикрепить документ",
        hint: "JPG, PNG или PDF · до 10 МБ",
        addMore: "Добавить ещё чек",
        previous: "Предыдущий",
        next: "Следующий",
        open: "Открыть документ",
        download: "Скачать",
        noPreview: "Этот файл нельзя показать здесь — скачайте его.",
        empty: "Документ не прикреплён.",
        tooLarge: "Файл не должен превышать 10 МБ.",
        uploadFailed: "Не удалось загрузить файл.",
        removeTitle: "Удалить документ",
        removeMessage: "Чек по этому платежу будет удалён. Продолжить?",
      },
      type: {
        CASH: "Наличные",
        CARD: "Карта",
        BANK: "Банк",
        WALLET: "Кошелёк",
      },
      errors: {
        customer: "Выберите клиента.",
        order: "Выберите заказ.",
        amount: "Введите сумму.",
        exceeds: "Превышает остаток (макс {amount}).",
        wallet: "Недостаточно средств в кошельке (макс {amount}).",
      },
      actions: {
        newPayment: "Новый платёж",
      },
      form: {
        newTitle: "Новая оплата",
        editTitle: "Изменить платёж",
        back: "Оплаты",
        customer: "Клиент",
        selectCustomer: "Выберите клиента",
        selectOrder: "Выберите заказ",
        noOutstanding: "У этого клиента нет неоплаченных заказов.",
        target: "Куда идут деньги",
        targetOrder: "На заказ",
        targetWallet: "В кошелёк",
        walletHint: "без заказа — долг по выданным заказам или аванс",
        walletNow: "Баланс сейчас",
        walletAfter: "После платежа",
        orderTotal: "Сумма заказа",
        alreadyPaid: "Оплачено",
        debt: "Остаток",
        tenders: "Способы оплаты",
        addTender: "Выберите способ оплаты",
        fillRemaining: "Заполнить остаток",
        walletBalance: "Баланс кошелька: {amount} сум",
        time: "Время",
      },
    },
    wallet: {
      topUpTitle: "Пополнить кошелёк",
      withdrawTitle: "Списать с кошелька",
      currentBalance: "Текущий баланс",
      amount: "Сумма",
      reason: "Причина",
      order: "Заказ",
      description: "Примечание (необязательно)",
      descriptionRequired: "Примечание (обязательно)",
      descriptionPlaceholder: "Добавьте примечание...",
      compensationPlaceholder: "Например: заказ №41 — пало 50 цыплят",
      reasonInfoLabel: "Что такое «{reason}»?",
      reasonInfo: {
        TOP_UP: {
          BONUS: "Деньги клиенту в подарок — например, поощрение за крупную покупку.",
          REFUND: "Возврат денег, которые заплатил клиент: переплата, сниженная цена или исправление ошибки. Деньги отменённого заказа система возвращает сама.",
          OPENING_BALANCE: "Остаток до перехода на систему: сумма, которую компания была должна клиенту.",
          COMPENSATION: "Деньги, которые компания платит за цыплят, павших в первую неделю. Укажите номер заказа в примечании. В выручку не входит.",
          OTHER: "Случай, который не подходит под причины выше, — опишите его в примечании.",
        },
        WITHDRAWAL: {
          CASH_OUT: "Выдача денег из кошелька клиенту наличными. Не больше, чем есть в кошельке.",
          FINE: "Штраф, удерживаемый с клиента. Ниже нуля записывается как долг.",
          OPENING_BALANCE: "Долг до перехода на систему: сумма, которую клиент был должен компании.",
          OTHER: "Списание, которое не подходит под причины выше, — опишите его в примечании.",
        },
      },
      balanceAfter: "Баланс после",
      goesIntoDebt: "Кошелёк уйдёт в минус — клиент станет должником.",
      submitTopUp: "Пополнить",
      submitWithdraw: "Списать",
      types: {
        TOP_UP: "Пополнение кошелька",
        WITHDRAWAL: "Списание с кошелька",
      },
      detail: {
        pageTitle: "Движение по кошельку",
        back: "Кошелёк",
        facts: "Детали движения",
        performedBy: "Кто провёл",
        at: "Время",
        payment: "Платёж",
        paymentNumber: "Платёж №{id}",
        noAttachment: "Подтверждающий документ не приложен.",
        notFoundTitle: "Движение не найдено",
        notFoundDescription: "Это движение по кошельку удалено или никогда не существовало.",
      },
      reasons: {
        CASH: "Наличные",
        CARD: "Картой",
        BANK: "Банковский перевод",
        BONUS: "Бонус",
        REFUND: "Возврат средств",
        OPENING_BALANCE: "Начальный остаток",
        PAYMENT: "Платёж",
        ORDER_SETTLEMENT: "Заказ выдан",
        WRITE_OFF: "Списано",
        COMPENSATION: "Возмещение ущерба",
        CASH_OUT: "Выдача наличных",
        FINE: "Штраф",
        ORDER: "За заказ",
        OTHER: "Другое",
      },
      attachment: {
        title: "Подтверждающий документ",
        label: "Подтверждающий документ (необязательно)",
        add: "Прикрепить документ",
        replace: "Заменить документ",
        open: "Открыть документ",
        tooLarge: "Файл не должен превышать 10 МБ.",
        uploadFailed: "Не удалось загрузить файл.",
        removeTitle: "Удалить документ",
        removeMessage: "Подтверждающий документ будет удалён. Сумма и баланс не изменятся. Продолжить?",
      },
      errors: {
        amount: "Введите сумму.",
        scale: "Сумма может иметь не более 2 знаков после запятой.",
        insufficient: "В кошельке недостаточно средств",
        descriptionRequired: "Для этой причины примечание обязательно.",
        descriptionTooLong: "Примечание не должно превышать 500 символов.",
      },
    },
    reminders: {
      title: "Напоминания",
      formTitle: "Напоминание",
      search: "Поиск по заметке или клиенту...",
      empty: "Напоминаний пока нет",
      emptyFiltered: "Нет напоминаний по выбранным фильтрам",
      deleteTitle: "Удалить напоминание",
      deleteMessage: "Это напоминание будет удалено. Продолжить?",
      completeTitle: "Отметить выполненным",
      completeMessage: "Напоминание будет отмечено как выполненное. Это нельзя отменить.",
      actions: {
        create: "Новое напоминание",
        edit: "Изменить",
        complete: "Выполнено",
        delete: "Удалить",
      },
      views: {
        table: "Таблица",
        kanban: "Канбан",
      },
      kanbanEmpty: "В этом статусе напоминаний нет",
      status: {
        TODAY: "Сегодня",
        OVERDUE: "Просрочено",
        UPCOMING: "Предстоящее",
        DONE: "Выполнено",
      },
      fields: {
        customer: "Клиент",
        phone: "Телефон",
        note: "Заметка",
        date: "Дата",
        time: "Время",
        status: "Статус",
        createdBy: "Записал",
        completedAt: "Дата выполнения",
      },
      filters: {
        allReminders: "Все напоминания",
        dateRange: "Период",
      },
      placeholders: {
        note: "Что нужно сделать? Например: позвонить по оплате июньской партии",
        selectCustomer: "Выберите клиента",
      },
      hints: {
        customerLocked: "Клиента напоминания изменить нельзя.",
        overdueIgnoresRange: "Просроченные напоминания показываются независимо от периода.",
        late: "Время прошло",
      },
      errors: {
        note: "Введите текст напоминания",
        date: "Выберите дату",
        time: "Выберите время",
        customer: "Выберите клиента",
      },
    },
    customers: {
      formTitle: "Клиент",
      search: "Поиск по клиенту, телефону, региону или адресу...",
      sort: {
        label: "Сортировка",
        newest: "Сначала новые",
        oldest: "Сначала старые",
        name: "По имени",
        region: "По региону",
        debt: "Сначала должники",
      },
      empty: "Клиентов пока нет",
      deleteTitle: "Удалить клиента",
      deleteMessage: "Клиент будет удален из списка. Продолжить?",
      deleteWithBalanceMessage: "{amount} сум в кошельке будут списаны, а клиент удалён. Продолжить?",
      actions: {
        create: "Добавить клиента",
      },
      filters: {
        allRegions: "Все регионы",
      },
      fields: {
        no: "№",
        name: "Клиент",
        phone: "Телефон",
        country: "Страна",
        region: "Регион",
        address: "Адрес",
        walletBalance: "Кошелёк",
        type: "Тип клиента",
        notes: "Заметки",
      },
      typeHint: "Уровень для цен и отчётов.",
      optional: "— необязательно",
      notesPlaceholder: "Добавьте заметку о клиенте...",
      placeholders: {
        address: "Улица, дом, кв.",
        selectCountry: "Выберите страну",
        selectRegion: "Выберите регион",
      },
      avatar: {
        upload: "Загрузить фото",
        change: "Изменить фото",
        remove: "Удалить",
        hint: "PNG или JPG, до 10 МБ.",
        tooLarge: "Размер изображения не должен превышать 10 МБ.",
        invalidType: "Допускаются только изображения.",
        uploadFailed: "Не удалось загрузить изображение. Попробуйте ещё раз.",
      },
      errors: {
        phoneInvalid: "Неверный номер телефона. Формат: +998 XX XXX XX XX",
        regionRequired: "Выберите регион.",
      },
      detail: {
        title: "Профиль клиента",
        back: "Клиенты",
        edit: "Редактировать",
        customerSince: "Клиент с",
        tier: "Уровень {type}",
        comingSoon: "Этот раздел скоро появится.",
        notFoundTitle: "Клиент не найден",
        notFoundDescription: "Этот клиент удалён или не существует.",
        tabs: {
          overview: "Общее",
          orders: "Заказы",
          payments: "Платежи",
          wallet: "Кошелёк",
          reminders: "Напоминания",
          activity: "Активность",
        },
      },
      overview: {
        noNotes: "Заметок пока нет",
        totalOrders: "Всего заказов",
        cancelled: "Отменено",
        boughtChicks: "Куплено цыплят",
        totalValue: "Общая сумма",
        walletBalance: "Баланс кошелька",
        debt: "Долг",
        openOrdersUnpaid: "Ожидаемые платежи",
        financeSoon: "Статистика заказов, платежей и кошелька скоро появится.",
      },
      activity: {
        empty: "Активности пока нет",
        deleteTitle: "Удалить заметку",
        deleteMessage: "Эта заметка будет удалена. Продолжить?",
      },
      conversations: {
        title: "Разговоры с клиентом",
        latest: "Последний разговор",
        placeholder: "О чём поговорили? С чего начать в следующий раз?",
        save: "Записать",
        charCount: "{n} / {max}",
        expand: "Читать полностью",
        collapse: "Свернуть",
        readOnly: "Нет прав на запись разговоров",
        editSave: "Сохранить",
        editCancel: "Отмена",
        retry: "Повторить",
        errorLoad: "Не удалось загрузить разговоры",
        errorSave: "Не удалось сохранить разговор. Ваш текст сохранён.",
        errorUpdate: "Не удалось сохранить изменение",
        deleteTitle: "Удалить разговор",
        deleteMessage: "«{excerpt}» будет удалён. Запись в истории активности останется.",
        empty: {
          title: "Разговоров пока нет",
          body: "После разговора с клиентом запишите главное — в следующий звонок сразу вспомните, на чём остановились.",
        },
      },
      orders: {
        priceSensitive: "Чувствительный к цене клиент",
        givenProfit: "Упущенная прибыль",
        avgDeal: "Средняя согласованная цена",
        avgMarket: "Средняя рыночная цена",
        totalDiff: "Общая разница",
        orderedChicks: "Всего цыплят",
        bonusChicks: "+{count} бонус",
        totalOrders: "Всего заказов",
        cancelled: "Отменено",
        totalValue: "Общая стоимость",
        empty: "У этого клиента пока нет заказов.",
      },
      payments: {
        outstanding: "Неоплаченные заказы",
        totalDue: "Всего к оплате",
        noOutstanding: "Нет неоплаченных заказов.",
        noHistory: "Платежей пока нет.",
      },
      wallet: {
        balance: "Баланс кошелька",
        debtor: "Должник",
        creditor: "Переплата",
        openOrdersUnpaid: "Ожидаемые платежи",
        noTransactions: "Операций пока нет.",
      },
    },
    debtors: {
      empty: "Должников нет",
      stats: {
        totalDebt: "Общий долг",
        debtors: "Должники",
      },
      columns: {
        no: "№",
        customer: "Клиент",
        debt: "Долг",
        status: "Итог разговора",
      },
      status: {
        placeholder: "Итог разговора",
        saved: "Сохранено",
      },
    },
    creditors: {
      empty: "Кредиторов нет",
      stats: {
        totalCredit: "Всего к возврату",
        creditors: "Кредиторы",
      },
      columns: {
        no: "№",
        customer: "Клиент",
        credit: "Сумма",
      },
    },
    expenses: {
      locked: "Записан из движения по кошельку клиента — изменить или удалить нельзя.",
      form: {
        newTitle: "Новый расход",
        editTitle: "Изменить расход",
      },
      search: "Поиск по описанию, категории или автору...",
      empty: "Расходов пока нет",
      deleteTitle: "Удалить расход",
      deleteMessage: "Расход будет удален из списка. Продолжить?",
      actions: {
        create: "Добавить расход",
      },
      stats: {
        today: "Сегодня",
        month: "Этот месяц",
        count: "{count} расходов",
      },
      filters: {
        allCategories: "Все категории",
      },
      fields: {
        category: "Категория",
        amount: "Сумма",
        expenseDate: "Дата расхода",
        expenseTime: "Время",
        description: "Описание",
        paymentType: "Тип оплаты",
        walletMovement: "Движение по кошельку",
        currency: "Валюта",
        createdBy: "Кто внёс",
        createdAt: "Время ввода",
      },
      receipt: {
        title: "Чек",
        attach: "Прикрепить чек",
        hint: "PDF или фото, до 10 МБ",
        tooLarge: "Файл не должен превышать 10 МБ.",
        uploadFailed: "Не удалось загрузить файл. Попробуйте ещё раз.",
        download: "Скачать",
      },
      detail: {
        title: "Детали расхода",
        notFoundTitle: "Расход не найден",
        notFoundDescription: "Этот расход удалён или ссылка неверна.",
      },
      placeholders: {
        amount: "Например: 250 000",
        description: "Краткое описание расхода",
      },
      errors: {
        category: "Выберите категорию.",
        amount: "Введите сумму.",
      },
    },
    branch: {
      label: "Филиал",
      activeTag: "Текущий",
      placeholder: "Выберите филиал",
      none: "Нет филиалов",
      loadError: "Не удалось загрузить филиалы.",
      retry: "Повторить",
      deleteActiveHint: "Нельзя удалить филиал, в котором вы работаете.",
      required: {
        title: "Филиал не выбран",
        empty: "Этот раздел привязан к филиалу, но филиалов пока нет.",
        forbidden: "У вас нет прав на просмотр филиалов. Обратитесь к администратору.",
        cta: "Добавить филиал",
      },
    },
    common: {
      cancel: "Отмена",
      clear: "Очистить",
      close: "Закрыть",
      confirm: "Подтвердить",
      details: "Подробнее",
      error: "Ошибка",
      loading: "Загрузка",
      noData: "Нет данных",
      ready: "Готово",
      save: "Сохранить",
      delete: "Удалить",
      remove: "Убрать",
      edit: "Редактировать",
      som: "сум",
      count: "{count}",
      showMore: "Показать больше",
      showLess: "Показать меньше",
      soon: "скоро",
      comingSoon: "Этот раздел скоро появится.",
      datePlaceholder: "дд.мм.гггг",
      dateTimePlaceholder: "дд.мм.гггг чч:мм",
      months: {
        1: "Январь",
        2: "Февраль",
        3: "Март",
        4: "Апрель",
        5: "Май",
        6: "Июнь",
        7: "Июль",
        8: "Август",
        9: "Сентябрь",
        10: "Октябрь",
        11: "Ноябрь",
        12: "Декабрь",
      },
      wholeYear: "Весь год",
      wholeYearOf: "Весь {year} год",
      errors: {
        unexpected: "Произошла непредвиденная ошибка. Попробуйте ещё раз.",
      },
      status: {
        available: "Свободно",
        loaded: "Занято",
        broken: "Неисправно",
      },
    },
    enums: {
      weightCategory: {
        LIGHT: "Лёгкий (<40 г)",
        MEDIUM: "Средний (40-48 г)",
        HEAVY: "Тяжёлый (≥48 г)",
      },
      incubationMachineType: {
        SETTER: "Инкубация",
        HATCHER: "Вывод",
      },
      expensePaymentType: {
        CASH: "Наличные",
        CARD: "Карта",
        BANK: "Банк",
        WALLET: "Через кошелёк",
      },
      expenseCurrency: {
        UZS: "сум",
        USD: "USD",
        EUR: "EUR",
        RUB: "RUB",
      },
      incubationMachineStatus: {
        ACTIVE: "Активна",
        INACTIVE: "Неактивна",
      },
      incubationMachineState: {
        FREE: "Свободно",
        LOADED: "Загружено",
        BROKEN: "Неисправно",
      },
    },
    settingsAdmin: {
      actions: {
        add: "Добавить",
        edit: "Изменить",
        delete: "Удалить",
        save: "Сохранить",
        refresh: "Обновить",
        close: "Закрыть",
      },
      form: {
        create: "Новый",
        edit: "Редактировать",
      },
      states: {
        empty: "Пока нет данных",
        error: "Не удалось загрузить данные",
      },
      labels: {
        total: "Всего",
        search: "Поиск...",
        name: "Название",
        capacity: "Вместимость",
        type: "Тип",
        status: "Статус",
        inactiveReason: "Причина неактивности",
        category: "Категория",
        parentAgeInWeeks: "Возраст в неделях",
        hatchabilityPercent: "Выводимость",
        weight: "Вес (г)",
        weightCategory: "Весовая категория",
        contactPersonName: "Контактное лицо",
        contactPersonPhoneNumber: "Телефон",
        address: "Адрес",
        price: "Цена",
      },
      branches: {
        title: "Филиалы",
        formTitle: "Филиал",
        subtitle: "Управление филиалами инкубатория.",
        create: "Добавить филиал",
        deleteTitle: "Удалить филиал",
        deleteMessage:
          "Филиал будет удалён. Удалить можно только филиал без данных. Продолжить?",
        nameRequired: "Введите название филиала.",
        nameExists: "Филиал с таким названием уже существует.",
      },
      suppliers: {
        title: "Поставщики",
        formTitle: "Поставщик",
        subtitle: "Управление контактами и адресами поставщиков.",
        create: "Добавить поставщика",
        search: "Поиск по названию, контакту или адресу...",
        deleteTitle: "Удалить поставщика",
        deleteMessage: "Поставщик будет удален из списка. Продолжить?",
      },
      incubationMachines: {
        title: "Инкубационные машины",
        formTitle: "Инкубационная машина",
        subtitle:
          "Управление вместимостью и статусом машин инкубации и вывода.",
        create: "Добавить машину",
        search: "Поиск по названию машины или статусу...",
        deleteTitle: "Удалить машину",
        deleteMessage: "Машина будет удалена из списка. Продолжить?",
      },
      eggStandards: {
        title: "Стандарты яиц",
        formTitle: "Стандарт яйца",
        subtitle: "Управление категорией, возрастом в неделях и выводимостью.",
        create: "Добавить стандарт",
        search: "Поиск по категории или названию...",
        deleteTitle: "Удалить стандарт",
        deleteMessage: "Стандарт будет удален из списка. Продолжить?",
      },
      expenseCategories: {
        title: "Категории расходов",
        formTitle: "Категория расходов",
        subtitle: "Управление категориями, которые используются в расходах.",
        create: "Добавить категорию",
        search: "Поиск по названию категории...",
        deleteTitle: "Удалить категорию",
        deleteMessage: "Категория будет удалена из списка. Продолжить?",
      },
      vaccines: {
        title: "Вакцины",
        formTitle: "Вакцина",
        subtitle: "Управление услугами вакцинации для заказов.",
        create: "Добавить вакцину",
        search: "Поиск по названию вакцины или цене...",
        deleteTitle: "Удалить вакцину",
        deleteMessage: "Вакцина будет удалена из списка. Продолжить?",
      },
    },
    incubationFlow: {
      active: "Активные",
      avgHumidity: "Сред. влажность",
      avgTemperature: "Сред. температура",
      batch: "Партия",
      completed: "Завершено",
      dateRange: "Период",
      empty: "Пока нет процессов",
      eggs: "Яйца",
      hatchingSubtitle:
        "Процессы вывода и ежедневные наблюдения ведутся отдельно.",
      hatchingTitle: "Вывод",
      humidity: "Влажность",
      inspectionButton: "Проверил",
      inspectionHint:
        "После подтверждения контроля руководители будут уведомлены.",
      inspectionLast: "Последний контроль: {time}",
      inspectionSaved: "Контроль сохранен",
      inspectionOverdue: "Контроль просрочен",
      inspectionTitle: "Контроль инкубаторов",
      hatcherInspectionHint:
        "После подтверждения контроля руководители будут уведомлены.",
      hatcherInspectionTitle: "Контроль выводных инкубаторов",
      latestLog: "Последний лог",
      loading: "Загрузка",
      machines: "Машины",
      settingSubtitle:
        "Инкубационные процессы с ежедневным контролем температуры и влажности.",
      settingTitle: "Инкубация",
      status: {
        TRANSFERRED_TO_ANOTHER_SETTER: "Перенесено в другой инкубатор",
        IN_SETTING: "В инкубации",
        NEW: "Новый",
        TRANSFERRED_TO_HATCHING: "Перенесено на вывод",
      },
      hatchingStatus: {
        TRANSFERRED_TO_ANOTHER_HATCHER: "Перенесено в другую выводную машину",
        IN_HATCHING: "На выводе",
        NEW: "Новый",
        COMPLETED: "Завершено",
      },
      completeHatching: "Завершить вывод",
      firstGradeCount: "1 сорт",
      hatchingLifecycleEyebrow: "Статус вывода",
      hatchingLifecycleTitle: "Процессы вывода",
      results: "Результаты",
      secondGradeCount: "2 сорт",
      selectMachine: "Выберите машину",
      settingLifecycleEyebrow: "Статус инкубации",
      settingLifecycleTitle: "Процессы инкубации",
      startConfirmMessage:
        "{setting} ({machine}) начнет процесс инкубации. Продолжить?",
      startConfirmTitle: "Подтвердите запуск инкубации",
      startShort: "Старт",
      startSetting: "Начать инкубацию",
      thirdGradeCount: "3 сорт",
      temperature: "Температура",
      totalHatchings: "Вывод",
      totalSettings: "Инкубации",
      transferAutoFill: "Автозаполнить",
      transferBrokenDefaultReason: "Причина переноса: инкубатор неисправен",
      transferBrokenNo: "нет",
      transferBrokenReason: "Причина неисправности",
      transferBrokenReasonPlaceholder: "Например: неисправен мотор",
      transferBrokenReasonRequired: "Укажите причину неисправности",
      transferBrokenYes: "да",
      transferConfirmMessage:
        "{setting} будет перенесен из {source} в {count} целевых инкубаторов. Отметить источник неисправным: {broken}. Продолжить?",
      transferConfirmTitle: "Подтвердите перенос в другой инкубатор",
      transferCreated: "Инкубация перенесена в другой инкубатор",
      transferFailed: "Не удалось перенести в другой инкубатор",
      transferInvalidDistribution:
        "Яйца по каждому стандарту должны быть распределены полностью",
      transferMarkBroken: "Отметить исходный инкубатор неисправным",
      transferMarkBrokenHint: "После переноса машина станет неактивной",
      transferModalTitle: "Распределить яйца в другой инкубатор",
      transferAvailableTargets: "Свободные инкубаторы",
      transferNoTargets: "Нет свободных целевых инкубаторов",
      transferNotEnoughCapacity:
        "Недостаточно свободной вместимости: {capacity} мест для {eggs} яиц",
      transferPlaced: "Размещено яиц",
      transferRemaining: "Осталось:",
      transferRemainingCapacity: "Оставшаяся свободная вместимость",
      transferRequired: "Яиц перенести",
      transferSelectTargets: "Выберите свободные инкубаторы для переноса",
      transferShort: "Перенос",
      transferSourcePatchFailed:
        "Не удалось отметить исходную машину неисправной",
      transferSourcePatchFailedWithReason:
        "Перенос выполнен, но статус исходной машины не обновлен: {reason}",
      transferStandard: "Стандарт",
      transferSubmit: "Перенести",
      transferTargetCapacity: "Свободная вместимость",
      transferTargetOverflow: "Превышена вместимость целевого инкубатора",
      transferTargetTotal: "Итого по цели",
      transferTargets: "Цели",
      transferTotal: "Итого",
      transferToAnotherHatcher: "Перенести в другой выводной инкубатор",
      transferToAnotherSetter: "Перенести в другой инкубатор",
      unhatchedCount: "Не вывелось",
    },
    sessionEdit: {
      title: "Редактирование",
      maxHint: "Не больше {count}",
      eggsLocked: "Яйца уже переведены в выводной шкаф — количество больше не меняется.",
      splitLocked: "Перенесено до учёта потерь — меняется только процент.",
      leftSetter: "Вышло из инкубатора: {count}",
      invalidDates: "Начало должно быть раньше окончания.",
      invalidEggs: "Проверьте количество яиц.",
    },
    machinePark: {
      available: "Свободна",
      broken: "Сломана",
      capacity: "Вместимость",
      period: "Срок",
      periodOf: "Из {total} · {percent}%",
      durationDaysHours: "{days} дн {hours} ч",
      durationDays: "{days} дн",
      durationHours: "{hours} ч",
      detailsTitle: "Данные машины",
      empty: "Пока нет машин",
      eggs: "Яйца",
      humidity: "Влажность",
      loaded: "Занята",
      loadedNoProcess: "Занята, процесс не найден",
      machineCount: "Всего машин: {count}",
      ready: "Готово",
      reason: "Причина",
      status: "Статус",
      temperature: "Температура",
      totalCapacity: "Общая вместимость",
      transferred: "Перенесено на вывод",
    },
    settingAllocator: {
      availableCount: "{count} свободно",
      availableMachinesSelect: "Инкубаторы setter",
      availableMachines: "Свободные инкубационные машины",
      batchLoadFailed: "Не удалось загрузить партии",
      batchRemaining: "Остаток партии",
      batch: "Партия",
      capacityExceededBy: "Выбрано на {count} яиц больше вместимости машины",
      capacityLeft: "Свободно: {count}",
      confirmMessage:
        "{eggs} яиц из партии {batch} будут размещены в машине {machine}. Продолжить?",
      confirmTitle: "Подтвердите размещение в инкубацию",
      createFailed: "Не удалось создать инкубацию",
      created: "Партия размещена в инкубационных машинах",
      distributions: "Категории яиц",
      duplicateStandard: "Эта категория уже добавлена",
      duration: "{days} дней инкубации",
      eggCount: "Количество яиц",
      eyebrow: "Следующий этап",
      expectedChicks: "Ожидаемые цыплята",
      fillMachine: "Заполнить свободное место",
      hatchability: "Выводимость",
      startDate: "Начало",
      endDate: "Окончание",
      total: "Итого",
      hint: "Система подбирает оптимальную комбинацию по вместимости и свободному месту.",
      invalidDistribution: "Проверьте распределение яиц",
      invalidEggCount: "Количество яиц должно быть целым числом и не меньше 0",
      invalidEggValues: "Проверьте количество яиц в {count} строках",
      machine: "Инкубационная машина",
      machineCapacityLeft: "Свободная вместимость",
      machineFill: "Заполнение машины",
      machineFull: "В этой машине нет свободного места",
      loadMachine: "Загрузить",
      maxEggs: "Максимум: {count}",
      noAvailableMachines: "Нет свободных инкубационных машин",
      noBatches: "Нет неразмещенных партий",
      noCapacityLeft: "Свободной вместимости в машине не осталось",
      noRemainingCategories: "В этой партии не осталось яиц для размещения",
      noPlan: "Сначала выберите партию и машины",
      notEnoughCapacity: "В выбранных машинах недостаточно вместимости",
      plan: "План размещения",
      placeEggs: "Яиц разместить",
      recommend: "Подобрать оптимально",
      recommended: "Рекомендовано",
      remaining: "Не хватает",
      remainingLoadFailed: "Не удалось загрузить остатки категорий",
      rowLimitExceeded: "{count} строк превышают остаток яиц в партии",
      rowLimitExceededShort: "Нельзя больше остатка яиц в партии",
      saving: "Сохранение",
      searchBatch: "Поиск партии...",
      selectBatch: "Выберите партию",
      selectBatchEmptyHint:
        "Выберите партию сверху, и распределение яиц появится здесь автоматически.",
      selectBatchFirst: "Сначала выберите партию",
      selectDistributionFirst: "Выберите хотя бы одну категорию яиц",
      selectMachineFirst: "Выберите инкубационную машину",
      selectMachineAndBatch: "Сначала выберите машину и партию",
      placedEggs: "Размещено яиц",
      selectedEggs: "Выбрано яиц",
      selectedCapacity: "Выбранная вместимость",
      submit: "Разместить в инкубацию",
      totalPlacementLosses: "Потери при закладке",
      titleEyebrow: "Размещение в инкубацию",
      title: "Разместить партию в инкубационные машины",
      tooManyEggs: "Выбранных яиц больше свободной вместимости машины",
      wasted: "Останется свободная вместимость машины",
    },
    hatchingAllocator: {
      capacityLeft: "Свободно в выводном инкубаторе: {count}",
      confirmMessage:
        "{eggs} яиц из {setting} будут перенесены в {machine}. Продолжить?",
      confirmTitle: "Подтвердите перенос на вывод",
      createFailed: "Не удалось создать вывод",
      created: "Яйца перенесены в выводную машину",
      completeCreated: "Вывод завершен",
      completeFailed: "Не удалось завершить вывод",
      completeConfirmMessage:
        "Результаты вывода {hatching} будут завершены. Продолжить?",
      completeConfirmTitle: "Подтвердите завершение вывода",
      completeInvalid:
        "Итог по каждому стандарту должен совпадать с количеством яиц",
      completeShort: "Завершить",
      completeTitle: "Введите результаты вывода",
      completedRows: "Готовые строки",
      currentHatching: "Процесс вывода",
      distributionHint:
        "Яйца распределяются по свободной вместимости выводных инкубаторов.",
      distributionTitle: "Распределение по выводным инкубаторам",
      fillFirstGrade: "Остаток в 1 сорт",
      hatcherBrokenDefaultReason:
        "Причина переноса: выводной инкубатор неисправен",
      hatcherTransferConfirmMessage:
        "{hatching} будет перенесен из {source} в {target}. Отметить этот инкубатор неисправным: {broken}. Продолжить?",
      hatcherTransferConfirmTitle:
        "Подтвердите перенос в другой выводной инкубатор",
      hatcherTransferTitle: "Перенести в другой выводной инкубатор",
      hatchingEggs: "Яиц на вывод",
      invalidTransfer: "Проверьте количество яиц или потери переноса",
      invalidDistribution:
        "Яйца по каждому стандарту должны быть распределены полностью",
      machine: "Выводной инкубатор",
      markHatcherBroken: "Отметить этот выводной инкубатор неисправным",
      markHatcherBrokenHint: "После переноса машина станет неактивной",
      noAvailableMachines: "Нет свободных выводных инкубаторов",
      noSettings: "Нет инкубаций для переноса на вывод",
      notEnoughCapacity:
        "Недостаточно свободной вместимости: {capacity} мест для {eggs} яиц",
      lossesHint: "Введите потери, обнаруженные при выходе из setter.",
      lossesTitle: "Потери",
      receiptPercent: "При приёме %",
      loadModalTitle: "Разместить яйца в выводные инкубаторы",
      parkHint:
        "Статус свободных, загруженных и неисправных выводных инкубаторов.",
      parkTitle: "Выводные инкубаторы",
      review: "План переноса",
      searchSetting: "Поиск инкубации или партии...",
      selectSetting: "Выберите инкубацию",
      selectSettingFirst: "Сначала выберите инкубацию",
      selectSettingFirstHint:
        "Выберите инкубацию в поле выше, и распределение яиц появится здесь автоматически.",
      selectTargetHatcher: "Выберите свободный выводной инкубатор для переноса",
      serviceNeeded: "Нужен сервис",
      setting: "Инкубация",
      submit: "Перенести на вывод",
      targetHatcherUnavailable: "Этот выводной инкубатор не свободен",
      targetOverflow: "Превышена вместимость выбранного выводного инкубатора",
      transferCreated: "Вывод перенесен в другой выводной инкубатор",
      transferEggs: "Яиц перенести",
      transferFailed: "Не удалось перенести в другой выводной инкубатор",
      standard: "Стандарт #{id}",
      unfertilizedCount: "Неоплодотворенные",
      earlyDeadEmbryoCount: "Тумак",
      rottenCount: "Гнилые",
    },
    dailyLogs: {
      add: "Добавить",
      avgHumidity: "Сред. влажность",
      avgTemperature: "Сред. температура",
      created: "Лог добавлен",
      date: "Дата",
      deleted: "Лог удален",
      deleteConfirmMessage:
        "Ежедневный лог за {date} {time} будет удален. Продолжить?",
      deleteConfirmTitle: "Удалить лог",
      deleteFailed: "Не удалось удалить лог",
      eyebrow: "Ежедневный контроль",
      hatchingTitle: "Ежедневные логи вывода",
      humidity: "Влажность",
      latest: "Последний лог",
      loadFailed: "Не удалось загрузить логи",
      noLogs: "Для этого процесса пока нет логов",
      noProcesses: "Нет процессов для контроля",
      process: "Процесс",
      range: "Диапазон температуры",
      saveFailed: "Не удалось сохранить лог",
      search: "Поиск процесса или партии...",
      selected: "Выбранный процесс",
      selectProcessFirst: "Сначала выберите процесс",
      settingTitle: "Ежедневные логи инкубации",
      temperature: "Температура",
      time: "Время",
      update: "Сохранить",
      updated: "Лог обновлен",
    },
    auth: {
      brandLabel: "Inter Agro",
      footer: "Панель управления фабрикой",
      invalidCredentials: "Неверный логин или пароль",
      password: "Пароль",
      passwordPlaceholder: "Введите пароль",
      passwordRequired: "Введите пароль",
      showPassword: "Показать пароль",
      hidePassword: "Скрыть пароль",
      signIn: "Войти",
      username: "Логин",
      usernamePlaceholder: "Введите логин",
      usernameRequired: "Введите логин",
      welcomeTitle: "Добро пожаловать",
      errors: {
        generic: "Произошла ошибка при входе. Попробуйте снова.",
        network: "Не удалось подключиться к серверу. Проверьте соединение.",
      },
      changePassword: {
        title: "Смена пароля",
        subtitle: "Установите новый пароль, чтобы продолжить.",
        forcedNotice:
          "Для вашей учётной записи задан временный пароль. Смените его, чтобы продолжить.",
        currentPassword: "Текущий пароль",
        currentPlaceholder: "Введите текущий пароль",
        currentRequired: "Введите текущий пароль",
        newPassword: "Новый пароль",
        newPlaceholder: "Введите новый пароль",
        newRequired: "Введите новый пароль",
        confirmPassword: "Подтвердите новый пароль",
        confirmPlaceholder: "Повторите новый пароль",
        submit: "Обновить пароль",
        success: "Пароль успешно изменён",
        mismatch: "Пароли не совпадают",
        tooShort: "Пароль должен содержать не менее 8 символов",
        signOut: "Выйти",
      },
    },
    admin: {
      users: {
        title: "Пользователи",
        count: "{count} пользователей",
        search: "Поиск пользователей...",
        empty: "Пользователи не найдены",
        createTitle: "Новый пользователь",
        editTitle: "Редактировать пользователя",
        noRoles: "Роли недоступны",
        markerOnlyWarning: "Эта роль сама по себе не даёт никаких прав — пользователь не сможет открыть ни одну страницу. Добавьте хотя бы ещё одну роль.",
        passwordHint: "Не менее 8 символов. Задаётся как временный пароль.",
        resetPasswordHint: "Оставьте пустым, чтобы не менять",
        errors: {
          phoneInvalid: "Неверный номер телефона. Формат: +998 XX XXX XX XX",
        },
        deleteTitle: "Удалить пользователя",
        deleteMessage: "Удалить {name}? Это действие нельзя отменить.",
        blockTitle: "Заблокировать пользователя",
        blockMessage: "Заблокировать {name}? Все его сессии будут аннулированы.",
        unblockTitle: "Разблокировать",
        unblockMessage: "Разблокировать {name}?",
        status: {
          active: "Активен",
          blocked: "Заблокирован",
        },
        actions: {
          create: "Добавить пользователя",
          edit: "Редактировать",
          delete: "Удалить",
          block: "Заблокировать",
          unblock: "Разблокировать",
          permissions: "Права",
        },
        fields: {
          user: "Пользователь",
          fullName: "Полное имя",
          username: "Логин",
          phone: "Телефон",
          password: "Пароль",
          resetPassword: "Сбросить пароль",
          roles: "Роли",
          status: "Статус",
          lastLogin: "Последний вход",
        },
        permissions: {
          title: "Права",
          search: "Поиск прав...",
          overrides: "Переопределений: {count}",
          empty: "Ничего не найдено",
          inherit: "Наследие",
          allow: "Разрешить",
          deny: "Запретить",
          on: "Да",
          off: "Нет",
          direct: "Напрямую",
          superAdminNote: "Права супер-администратора управляются автоматически и не могут быть переопределены.",
        },
        detail: {
          subtitle: "Профиль, доступ и статус учётной записи",
          back: "К пользователям",
          notFoundTitle: "Пользователь не найден",
          notFoundDescription: "Этот пользователь мог быть удалён, либо ссылка неверна.",
          tabs: {
            information: "Данные пользователя",
            roles: "Роли",
            permissions: "Права",
          },
          aside: {
            memberSince: "Дата регистрации",
            roles: "Роли",
            permissions: "Права",
            effective: "{count} действующих",
            noRoles: "Ролей нет",
            disableAccount: "Отключить учётную запись",
            enableAccount: "Включить учётную запись",
          },
          information: {
            usernameHint: "Используется для входа — можно изменить, если пользователь предпочитает другой.",
            resetPasswordTitle: "Сброс пароля",
            resetPasswordNote: "Администратор задаёт новый пароль пользователю.",
            setNewPassword: "Задать новый пароль",
            newPasswordPlaceholder: "Новый пароль",
            statusLabel: "Статус",
            statusNote: "Активные учётные записи могут входить в систему.",
            save: "Сохранить изменения",
          },
          roles: {
            description: "Роль объединяет права. Назначайте или снимайте роли для {name}.",
            assigned: "Назначенные роли",
            available: "Доступные роли",
            grant: "Назначить",
            revoke: "Снять",
            revokeTitle: "Снять роль",
            revokeMessage: "Снять роль {role} с пользователя {name}?",
            operationCount: "{count} операций",
            empty: "Роли ещё не назначены.",
            allAssigned: "Все роли назначены.",
            banner: "Роли выдают права наборами. Точную настройку отдельных операций для этого пользователя выполняйте во вкладке «Права».",
          },
          permissions: {
            searchSections: "Поиск разделов",
            banner: "Операции берутся из ролей пользователя {name}; здесь можно добавить дополнительные или убрать выданные ролью — изменения касаются только этого пользователя.",
            save: "Сохранить изменения",
            empty: "Ничего не найдено",
          },
        },
      },
      roles: {
        title: "Роли",
        count: "{count} ролей",
        search: "Поиск ролей...",
        empty: "Роли не найдены",
        createTitle: "Новая роль",
        editTitle: "Редактировать роль",
        codeHint: "напр. sales_manager",
        operationCount: "{count} прав",
        systemBadge: "Системная роль",
        systemNames: {
          super_admin: "Супер-администратор",
          configuration_manager: "Менеджер настроек",
          access_manager: "Менеджер доступа",
        },
        deleteTitle: "Удалить роль",
        deleteMessage: "Удалить роль {name}? Она будет немедленно снята со всех носителей.",
        actions: {
          create: "Добавить роль",
          edit: "Редактировать",
          delete: "Удалить",
          permissions: "Права",
        },
        fields: {
          role: "Роль",
          name: "Название",
          code: "Код",
          description: "Описание",
          operations: "Права",
        },
        operations: {
          title: "Права роли",
          searchSections: "Поиск разделов",
          banner: "Включённые здесь операции действуют для всех пользователей с ролью {name}.",
          save: "Сохранить изменения",
          selectAll: "Выбрать все",
          clearAll: "Очистить",
          systemNote: "Системная роль — её права нельзя изменить.",
          empty: "Ничего не найдено",
        },
        detail: {
          subtitle: "Настройка прав роли",
          back: "К ролям",
          notFoundTitle: "Роль не найдена",
          notFoundDescription: "Эта роль могла быть удалена, либо ссылка неверна.",
          loadFailedTitle: "Не удалось загрузить данные",
          loadFailedDescription: "При получении роли произошла ошибка. Попробуйте ещё раз.",
          retry: "Повторить",
        },
      },
    },
    noAccess: {
      title: "Нет доступа",
      message: "У вас нет доступа ни к одному разделу. Обратитесь к администратору.",
    },
    account: {
      title: "Мой профиль",
      personalInfo: "Личная информация",
      readOnlyNote: "Ваши данные управляются администратором.",
      changePassword: "Смена пароля",
      yourRoles: "Ваши роли",
      noRoles: "Роли не назначены",
      permissionCount: "{count} прав",
      managedByAdmin: "Роли и права управляются вашим администратором.",
      signOut: "Выйти",
      avatar: {
        change: "Изменить фото",
        upload: "Загрузить фото",
        remove: "Удалить",
        hint: "PNG или JPG, до 10 МБ.",
        tooLarge: "Размер изображения не должен превышать 10 МБ.",
        invalidType: "Допускаются только файлы изображений.",
        uploadFailed: "Не удалось загрузить изображение. Пожалуйста, попробуйте еще раз.",
      },
      fields: {
        fullName: "Полное имя",
        username: "Логин",
        phone: "Телефон",
        memberSince: "Дата регистрации",
        lastLogin: "Последний вход",
      },
    },
    dashboard: {
      eyebrow: "Панель управления фабрикой",
      periodLabel: "Выбор периода",
      filters: {
        dateRange: "Период",
        invalidRange: "Дата начала не может быть позже даты окончания.",
      },
      legend: {
        now: "состояние сейчас",
        notSettled: "еще не завершено",
      },
      now: {
        eyebrow: "СЕЙЧАС",
        scopeNote: "Текущее состояние филиала — не зависит от выбранного периода.",
        updatedAt: "обновлено в {time}",
        refresh: "Обновить",
        never: "еще не загружено",
      },
      period: {
        eyebrow: "ПЕРИОД",
        scopeNote: "Разделы ниже — за {range}.",
        emptyHint: "За этот период партии не поступали. Попробуйте расширить диапазон.",
        receivedHelper: "принято за период",
      },
      metrics: {
        batchCount: "Партии",
        eggsInSetting: "В инкубации",
        eggsInHatching: "В выводе",
        inProduction: "еще в производстве",
      },
      floor: {
        title: "Загрузка машин",
        type: {
          SETTER: "Инкубатор",
          HATCHER: "Выводной шкаф",
        },
        free: "свободно",
        loaded: "загружено",
        broken: "неисправно",
        capacityNote: "В емкость входят и неисправные машины, поэтому свободного места может быть меньше.",
        noMachines: "Машин этого типа нет",
        noneRegistered: "В этом филиале инкубаторы не зарегистрированы",
        machineCount: "{count} машин",
        eggsOfCapacity: "{loaded} / {capacity} яиц",
      },
      attention: {
        title: "Требует внимания",
        brokenMachines: "Неисправные машины",
        readyToTransfer: "Готовы к переводу",
        readyToComplete: "Готовы к завершению",
        unsortedBatches: "Неотсортированные партии",
        goSorting: "Перейти к сортировке",
        goHatching: "Перейти к выводу",
        more: "еще {count}",
        groupClear: "Пусто",
        allClear: "Сейчас ничего не требует внимания",
      },
      journey: {
        title: "Путь яйца",
        subtitle: "Где сейчас яйца, принятые за этот период.",
        stage: {
          RECEIVED: "Принято",
          AFTER_SORTING: "После сортировки",
          SET: "Заложено в инкубатор",
          MOVED_TO_HATCHER: "Переведено в выводной шкаф",
          CHICKS: "Цыплята",
        },
        lost: "потеряно",
        gap: {
          sorting: "еще не отсортировано",
          loading: "еще не заложено",
          transfer: "еще не переведено",
          hatch: "еще не выведено",
        },
        unattributed: "разница не распределена",
        settled: "Период закрыт — все партии выведены",
        open: "{count} яиц еще в производстве",
        lossLink: "Полный реестр учтенных потерь ниже",
        emptyTitle: "За этот период партий не поступало",
        emptyDescription: "Расширьте период или выберите другой филиал.",
        noEggs: "В партиях за этот период нет яиц",
        stageCount: "{count} этапов",
        scaleNote: "Ширина каждой строки — относительно принятых яиц",
        legend: {
          stage: "на этапе",
          inFlight: "ещё в процессе",
        },
      },
      lossSteps: {
        title: "Реестр потерь",
        subtitle: "Учтенные потери по причинам.",
        step: {
          BROKEN: "Бой",
          DEFECTED: "Брак",
          UNFERTILIZED: "Неоплодотворенное",
          EARLY_DEAD_EMBRYO: "Ранняя гибель эмбриона",
          UNHATCHED: "Не выведено",
        },
        stage: {
          ARRIVAL: "Приемка",
          INCUBATION: "Инкубация",
          HATCHING: "Вывод",
        },
        total: "Всего потерь",
        none: "За этот период потерь не зафиксировано",
        reasonCount: "{count} причин",
        opacityNote: "Насыщенность цвета обозначает этап",
      },
      suppliers: {
        title: "Поставщики",
        subtitle: "Каждый поставщик сравнивается со своим каталожным прогнозом.",
        name: "Поставщик",
        batches: "{count} партии",
        eggs: "Яйца",
        expected: "Ожидаемо %",
        actual: "Факт %",
        variance: "Отклонение",
        lossRate: "Потери %",
        pointsSuffix: "%",
        pointsAbove: "На {value} процента выше ожидаемого",
        pointsBelow: "На {value} процента ниже ожидаемого",
        pointsEqual: "Точно как ожидалось",
        stillInProduction: "партии еще не выведены",
        empty: "За этот период поставок не было",
        sortNote: "отсортировано от худшего",
      },
      chicks: {
        title: "Результаты цыплят",
        cardSubtitle: "По сортам",
        firstGrade: "1 сорт",
        secondGrade: "2 сорт",
        thirdGrade: "3 сорт",
        gradeCount: "{count} сорта",
        total: "Всего",
        unit: "цыплят",
        empty: "Нет результатов по цыплятам за период",
      },
      standardEfficiency: {
        eyebrow: "Эффективность по стандартам",
        title: "Ожидаемая и фактическая выводимость",
        subtitle: "Прогноз и результат сравниваются по каждому стандарту яиц.",
        expected: "Ожидаемо",
        actual: "Факт",
        empty: "За этот период данных по выводимости стандартов нет",
        aboveExpected: "На {value} п. выше плана",
        belowExpected: "На {value} п. ниже плана",
        onExpected: "На уровне плана",
        countBadge: "{count} пород",
      },
      batches: {
        title: "Эффективность партий",
        eyebrow: "Последние партии",
        subtitle: "Все партии, принятые за период, от самых ранних.",
        emptyTitle: "Результатов по партиям пока нет",
        name: "Партия",
        receivedDate: "Дата приёма",
        tableNote: "Все партии, принятые за период, от самых ранних.",
      },
      table: {
        totalEggs: "Всего",
        chicks: "Цыплята",
        lossRate: "Потери",
        remaining: "Остаток",
        hatchability: "Выводимость",
      },
      state: {
        loadFailed: "Не удалось загрузить этот раздел",
      },
      finance: {
        title: "Выручка и расходы",
      },
      title: "Управление инкубацией",
      tagline: "Текущее состояние фабрики и результаты за выбранный период",
      kpi: {
        eggsReceived: "Принято яиц",
        eggUnit: "шт",
        chicks: "Цыплята",
        chickUnit: "шт выведено",
        hatchRate: "Процент вывода",
        hatchRateHelper: "от принятых яиц",
        loss: "Потери",
        lossHelper: "{count} шт учтено",
        inFlight: "Ещё в процессе",
        inFlightHelper: "шт ожидают результата",
      },
      cards: {
        live: "Онлайн",
        liveNow: "Онлайн · сейчас",
        periodHelper: "за выбранный период",
        liveHelper: "текущее состояние · не по дате",
        kpi: {
          batchesReceived: "Принятых партий",
          totalEggs: "Всего яиц",
          eggsInIncubation: "Яиц в инкубации",
          eggsInHatchers: "Яиц в выводе",
        },
        attention: {
          headline: "{count} требуют внимания",
          brokenCount: "{count} неисправны",
          batchCount: "{count} партий",
          view: "Смотреть",
          resolve: "Решить",
          expand: "Развернуть список",
          collapse: "Свернуть список",
          tag: {
            broken: "Неисправная машина",
            unsorted: "Не отсортирована",
            transfer: "Перевод",
            complete: "Завершение",
          },
          detail: {
            unsorted: "Ещё не отсортирована",
            transfer: "Готова к переводу в вывод",
            complete: "Готова к завершению",
          },
        },
        funnel: {
          title: "Воронка",
          dropped: "убыло {count}",
          summaryOpen: "Пока {percent} цыплят · {count} ещё в процессе",
          summarySettled: "Период закрыт — {percent} принятых яиц стали цыплятами",
          summaryPlain: "{percent} принятых яиц стали цыплятами",
        },
        losses: {
          title: "Потери",
          total: "Всего потерь",
          topStage: "{share} потерь на этапе «{stage}»",
          eggShare: "{value} от принятых яиц",
        },
        chicks: {
          hatched: "цыплят выведено",
          expected: "Ожидалось",
          actual: "Фактически",
          hatchRate: "Процент вывода",
        },
        machines: {
          title: "Машины",
          setters: "Инкубаторы",
          hatchers: "Выводные шкафы",
          unitCount: "{count} шт",
          free: "Свободно {count}",
          loaded: "Загружено {count}",
          broken: "Неисправно {count}",
          capacityLine: "Ёмкость {capacity} · Загружено {loaded}",
          occupancy: "Занятость",
        },
        standards: {
          title: "Эффективность по стандарту",
          subtitle: "Ожидаемый и фактический вывод",
          rowMeta: "{eggs} яиц · {chicks} цыплят",
          variance: "Разница {value}",
        },
        suppliers: {
          title: "Эффективность поставщиков",
          subtitle: "Худшая разница первой",
          batchesShort: "Партий",
        },
      },
    },
    batchGrades: {
      action: "Изменить",
      title: "Исправить число выведенных цыплят",
      subtitle: "Цыплята 1, 2 и 3 сорта по каждому стандарту яиц. Невыведенные — остаток от яиц на выводе.",
      standard: "Стандарт",
      hatchedOut: "Яиц на выводе",
      total: "Итого",
      notHatchedOut: "Вывод ещё не завершён",
      hint: "Итого 1 сорта — число выведенных цыплят, против которого продаёт отдел продаж.",
    },
    eggBatches: {
      accepted: "Принято",
      active: "Активные",
      addRow: "Добавить строку",
      allocationResults: "Распределение и результаты",
      all: "Все",
      averageLoss: "Сред. потери",
      back: "Назад",
      batch: "Партия",
      batchName: "Название партии",
      batchNamePlaceholder: "Например: Партия-2026-012",
      batchNameRequired: "Введите название партии.",
      age: "Возраст",
      category: "Категория",
      categoryAge: "Категория / возраст",
      completed: "Завершено",
      date: "Дата",
      delete: "Удалить",
      deleteBatchDescription:
        'Партия "{name}" будет удалена. Это действие нельзя отменить.',
      deleteBatchTitle: "Удалить партию",
      distribution: "Распределение яиц",
      edit: "Редактировать",
      editBatch: "Редактировать партию",
      gradesAfterHatchOut: "Сорта вносятся после завершения вывода",
      eggCount: "Кол-во яиц",
      eggCountRequired: "Введите количество яиц",
      eggUnit: "яиц",
      emptyData: "Нет данных",
      actualEggs: "Факт",
      availableEggs: "Доступно",
      orderedEggs: "Заказано",
      expectedChicks: "Ожидаемые цыплята",
      expectedEggs: "Ожидается",
      expectedHatchDate: "Ожидаемый вывод",
      filter: "Статус",
      forecastChicks: "Прогноз цыплят",
      flowEmptyLane: "На этом этапе процессов нет",
      flowHatchingTitle: "Вывод",
      flowHatchingSubtitle: "Финальный этап в выводных инкубаторах",
      flowRecords: "записей",
      flowSettingTitle: "Инкубация",
      flowSettingSubtitle: "Основной процесс в сеттерах",
      flowSettingEmptyTitle: "Инкубация еще не началась",
      flowSettingEmptyDescription:
        "Когда партия будет загружена в сеттер, здесь появятся процесс, машина и распределение яиц.",
      flowHatchingEmptyTitle: "Вывод еще не начался",
      flowHatchingEmptyBeforeSetting:
        "Сначала загрузите партию в инкубацию, после этого откроется этап вывода.",
      flowHatchingEmptyAfterSetting:
        "После завершения инкубации яйца переносятся в выводной инкубатор, и процесс вывода появится здесь.",
      flowMetricSettingEggs: "Яиц в инкубации",
      flowMetricHatchingEggs: "Яиц на выводе",
      flowMetricProcessCount: "{count} записей процесса",
      flowMetricForecastHelper: "по нормативу",
      flowProgressReady: "Готово к запуску",
      flowProgressDay: "{current}/{total} день",
      flowProgressMovedToHatching: "Перенесено на вывод",
      flowProgressMovedToSetter: "Перенесено в другой сеттер",
      flowProgressMovedToHatcher: "Перенесено в другой выводной инкубатор",
      flowProgressCompleted: "Завершено",
      flowTitle: "Поток процесса",
      formNeedsAttention: "Есть незаполненные поля",
      formNotFound: "Партия не найдена",
      formNotFoundDescription:
        "Выбранная партия не существует или была удалена.",
      formReady: "Готово к сохранению",
      free: "свободно",
      fullyReserved: "Полностью занято",
      gradesExceedHatchedOut: "Сорта 1–3 вместе не больше выведенных яиц ({count})",
      hatchingStage: "Вывод",
      hatchability: "Выводимость",
      hatchingEnteredEggs: "Вошло на вывод",
      incubationEggs: "Войдет в инкубацию",
      incubationStatus: "В инкубации",
      lossAccounting: "Учет потерь",
      lossDetails: "Потери",
      newBatch: "Приёмка партии",
      due: {
        title: "Принять сегодня",
        today: "Прибывает сегодня",
        late: "Опоздание: {count} дн.",
        badge: "Опоздание: {overdue} · Сегодня: {today}",
        receive: "Принять",
      },
      deliveries: {
        searchPlaceholder: "Поиск по партии или поставщику",
        allMonths: "Все месяцы",
        columns: {
          delivery: "Партия",
          supplier: "Поставщик",
          arrivalDate: "Дата прибытия",
          eggs: "Яйца",
          status: "Статус",
        },
        pending: "Ожидается",
        emptyTitle: "Поставок не запланировано",
        emptyDescription:
          "Для этого филиала ничего не запланировано. Партии принимаются из плана отдела продаж.",
        emptyFilteredTitle: "Партия не найдена",
        emptyFiltered: "Выберите другой месяц или измените поиск.",
        missingTitle: "План не найден",
        missingDescription:
          "Партия принимается только из плана отдела продаж. Этот план относится к другому филиалу или удалён.",
        receivedTitle: "Партия уже принята",
        receivedDescription:
          "Инкубация приняла эту поставку — принять её второй раз нельзя. Данные смотрите на странице партии.",
      },
      plan: {
        title: "План отдела продаж",
        arrival: "Дата прибытия",
        eggs: "Яиц по плану",
        chicks: "Цыплят по плану",
        difference: "Отклонение от плана",
        matches: "Совпадает с планом",
        more: "На {count} больше плана",
        less: "На {count} меньше плана",
        rowHint: "{category} · план {count}",
      },
      netEggs: "Чистый остаток",
      normativeStandard: "Норматив",
      normativeStandardRequired: "Выберите норматив",
      outputPercent: "Выход %",
      standardPercent: "Норматив %",
      specialistPercent: "Специалист %",
      hatchPercentRequired: "Введите процент (0–100)",
      processData: "Данные процесса",
      receivingDetails: "Данные приемки",
      receivingTemperature: "Температура приемки",
      receivingInfo: "Данные приемки",
      remaining: "остаток",
      reserved: "занято",
      salesCapacity: "Продажная емкость",
      salesProcess: "Процесс продаж",
      save: "Сохранить",
      saving: "Сохранение...",
      search: "Поиск по партии или поставщику...",
      sold: "Продано",
      standards: "Стандарты",
      supplier: "Поставщик",
      supplierPlaceholder: "Например: Agromir LLC",
      supplierRequired: "Выберите поставщика.",
      temperature: "Температура",
      temperatureInfo: "Данные температуры",
      total: "всего",
      totalEggs: "Всего яиц",
      totalExpectedChicks: "Всего ожидаемых цыплят",
      totalLoss: "Всего потерь",
      transport: "Транспортные данные",
      vehiclePlate: "Номер машины",
      vehiclePlatePlaceholder: "01 A 777 AA",
      vehiclePlateRequired: "Введите номер машины.",
      vehiclePlateIncomplete: "Введите номер полностью: 01 A 777 AA или 01 777 AAA.",
      driver: "Водитель",
      driverPlaceholder: "Ф.И.О. водителя",
      driverRequired: "Введите Ф.И.О. водителя.",
      brokenCount: "Разбитые",
      defectedCount: "Брак",
      roadLoss: "Потери в дороге",
      unloadingLoss: "Потери при разгрузке",
      sortingRejected: "Брак",
      sortingLoss: "Потери сортировки",
      outsideTemperature: "Температура снаружи",
      vehicleTemperature: "Температура машины",
      eggTemperature: "Температура яиц",
      roomTemperature: "Температура помещения",
      warehouseTemperature: "Температура склада",
      temperatureRequired: "Введите температуру.",
      weekShort: "нед.",
      viewOrders: "Посмотреть заказы",
      ordersPanelTitle: "Заказы партии",
      ordersPanelSubtitle:
        "Заказы, созданные для этой партии, будут отображаться здесь.",
      usedByOrders: "Занято заказами",
      canAcceptOrders: "Принимает заказы",
      closedForOrders: "Закрыто для заказов",
      noOrdersForBatch: "Для этой партии заказов нет",
      validationDistribution:
        "Нужна минимум одна заполненная строка распределения.",
      validationNegativeNumber: "Значения не могут быть отрицательными.",
      validationLossTooHigh: "Потери не могут превышать общее количество яиц.",
      statusReceived: "Принято",
      statusReadyToHatching: "Готово к выводу",
      statusHatching: "На выводе",
      statusReadyToComplete: "Готово к завершению",
      statusCompleted: "Завершено",
    },
    modules: {
      eggBatches: {
        title: "Модуль партий",
        description:
          "Список партий, форма приемки и детали используют поля backend v2.",
      },
      incubations: {
        title: "Модуль инкубации",
        description:
          "Сценарии инкубации и вывода подключены к процессам setting/hatching v2.",
      },
      orders: {
        title: "Модуль заказов",
        description:
          "В следующей итерации соберем pipeline заказов из mockup на реальных компонентах и формах с валидацией.",
      },
      settings: {
        title: "Модуль настроек",
        description:
          "Инкубаторы, емкости и нормативные стандарты будут жить здесь как отдельные settings slices.",
      },
    },
  },
} as const;

const latinToCyrillicPairs: Array<[string | RegExp, string]> = [
  // `yo` + `oʻ` overlap on their shared `o`, so whichever pair is reached first wins and mangles the
  // other. "yo'q" hit `o'`->`ў` and came out "yўq" (Latin y); "Yo'qotish" hit `Yo`->`Ё` and came out
  // "Ё'qotish" (stray apostrophe). Both are the single digraph йў, so they are matched here — ahead
  // of every pair that could claim a letter out of them.
  ["Yoʻ", "Йў"],
  ["Yo‘", "Йў"],
  ["Yo'", "Йў"],
  ["yoʻ", "йў"],
  ["yo‘", "йў"],
  ["yo'", "йў"],
  ["Oʻ", "Ў"],
  ["O‘", "Ў"],
  ["O'", "Ў"],
  ["Gʻ", "Ғ"],
  ["G‘", "Ғ"],
  ["G'", "Ғ"],
  ["Sh", "Ш"],
  ["Ch", "Ч"],
  ["Yo", "Ё"],
  ["Yu", "Ю"],
  ["Ya", "Я"],
  ["YE", "Е"],
  ["Ye", "Е"],
  ["TS", "Ц"],
  ["Ts", "Ц"],
  ["oʻ", "ў"],
  ["o‘", "ў"],
  ["o'", "ў"],
  ["gʻ", "ғ"],
  ["g‘", "ғ"],
  ["g'", "ғ"],
  // Every o'/g' apostrophe is gone by now, so an apostrophe (' or the modifier letter ʼ) left between
  // two letters is the tutuq belgisi, written ъ: "ma'lumot" -> "маълумот", "e'tibor" -> "эътибор". One
  // next to a non-letter is a quote mark and stays.
  [/(?<=\p{L})['ʼ](?=\p{L})/u, "ъ"],
  ["sh", "ш"],
  ["ch", "ч"],
  ["yo", "ё"],
  ["yu", "ю"],
  ["ya", "я"],
  ["ye", "е"],
  ["ts", "ц"],
  ["A", "А"],
  ["B", "Б"],
  ["D", "Д"],
  // A single e/E is э/Э at the start of a word (start of the text, or after a non-letter such as a
  // space, dash, quote, bracket or «) and е/Е anywhere else: "Barcha eslatmalar" -> "Барча эслатмалар",
  // and an E inside an all-caps word stays Е. The pairs above have already made part of the word
  // Cyrillic (Ye/ye are taken, o'/g' became ў/ғ), so `\p{L}` has to count letters of both scripts.
  [/(?<!\p{L})E/u, "Э"],
  ["E", "Е"],
  ["F", "Ф"],
  ["G", "Г"],
  ["H", "Ҳ"],
  ["I", "И"],
  ["J", "Ж"],
  ["K", "К"],
  ["L", "Л"],
  ["M", "М"],
  ["N", "Н"],
  ["O", "О"],
  ["P", "П"],
  ["Q", "Қ"],
  ["R", "Р"],
  ["S", "С"],
  ["T", "Т"],
  ["U", "У"],
  ["V", "В"],
  ["X", "Х"],
  ["Y", "Й"],
  ["Z", "З"],
  ["a", "а"],
  ["b", "б"],
  ["d", "д"],
  [/(?<!\p{L})e/u, "э"],
  ["e", "е"],
  ["f", "ф"],
  ["g", "г"],
  ["h", "ҳ"],
  ["i", "и"],
  ["j", "ж"],
  ["k", "к"],
  ["l", "л"],
  ["m", "м"],
  ["n", "н"],
  ["o", "о"],
  ["p", "п"],
  ["q", "қ"],
  ["r", "р"],
  ["s", "с"],
  ["t", "т"],
  ["u", "у"],
  ["v", "в"],
  ["x", "х"],
  ["y", "й"],
  ["z", "з"],
]

const transliterateText = (value: string) =>
  latinToCyrillicPairs.reduce((result, [latin, cyrillic]) => result.split(latin).join(cyrillic), value)

const transliterateUzbekCyrillic = (value: string) =>
  value
    .split(/(\{[^}]*})/g)
    .map((part) => (part.startsWith("{") && part.endsWith("}") ? part : transliterateText(part)))
    .join("")

const transliterateMessageTree = (value: unknown): unknown => {
  if (typeof value === "string") return transliterateUzbekCyrillic(value)
  if (Array.isArray(value)) return value.map(transliterateMessageTree)

  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).map(([key, child]) => [key, transliterateMessageTree(child)]))
  }

  return value
}

;(messages as unknown as Record<string, unknown>)["uz-Cyrl"] = transliterateMessageTree(messages.uz)

export type Locale = keyof typeof messages | "uz-Cyrl";

export const i18nMessages = messages as unknown as Record<Locale, typeof messages.uz | typeof messages.en | typeof messages.ru>;

export const defaultLocale: Locale = "uz";
export const supportedLocales: Locale[] = ["uz", "uz-Cyrl", "en", "ru"];
